unit dashboard.loads;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, XData.Web.Client,
  Data.DB, WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset, VCL.TMSFNCTypes,
  VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes,
  VCL.TMSFNCCustomComponent, VCL.TMSFNCChart, VCL.TMSFNCChartDatabaseAdapter,
  Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.DBCtrls, VCL.TMSFNCButton;

type
  TfrmDashboardLoads = class(TForm)
    wpTop: TPanel;
    wcCompany: TXDataWebClient;
    wdsCompany: TXDataWebDataSet;
    dsCompany: TDataSource;
    wdsCompanyLoadsC: TIntegerField;
    wdsCompanyLoadsR: TFloatField;
    wdsCompanyLoadsIC: TIntegerField;
    wdsCompanyLoadsIR: TFloatField;
    wdsCompanyLoadsINRC: TIntegerField;
    wdsCompanyLoadsINRR: TFloatField;
    wdsCompanyLoadsNIC: TIntegerField;
    wdsCompanyLoadsNIR: TFloatField;
    wdsCompanyLoadsNRC: TIntegerField;
    wdsCompanyLoadsNRR: TFloatField;
    wdsCompanyLoadsName: TStringField;
    wdsCompanyLoadsIName: TStringField;
    wdsCompanyLoadsINRName: TStringField;
    wdsCompanyLoadsNIName: TStringField;
    wdsCompanyLoadsNRName: TStringField;
    wdsCompanyLoadsPos: TIntegerField;
    wdsCompanyLoadsIPos: TIntegerField;
    wdsCompanyLoadsINRPos: TIntegerField;
    wdsCompanyLoadsNIPos: TIntegerField;
    wdsCompanyLoadsNRPos: TIntegerField;
    wcOwnFleet: TXDataWebClient;
    wdsOwnFleet: TXDataWebDataSet;
    IntegerField1: TIntegerField;
    FloatField1: TFloatField;
    IntegerField2: TIntegerField;
    FloatField2: TFloatField;
    IntegerField3: TIntegerField;
    FloatField3: TFloatField;
    IntegerField4: TIntegerField;
    FloatField4: TFloatField;
    IntegerField5: TIntegerField;
    FloatField5: TFloatField;
    StringField1: TStringField;
    StringField2: TStringField;
    StringField3: TStringField;
    StringField4: TStringField;
    StringField5: TStringField;
    IntegerField6: TIntegerField;
    IntegerField7: TIntegerField;
    IntegerField8: TIntegerField;
    IntegerField9: TIntegerField;
    IntegerField10: TIntegerField;
    dsOwnFleet: TDataSource;
    WebScrollBox1: TScrollBox;
    wpMainCompany: TPanel;
    wpCompanyCount: TPanel;
    cCompanyCount: TTMSFNCChart;
    wpCompanyRevenue: TPanel;
    cCompanyRevenue: TTMSFNCChart;
    wpOwnFleet: TPanel;
    wpOwnFleetInfo: TPanel;
    wpOwnFleetButtons: TPanel;
    wpOwnFleetCount: TPanel;
    cOwnFleetCount: TTMSFNCChart;
    wpOwnFleetRevenue: TPanel;
    cOwnFleetRevenue: TTMSFNCChart;
    wpSubsFleet: TPanel;
    wpSubsFleetInfo: TPanel;
    wpSubsFleetButtons: TPanel;
    wpSubsFleetCount: TPanel;
    cSubsFleetCount: TTMSFNCChart;
    wpSubsFleetRevenue: TPanel;
    cSubsFleetRevenue: TTMSFNCChart;
    wcSubsFleet: TXDataWebClient;
    wdsSubsFleet: TXDataWebDataSet;
    IntegerField11: TIntegerField;
    FloatField6: TFloatField;
    IntegerField12: TIntegerField;
    FloatField7: TFloatField;
    IntegerField13: TIntegerField;
    FloatField8: TFloatField;
    IntegerField14: TIntegerField;
    FloatField9: TFloatField;
    IntegerField15: TIntegerField;
    FloatField10: TFloatField;
    StringField6: TStringField;
    StringField7: TStringField;
    StringField8: TStringField;
    StringField9: TStringField;
    StringField10: TStringField;
    IntegerField16: TIntegerField;
    IntegerField17: TIntegerField;
    IntegerField18: TIntegerField;
    IntegerField19: TIntegerField;
    IntegerField20: TIntegerField;
    dsSubsFleet: TDataSource;
    WebTimer1: TTimer;
    wpDate: TPanel;
    btnPrevMonth: TTMSFNCButton;
    btnNextMonth: TTMSFNCButton;
    wlMonth: TDBLabel;
    TMSFNCButton1: TTMSFNCButton;
    TMSFNCButton2: TTMSFNCButton;
    TMSFNCButton3: TTMSFNCButton;
    procedure WebFormShow(Sender: TObject);
    procedure wdsCompanyAfterOpen(DataSet: TDataSet);
    procedure WebFormResize(Sender: TObject);
    procedure wdsOwnFleetAfterOpen(DataSet: TDataSet);
    procedure wdsSubsFleetAfterOpen(DataSet: TDataSet);
    procedure WebTimer1Timer(Sender: TObject);
    procedure btnPrevMonthClick(Sender: TObject);
    procedure btnNextMonthClick(Sender: TObject);
    procedure TMSFNCButton1Click(Sender: TObject);
    procedure TMSFNCButton2Click(Sender: TObject);
    procedure TMSFNCButton3Click(Sender: TObject);
  private
    { Private declarations }
    wYear,
    wMonth,
    wDay : Word;
    bCreate : Boolean;
    procedure LoadOwnFleet;
    procedure LoadSubFleet;
    procedure LoadCompanyInfo;
    procedure UpdateDateLabel;
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  frmDashboardLoads: TfrmDashboardLoads;

implementation

{$R *.dfm}

uses
  stfmssystem.connection,
  share.common,
  share.classes,
  dashboard.loads.controller,
  dashboard.loads.notinvoiced;

procedure TfrmDashboardLoads.btnNextMonthClick(Sender: TObject);
begin
  wMonth := wMonth + 1;
  if wMonth > 12 then
    begin
      wMonth := 1;
      wYear := wYear + 1;
    end;
  UpdateDateLabel;
  LoadCompanyInfo;
end;

procedure TfrmDashboardLoads.btnPrevMonthClick(Sender: TObject);
begin
  wMonth := wMonth - 1;
  if wMonth < 1 then
    begin
      wMonth := 12;
      wYear := wYear -1;
    end;
  UpdateDateLabel;
  LoadCompanyInfo;
end;

procedure TfrmDashboardLoads.LoadCompanyInfo;
  procedure OnError(Error: TXDataClientError);
  begin
    LoadCompanyInfo;
  end;
  procedure OnResult(Response : TXDataClientResponse);
  begin
    If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
      begin
        LoadCompanyInfo;
      end
    else
      begin
        wdsCompany.Close;
        wdsCompany.SetJsonData(Response.Result);
        wdsCompany.Open;
      end;
  end;

begin
  wcCompany.RawInvoke('IdashboardService.GetLoadsTotals', [wMonth,wYear,0], @OnResult, @OnError);
end;

procedure TfrmDashboardLoads.LoadOwnFleet;
  procedure OnError(Error: TXDataClientError);
  begin
    LoadOwnFleet;
  end;
  procedure OnResult(Response : TXDataClientResponse);
  begin
    If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
      begin
        LoadOwnFleet;
      end
    else
      begin
        wdsOwnFleet.Close;
        wdsOwnFleet.SetJsonData(Response.Result);
        wdsOwnFleet.Open;
      end;
  end;

begin
  wcOwnFleet.RawInvoke('IdashboardService.GetLoadsTotals', [wMonth,wYear,1], @OnResult, @OnError);
end;

procedure TfrmDashboardLoads.LoadSubFleet;
  procedure OnError(Error: TXDataClientError);
  begin
    LoadSubFleet;
  end;
  procedure OnResult(Response : TXDataClientResponse);
  begin
    If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
      begin
        LoadSubFleet;
      end
    else
      begin
        wdsSubsFleet.Close;
        wdsSubsFleet.SetJsonData(Response.Result);
        wdsSubsFleet.Open;
      end;
  end;

begin
  wcSubsFleet.RawInvoke('IdashboardService.GetLoadsTotals', [wMonth,wYear,2], @OnResult, @OnError);
end;

procedure TfrmDashboardLoads.TMSFNCButton1Click(Sender: TObject);
  var
    jsr: TJSDOMRect;
    LFrm : TfrmDashboardControllers;

  procedure AfterCreate(AForm : TObject);
  begin
    with (AForm as TfrmDashboardControllers) do
      begin
        iCompany := 1;
        iYear := wYear;
        iMonth := wMonth;
        LoadData;

      end;
  end;
begin
  jsr := document.body.getBoundingClientRect;
  LFrm := TfrmDashboardControllers.CreateNew( @AfterCreate );

  // LFrm als Pop-Up festlegen
  LFrm.Popup := true;

  // Transparenz definieren
  LFrm.PopupOpacity := 0.2;
  LFrm.Height := 463;
  LFrm.Width := 1100;
  LFrm.Top := Round((window.innerheight - LFrm.Height) / 2);
  LFrm.Left := Round((jsr.right - jsr.left - LFrm.Width) / 2);
  LFrm.ShowModal;
end;

procedure TfrmDashboardLoads.TMSFNCButton2Click(Sender: TObject);
  var
    jsr: TJSDOMRect;
    LFrm : TfrmDashboardControllers;

  procedure AfterCreate(AForm : TObject);
  begin
    with (AForm as TfrmDashboardControllers) do
      begin
        iCompany := 2;
        iYear := wYear;
        iMonth := wMonth;
        LoadData;

      end;
  end;
begin
  jsr := document.body.getBoundingClientRect;
  LFrm := TfrmDashboardControllers.CreateNew( @AfterCreate );

  // LFrm als Pop-Up festlegen
  LFrm.Popup := true;

  // Transparenz definieren
  LFrm.PopupOpacity := 0.2;
  LFrm.Height := 463;
  LFrm.Width := 1100;
  LFrm.Top := Round((window.innerheight - LFrm.Height) / 2);
  LFrm.Left := Round((jsr.right - jsr.left - LFrm.Width) / 2);
  LFrm.ShowModal;
end;

procedure TfrmDashboardLoads.TMSFNCButton3Click(Sender: TObject);
  var
    jsr: TJSDOMRect;
    LFrm : Tfrmdashboardloadsnotinvoiced;

  procedure AfterCreate(AForm : TObject);
  begin
    with (AForm as Tfrmdashboardloadsnotinvoiced) do
      begin
        iCompany := 1;
        iYear := wYear;
        iMonth := wMonth;
        LoadDataClient;

      end;
  end;
begin
  jsr := document.body.getBoundingClientRect;
  LFrm := Tfrmdashboardloadsnotinvoiced.CreateNew( @AfterCreate );

  // LFrm als Pop-Up festlegen
  LFrm.Popup := true;

  // Transparenz definieren
  LFrm.PopupOpacity := 0.2;
  LFrm.Height := 463;
  LFrm.Width := 1100;
  LFrm.Top := Round((window.innerheight - LFrm.Height) / 2);
  LFrm.Left := Round((jsr.right - jsr.left - LFrm.Width) / 2);
  LFrm.ShowModal;
end;

procedure TfrmDashboardLoads.UpdateDateLabel;
begin
  Case wMonth of
    1 : wlMonth.Caption := 'JANUARY ' + IntToStr(wYear);
    2 : wlMonth.Caption := 'FEBRUARY ' + IntToStr(wYear);
    3 : wlMonth.Caption := 'MARCH ' + IntToStr(wYear);
    4 : wlMonth.Caption := 'APRIL ' + IntToStr(wYear);
    5 : wlMonth.Caption := 'MAY ' + IntToStr(wYear);
    6 : wlMonth.Caption := 'JUNE ' + IntToStr(wYear);
    7 : wlMonth.Caption := 'JULY ' + IntToStr(wYear);
    8 : wlMonth.Caption := 'AUGUST ' + IntToStr(wYear);
    9 : wlMonth.Caption := 'SEPTEMBER ' + IntToStr(wYear);
    10 : wlMonth.Caption := 'OCTOBER ' + IntToStr(wYear);
    11 : wlMonth.Caption := 'NOVEMBER ' + IntToStr(wYear);
    12 : wlMonth.Caption := 'DECEMBER ' + IntToStr(wYear);
  End;
end;

procedure TfrmDashboardLoads.wdsCompanyAfterOpen(DataSet: TDataSet);
begin
  cCompanyCount.BeginUpdate;
  cCompanyCount.Series[0].Points.Clear;
  cCompanyCount.Series[0].AddPoint(wdsCompany.FieldByName('LoadsC').asInteger);
  cCompanyCount.Series[1].Points.Clear;
  cCompanyCount.Series[1].AddPoint(wdsCompany.FieldByName('LoadsIC').asInteger);
  cCompanyCount.Series[2].Points.Clear;
  cCompanyCount.Series[2].AddPoint(wdsCompany.FieldByName('LoadsNIC').asInteger);
  cCompanyCount.Series[3].Points.Clear;
  cCompanyCount.Series[3].AddPoint(wdsCompany.FieldByName('LoadsNRC').asInteger);
  cCompanyCount.EndUpdate;

  cCompanyRevenue.BeginUpdate;
  cCompanyRevenue.Series[0].Points.Clear;
  cCompanyRevenue.Series[0].AddPoint(wdsCompany.FieldByName('LoadsR').asFloat);
  cCompanyRevenue.Series[1].Points.Clear;
  cCompanyRevenue.Series[1].AddPoint(wdsCompany.FieldByName('LoadsIR').asFloat);
  cCompanyRevenue.Series[2].Points.Clear;
  cCompanyRevenue.Series[2].AddPoint(wdsCompany.FieldByName('LoadsNIR').asFloat);
  cCompanyRevenue.Series[3].Points.Clear;
  cCompanyRevenue.Series[3].AddPoint(wdsCompany.FieldByName('LoadsNRR').asFloat);
  cCompanyRevenue.EndUpdate;

  LoadOwnFleet;
end;

procedure TfrmDashboardLoads.wdsOwnFleetAfterOpen(DataSet: TDataSet);
begin
  cOwnFleetCount.BeginUpdate;
  cOwnFleetCount.Series[0].Points.Clear;
  cOwnFleetCount.Series[0].AddPoint(wdsOwnFleet.FieldByName('LoadsC').asInteger);
  cOwnFleetCount.Series[1].Points.Clear;
  cOwnFleetCount.Series[1].AddPoint(wdsOwnFleet.FieldByName('LoadsIC').asInteger);
  cOwnFleetCount.Series[2].Points.Clear;
  cOwnFleetCount.Series[2].AddPoint(wdsOwnFleet.FieldByName('LoadsNIC').asInteger);
  cOwnFleetCount.Series[3].Points.Clear;
  cOwnFleetCount.Series[3].AddPoint(wdsOwnFleet.FieldByName('LoadsNRC').asInteger);
  cOwnFleetCount.EndUpdate;

  cOwnFleetRevenue.BeginUpdate;
  cOwnFleetRevenue.Series[0].Points.Clear;
  cOwnFleetRevenue.Series[0].AddPoint(wdsOwnFleet.FieldByName('LoadsR').asFloat);
  cOwnFleetRevenue.Series[1].Points.Clear;
  cOwnFleetRevenue.Series[1].AddPoint(wdsOwnFleet.FieldByName('LoadsIR').asFloat);
  cOwnFleetRevenue.Series[2].Points.Clear;
  cOwnFleetRevenue.Series[2].AddPoint(wdsOwnFleet.FieldByName('LoadsNIR').asFloat);
  cOwnFleetRevenue.Series[3].Points.Clear;
  cOwnFleetRevenue.Series[3].AddPoint(wdsOwnFleet.FieldByName('LoadsNRR').asFloat);
  cOwnFleetRevenue.EndUpdate;

  LoadSubFleet;
end;

procedure TfrmDashboardLoads.wdsSubsFleetAfterOpen(DataSet: TDataSet);
begin
  cSubsFleetCount.BeginUpdate;
  cSubsFleetCount.Series[0].Points.Clear;
  cSubsFleetCount.Series[0].AddPoint(wdsSubsFleet.FieldByName('LoadsC').asInteger);
  cSubsFleetCount.Series[1].Points.Clear;
  cSubsFleetCount.Series[1].AddPoint(wdsSubsFleet.FieldByName('LoadsIC').asInteger);
  cSubsFleetCount.Series[2].Points.Clear;
  cSubsFleetCount.Series[2].AddPoint(wdsSubsFleet.FieldByName('LoadsNIC').asInteger);
  cSubsFleetCount.Series[3].Points.Clear;
  cSubsFleetCount.Series[3].AddPoint(wdsSubsFleet.FieldByName('LoadsNRC').asInteger);
  cSubsFleetCount.EndUpdate;

  cSubsFleetRevenue.BeginUpdate;
  cSubsFleetRevenue.Series[0].Points.Clear;
  cSubsFleetRevenue.Series[0].AddPoint(wdsSubsFleet.FieldByName('LoadsR').asFloat);
  cSubsFleetRevenue.Series[1].Points.Clear;
  cSubsFleetRevenue.Series[1].AddPoint(wdsSubsFleet.FieldByName('LoadsIR').asFloat);
  cSubsFleetRevenue.Series[2].Points.Clear;
  cSubsFleetRevenue.Series[2].AddPoint(wdsSubsFleet.FieldByName('LoadsNIR').asFloat);
  cSubsFleetRevenue.Series[3].Points.Clear;
  cSubsFleetRevenue.Series[3].AddPoint(wdsSubsFleet.FieldByName('LoadsNRR').asFloat);
  cSubsFleetRevenue.EndUpdate;

  WebTimer1.Enabled := True;
  bCreate := False;
end;

procedure TfrmDashboardLoads.WebFormResize(Sender: TObject);
begin
  wpCompanyCount.Width := Trunc(wpMainCompany.Width / 2);
  wpOwnFleetCount.Width := Trunc(wpOwnFleet.Width / 2);
  wpSubsFleetCount.Width := Trunc(wpSubsFleet.Width / 2);
end;

procedure TfrmDashboardLoads.WebFormShow(Sender: TObject);
begin
  bCreate := True;
  DecodeDate(Now,wYear,wMonth,wDay);
  UpdateDateLabel;
  LoadCompanyInfo;
end;

procedure TfrmDashboardLoads.WebTimer1Timer(Sender: TObject);
begin
  WebTimer1.Enabled := False;
  LoadCompanyInfo;
end;

procedure TfrmDashboardLoads.LoadDFMValues;
begin
  inherited LoadDFMValues;

  wpTop := TPanel.Create(Self);
  WebScrollBox1 := TScrollBox.Create(Self);
  wpMainCompany := TPanel.Create(Self);
  wpCompanyCount := TPanel.Create(Self);
  cCompanyCount := TTMSFNCChart.Create(Self);
  wpCompanyRevenue := TPanel.Create(Self);
  cCompanyRevenue := TTMSFNCChart.Create(Self);
  wpOwnFleet := TPanel.Create(Self);
  wpOwnFleetInfo := TPanel.Create(Self);
  wpOwnFleetButtons := TPanel.Create(Self);
  TMSFNCButton1 := TTMSFNCButton.Create(Self);
  TMSFNCButton3 := TTMSFNCButton.Create(Self);
  wpOwnFleetCount := TPanel.Create(Self);
  cOwnFleetCount := TTMSFNCChart.Create(Self);
  wpOwnFleetRevenue := TPanel.Create(Self);
  cOwnFleetRevenue := TTMSFNCChart.Create(Self);
  wpSubsFleet := TPanel.Create(Self);
  wpSubsFleetInfo := TPanel.Create(Self);
  wpSubsFleetButtons := TPanel.Create(Self);
  TMSFNCButton2 := TTMSFNCButton.Create(Self);
  wpSubsFleetCount := TPanel.Create(Self);
  cSubsFleetCount := TTMSFNCChart.Create(Self);
  wpSubsFleetRevenue := TPanel.Create(Self);
  cSubsFleetRevenue := TTMSFNCChart.Create(Self);
  wpDate := TPanel.Create(Self);
  wlMonth := TDBLabel.Create(Self);
  btnPrevMonth := TTMSFNCButton.Create(Self);
  btnNextMonth := TTMSFNCButton.Create(Self);
  wcCompany := TXDataWebClient.Create(Self);
  wdsCompany := TXDataWebDataSet.Create(Self);
  wdsCompanyLoadsC := TIntegerField.Create(Self);
  wdsCompanyLoadsR := TFloatField.Create(Self);
  wdsCompanyLoadsIC := TIntegerField.Create(Self);
  wdsCompanyLoadsIR := TFloatField.Create(Self);
  wdsCompanyLoadsINRC := TIntegerField.Create(Self);
  wdsCompanyLoadsINRR := TFloatField.Create(Self);
  wdsCompanyLoadsNIC := TIntegerField.Create(Self);
  wdsCompanyLoadsNIR := TFloatField.Create(Self);
  wdsCompanyLoadsNRC := TIntegerField.Create(Self);
  wdsCompanyLoadsNRR := TFloatField.Create(Self);
  wdsCompanyLoadsName := TStringField.Create(Self);
  wdsCompanyLoadsIName := TStringField.Create(Self);
  wdsCompanyLoadsINRName := TStringField.Create(Self);
  wdsCompanyLoadsNIName := TStringField.Create(Self);
  wdsCompanyLoadsNRName := TStringField.Create(Self);
  wdsCompanyLoadsPos := TIntegerField.Create(Self);
  wdsCompanyLoadsIPos := TIntegerField.Create(Self);
  wdsCompanyLoadsINRPos := TIntegerField.Create(Self);
  wdsCompanyLoadsNIPos := TIntegerField.Create(Self);
  wdsCompanyLoadsNRPos := TIntegerField.Create(Self);
  dsCompany := TDataSource.Create(Self);
  wcOwnFleet := TXDataWebClient.Create(Self);
  wdsOwnFleet := TXDataWebDataSet.Create(Self);
  IntegerField1 := TIntegerField.Create(Self);
  FloatField1 := TFloatField.Create(Self);
  IntegerField2 := TIntegerField.Create(Self);
  FloatField2 := TFloatField.Create(Self);
  IntegerField3 := TIntegerField.Create(Self);
  FloatField3 := TFloatField.Create(Self);
  IntegerField4 := TIntegerField.Create(Self);
  FloatField4 := TFloatField.Create(Self);
  IntegerField5 := TIntegerField.Create(Self);
  FloatField5 := TFloatField.Create(Self);
  StringField1 := TStringField.Create(Self);
  StringField2 := TStringField.Create(Self);
  StringField3 := TStringField.Create(Self);
  StringField4 := TStringField.Create(Self);
  StringField5 := TStringField.Create(Self);
  IntegerField6 := TIntegerField.Create(Self);
  IntegerField7 := TIntegerField.Create(Self);
  IntegerField8 := TIntegerField.Create(Self);
  IntegerField9 := TIntegerField.Create(Self);
  IntegerField10 := TIntegerField.Create(Self);
  dsOwnFleet := TDataSource.Create(Self);
  wcSubsFleet := TXDataWebClient.Create(Self);
  wdsSubsFleet := TXDataWebDataSet.Create(Self);
  IntegerField11 := TIntegerField.Create(Self);
  FloatField6 := TFloatField.Create(Self);
  IntegerField12 := TIntegerField.Create(Self);
  FloatField7 := TFloatField.Create(Self);
  IntegerField13 := TIntegerField.Create(Self);
  FloatField8 := TFloatField.Create(Self);
  IntegerField14 := TIntegerField.Create(Self);
  FloatField9 := TFloatField.Create(Self);
  IntegerField15 := TIntegerField.Create(Self);
  FloatField10 := TFloatField.Create(Self);
  StringField6 := TStringField.Create(Self);
  StringField7 := TStringField.Create(Self);
  StringField8 := TStringField.Create(Self);
  StringField9 := TStringField.Create(Self);
  StringField10 := TStringField.Create(Self);
  IntegerField16 := TIntegerField.Create(Self);
  IntegerField17 := TIntegerField.Create(Self);
  IntegerField18 := TIntegerField.Create(Self);
  IntegerField19 := TIntegerField.Create(Self);
  IntegerField20 := TIntegerField.Create(Self);
  dsSubsFleet := TDataSource.Create(Self);
  WebTimer1 := TTimer.Create(Self);

  wpTop.BeforeLoadDFMValues;
  WebScrollBox1.BeforeLoadDFMValues;
  wpMainCompany.BeforeLoadDFMValues;
  wpCompanyCount.BeforeLoadDFMValues;
  cCompanyCount.BeforeLoadDFMValues;
  wpCompanyRevenue.BeforeLoadDFMValues;
  cCompanyRevenue.BeforeLoadDFMValues;
  wpOwnFleet.BeforeLoadDFMValues;
  wpOwnFleetInfo.BeforeLoadDFMValues;
  wpOwnFleetButtons.BeforeLoadDFMValues;
  TMSFNCButton1.BeforeLoadDFMValues;
  TMSFNCButton3.BeforeLoadDFMValues;
  wpOwnFleetCount.BeforeLoadDFMValues;
  cOwnFleetCount.BeforeLoadDFMValues;
  wpOwnFleetRevenue.BeforeLoadDFMValues;
  cOwnFleetRevenue.BeforeLoadDFMValues;
  wpSubsFleet.BeforeLoadDFMValues;
  wpSubsFleetInfo.BeforeLoadDFMValues;
  wpSubsFleetButtons.BeforeLoadDFMValues;
  TMSFNCButton2.BeforeLoadDFMValues;
  wpSubsFleetCount.BeforeLoadDFMValues;
  cSubsFleetCount.BeforeLoadDFMValues;
  wpSubsFleetRevenue.BeforeLoadDFMValues;
  cSubsFleetRevenue.BeforeLoadDFMValues;
  wpDate.BeforeLoadDFMValues;
  wlMonth.BeforeLoadDFMValues;
  btnPrevMonth.BeforeLoadDFMValues;
  btnNextMonth.BeforeLoadDFMValues;
  wcCompany.BeforeLoadDFMValues;
  wdsCompany.BeforeLoadDFMValues;
  wdsCompanyLoadsC.BeforeLoadDFMValues;
  wdsCompanyLoadsR.BeforeLoadDFMValues;
  wdsCompanyLoadsIC.BeforeLoadDFMValues;
  wdsCompanyLoadsIR.BeforeLoadDFMValues;
  wdsCompanyLoadsINRC.BeforeLoadDFMValues;
  wdsCompanyLoadsINRR.BeforeLoadDFMValues;
  wdsCompanyLoadsNIC.BeforeLoadDFMValues;
  wdsCompanyLoadsNIR.BeforeLoadDFMValues;
  wdsCompanyLoadsNRC.BeforeLoadDFMValues;
  wdsCompanyLoadsNRR.BeforeLoadDFMValues;
  wdsCompanyLoadsName.BeforeLoadDFMValues;
  wdsCompanyLoadsIName.BeforeLoadDFMValues;
  wdsCompanyLoadsINRName.BeforeLoadDFMValues;
  wdsCompanyLoadsNIName.BeforeLoadDFMValues;
  wdsCompanyLoadsNRName.BeforeLoadDFMValues;
  wdsCompanyLoadsPos.BeforeLoadDFMValues;
  wdsCompanyLoadsIPos.BeforeLoadDFMValues;
  wdsCompanyLoadsINRPos.BeforeLoadDFMValues;
  wdsCompanyLoadsNIPos.BeforeLoadDFMValues;
  wdsCompanyLoadsNRPos.BeforeLoadDFMValues;
  dsCompany.BeforeLoadDFMValues;
  wcOwnFleet.BeforeLoadDFMValues;
  wdsOwnFleet.BeforeLoadDFMValues;
  IntegerField1.BeforeLoadDFMValues;
  FloatField1.BeforeLoadDFMValues;
  IntegerField2.BeforeLoadDFMValues;
  FloatField2.BeforeLoadDFMValues;
  IntegerField3.BeforeLoadDFMValues;
  FloatField3.BeforeLoadDFMValues;
  IntegerField4.BeforeLoadDFMValues;
  FloatField4.BeforeLoadDFMValues;
  IntegerField5.BeforeLoadDFMValues;
  FloatField5.BeforeLoadDFMValues;
  StringField1.BeforeLoadDFMValues;
  StringField2.BeforeLoadDFMValues;
  StringField3.BeforeLoadDFMValues;
  StringField4.BeforeLoadDFMValues;
  StringField5.BeforeLoadDFMValues;
  IntegerField6.BeforeLoadDFMValues;
  IntegerField7.BeforeLoadDFMValues;
  IntegerField8.BeforeLoadDFMValues;
  IntegerField9.BeforeLoadDFMValues;
  IntegerField10.BeforeLoadDFMValues;
  dsOwnFleet.BeforeLoadDFMValues;
  wcSubsFleet.BeforeLoadDFMValues;
  wdsSubsFleet.BeforeLoadDFMValues;
  IntegerField11.BeforeLoadDFMValues;
  FloatField6.BeforeLoadDFMValues;
  IntegerField12.BeforeLoadDFMValues;
  FloatField7.BeforeLoadDFMValues;
  IntegerField13.BeforeLoadDFMValues;
  FloatField8.BeforeLoadDFMValues;
  IntegerField14.BeforeLoadDFMValues;
  FloatField9.BeforeLoadDFMValues;
  IntegerField15.BeforeLoadDFMValues;
  FloatField10.BeforeLoadDFMValues;
  StringField6.BeforeLoadDFMValues;
  StringField7.BeforeLoadDFMValues;
  StringField8.BeforeLoadDFMValues;
  StringField9.BeforeLoadDFMValues;
  StringField10.BeforeLoadDFMValues;
  IntegerField16.BeforeLoadDFMValues;
  IntegerField17.BeforeLoadDFMValues;
  IntegerField18.BeforeLoadDFMValues;
  IntegerField19.BeforeLoadDFMValues;
  IntegerField20.BeforeLoadDFMValues;
  dsSubsFleet.BeforeLoadDFMValues;
  WebTimer1.BeforeLoadDFMValues;
  try
    Name := 'frmDashboardLoads';
    Width := 1024;
    Height := 1386;
    Align := alClient;
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    wpTop.SetParentComponent(Self);
    wpTop.Name := 'wpTop';
    wpTop.Left := 0;
    wpTop.Top := 0;
    wpTop.Width := 1024;
    wpTop.Height := 41;
    wpTop.Align := alTop;
    wpTop.Caption := 'Loads Dashboard';
    wpTop.Font.Charset := DEFAULT_CHARSET;
    wpTop.Font.Color := clWindowText;
    wpTop.Font.Height := -12;
    wpTop.Font.Name := 'Segoe UI';
    wpTop.Font.Style := [fsBold];
    wpTop.ParentFont := False;
    wpTop.TabOrder := 0;
    WebScrollBox1.SetParentComponent(Self);
    WebScrollBox1.Name := 'WebScrollBox1';
    WebScrollBox1.Left := 0;
    WebScrollBox1.Top := 41;
    WebScrollBox1.Width := 1024;
    WebScrollBox1.Height := 1345;
    WebScrollBox1.Align := alClient;
    WebScrollBox1.BorderStyle := bsSingle;
    WebScrollBox1.ChildOrder := 3;
    wpMainCompany.SetParentComponent(WebScrollBox1);
    wpMainCompany.Name := 'wpMainCompany';
    wpMainCompany.Left := 0;
    wpMainCompany.Top := 54;
    wpMainCompany.Width := 1024;
    wpMainCompany.Height := 351;
    wpMainCompany.Align := alTop;
    wpMainCompany.ChildOrder := 1;
    wpMainCompany.TabOrder := 0;
    wpCompanyCount.SetParentComponent(wpMainCompany);
    wpCompanyCount.Name := 'wpCompanyCount';
    wpCompanyCount.Left := 0;
    wpCompanyCount.Top := 0;
    wpCompanyCount.Width := 512;
    wpCompanyCount.Height := 351;
    wpCompanyCount.Align := alLeft;
    wpCompanyCount.Anchors := [akLeft,akTop,akRight,akBottom];
    wpCompanyCount.Caption := 'wpCompanyCount';
    wpCompanyCount.ChildOrder := 1;
    wpCompanyCount.ShowCaption := False;
    wpCompanyCount.TabOrder := 0;
    cCompanyCount.SetParentComponent(wpCompanyCount);
    cCompanyCount.Name := 'cCompanyCount';
    cCompanyCount.Left := 0;
    cCompanyCount.Top := 0;
    cCompanyCount.Width := 512;
    cCompanyCount.Height := 350;
    cCompanyCount.Appearance.ColorList.Clear;
    with cCompanyCount.Appearance.ColorList.Add do
    begin
      Color := 16105559;
    end;
    with cCompanyCount.Appearance.ColorList.Add do
    begin
      Color := 5644279;
    end;
    with cCompanyCount.Appearance.ColorList.Add do
    begin
      Color := 7936771;
    end;
    with cCompanyCount.Appearance.ColorList.Add do
    begin
      Color := 12275349;
    end;
    with cCompanyCount.Appearance.ColorList.Add do
    begin
      Color := 1296366;
    end;
    with cCompanyCount.Appearance.ColorList.Add do
    begin
      Color := 4350195;
    end;
    with cCompanyCount.Appearance.ColorList.Add do
    begin
      Color := 16544551;
    end;
    with cCompanyCount.Appearance.ColorList.Add do
    begin
      Color := 5820321;
    end;
    with cCompanyCount.Appearance.ColorList.Add do
    begin
      Color := 10922240;
    end;
    with cCompanyCount.Appearance.ColorList.Add do
    begin
      Color := 16376965;
    end;
    cCompanyCount.Appearance.GlobalFont.Color := -1;
    cCompanyCount.Appearance.GlobalFont.Scale := 1.000000000000000000;
    cCompanyCount.Appearance.GlobalFont.Style := [];
    cCompanyCount.Appearance.ColorScheme := ccsColorList;
    cCompanyCount.Appearance.MonochromeColor := clSteelblue;
    cCompanyCount.ClickMargin := 10.000000000000000000;
    cCompanyCount.Legend.Fill.Kind := gfkSolid;
    cCompanyCount.Legend.Stroke.Kind := gskSolid;
    cCompanyCount.Legend.Font.Charset := DEFAULT_CHARSET;
    cCompanyCount.Legend.Font.Color := clWindowText;
    cCompanyCount.Legend.Font.Height := -12;
    cCompanyCount.Legend.Font.Name := 'Segoe UI';
    cCompanyCount.Legend.Font.Style := [];
    cCompanyCount.Legend.Left := -10.000000000000000000;
    cCompanyCount.Legend.Position := lpTopRight;
    cCompanyCount.Legend.Top := 10.000000000000000000;
    cCompanyCount.SeriesMargins.Left := 0;
    cCompanyCount.SeriesMargins.Top := 15;
    cCompanyCount.SeriesMargins.Right := 0;
    cCompanyCount.SeriesMargins.Bottom := 0;
    cCompanyCount.Series.Clear;
    with cCompanyCount.Series.Add do
    begin
      AnimationFactor := 4.000000000000000000;
      AutoXRange := arEnabled;
      AutoYRange := arCommonZeroBased;
      Bar.Width := 65.000000000000000000;
      Bar.Spacing := 20.000000000000000000;
      MultiPoint.Width := 65.000000000000000000;
      Pie.Size := 200.000000000000000000;
      Pie.Margins.Left := 10;
      Pie.Margins.Top := 10;
      Pie.Margins.Right := 10;
      Pie.Margins.Bottom := 10;
      Pie.SweepAngle := 360.000000000000000000;
      ChartType := ctBar;
      Fill.Color := 16105559;
      LegendText := 'Loads';
      Labels.Font.Charset := DEFAULT_CHARSET;
      Labels.Font.Color := clWindowText;
      Labels.Font.Height := -12;
      Labels.Font.Name := 'Segoe UI';
      Labels.Font.Style := [];
      Labels.Format := '%.0f';
      Labels.OffsetY := 5.000000000000000000;
      Labels.Visible := True;
      Markers.Fill.Color := 16105559;
      Markers.Height := 10.000000000000000000;
      Markers.Stroke.Color := 8020012;
      Markers.Width := 10.000000000000000000;
      MaxX := 10.000000000000000000;
      MaxY := 10.000000000000000000;
      Offset3DX := 15.000000000000000000;
      Offset3DY := 15.000000000000000000;
      Legend.Font.Charset := DEFAULT_CHARSET;
      Legend.Font.Color := clWindowText;
      Legend.Font.Height := -12;
      Legend.Font.Name := 'Segoe UI';
      Legend.Font.Style := [];
      Legend.Left := -10.000000000000000000;
      Stroke.Color := 16105559;
      XValues.MajorUnit := 1.000000000000000000;
      XValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MajorUnitFont.Color := clWindowText;
      XValues.MajorUnitFont.Height := -12;
      XValues.MajorUnitFont.Name := 'Segoe UI';
      XValues.MajorUnitFont.Style := [];
      XValues.MajorUnitFormat := '%.0f';
      XValues.MajorUnitSpacing := 5.000000000000000000;
      XValues.MajorUnitTickMarkSize := 10.000000000000000000;
      XValues.MajorUnitTickMarkColor := clSilver;
      XValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MinorUnitFont.Color := clWindowText;
      XValues.MinorUnitFont.Height := -12;
      XValues.MinorUnitFont.Name := 'Segoe UI';
      XValues.MinorUnitFont.Style := [];
      XValues.MinorUnitFormat := '%.0f';
      XValues.MinorUnitSpacing := 5.000000000000000000;
      XValues.MinorUnitTickMarkSize := 7.000000000000000000;
      XValues.MinorUnitTickMarkColor := clSilver;
      XValues.Title.Font.Charset := DEFAULT_CHARSET;
      XValues.Title.Font.Color := clWindowText;
      XValues.Title.Font.Height := -12;
      XValues.Title.Font.Name := 'Segoe UI';
      XValues.Title.Font.Style := [];
      XValues.Title.TextMargins.Left := 0;
      XValues.Title.TextMargins.Top := 0;
      XValues.Title.TextMargins.Right := 0;
      XValues.Title.TextMargins.Bottom := 0;
      YValues.MajorUnit := 1.000000000000000000;
      YValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MajorUnitFont.Color := clWindowText;
      YValues.MajorUnitFont.Height := -12;
      YValues.MajorUnitFont.Name := 'Segoe UI';
      YValues.MajorUnitFont.Style := [];
      YValues.MajorUnitFormat := '%.0f';
      YValues.MajorUnitSpacing := 5.000000000000000000;
      YValues.MajorUnitTickMarkSize := 10.000000000000000000;
      YValues.MajorUnitTickMarkColor := clSilver;
      YValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MinorUnitFont.Color := clWindowText;
      YValues.MinorUnitFont.Height := -12;
      YValues.MinorUnitFont.Name := 'Segoe UI';
      YValues.MinorUnitFont.Style := [];
      YValues.MinorUnitFormat := '%.0f';
      YValues.MinorUnitSpacing := 5.000000000000000000;
      YValues.MinorUnitTickMarkSize := 7.000000000000000000;
      YValues.MinorUnitTickMarkColor := clSilver;
      YValues.Title.Font.Charset := DEFAULT_CHARSET;
      YValues.Title.Font.Color := clWindowText;
      YValues.Title.Font.Height := -12;
      YValues.Title.Font.Name := 'Segoe UI';
      YValues.Title.Font.Style := [];
      YValues.Title.TextMargins.Left := 0;
      YValues.Title.TextMargins.Top := 0;
      YValues.Title.TextMargins.Right := 0;
      YValues.Title.TextMargins.Bottom := 0;
      YValues.SpiderValues := False;
      Crosshair.XTextStroke.Color := 16105559;
      Crosshair.XTextFill.Color := 16105559;
      Crosshair.XTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.XTextFont.Color := clWhite;
      Crosshair.XTextFont.Height := -12;
      Crosshair.XTextFont.Name := 'Segoe UI';
      Crosshair.XTextFont.Style := [];
      Crosshair.YTextStroke.Color := 16105559;
      Crosshair.YTextFill.Color := 16105559;
      Crosshair.YTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.YTextFont.Color := clWhite;
      Crosshair.YTextFont.Height := -12;
      Crosshair.YTextFont.Name := 'Segoe UI';
      Crosshair.YTextFont.Style := [];
      Crosshair.HorizontalLineStroke.Color := 16105559;
      Crosshair.VerticalLineStroke.Color := 16105559;
    end;
    with cCompanyCount.Series.Add do
    begin
      AnimationFactor := 4.000000000000000000;
      AutoXRange := arEnabled;
      AutoYRange := arCommonZeroBased;
      Bar.Width := 65.000000000000000000;
      Bar.Spacing := 20.000000000000000000;
      MultiPoint.Width := 65.000000000000000000;
      Pie.Size := 200.000000000000000000;
      Pie.Margins.Left := 10;
      Pie.Margins.Top := 10;
      Pie.Margins.Right := 10;
      Pie.Margins.Bottom := 10;
      Pie.SweepAngle := 360.000000000000000000;
      ChartType := ctBar;
      Fill.Color := 5644279;
      LegendText := 'Invoiced';
      Labels.Font.Charset := DEFAULT_CHARSET;
      Labels.Font.Color := clWindowText;
      Labels.Font.Height := -12;
      Labels.Font.Name := 'Segoe UI';
      Labels.Font.Style := [];
      Labels.Format := '%.0f';
      Labels.OffsetY := 5.000000000000000000;
      Labels.Visible := True;
      Markers.Fill.Color := 5644279;
      Markers.Height := 10.000000000000000000;
      Markers.Stroke.Color := 2822268;
      Markers.Width := 10.000000000000000000;
      MaxX := 10.000000000000000000;
      MaxY := 10.000000000000000000;
      Offset3DX := 15.000000000000000000;
      Offset3DY := 15.000000000000000000;
      Legend.Font.Charset := DEFAULT_CHARSET;
      Legend.Font.Color := clWindowText;
      Legend.Font.Height := -12;
      Legend.Font.Name := 'Segoe UI';
      Legend.Font.Style := [];
      Legend.Left := -10.000000000000000000;
      Stroke.Color := 5644279;
      XValues.MajorUnit := 1.000000000000000000;
      XValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MajorUnitFont.Color := clWindowText;
      XValues.MajorUnitFont.Height := -12;
      XValues.MajorUnitFont.Name := 'Segoe UI';
      XValues.MajorUnitFont.Style := [];
      XValues.MajorUnitFormat := '%.0f';
      XValues.MajorUnitSpacing := 5.000000000000000000;
      XValues.MajorUnitTickMarkSize := 10.000000000000000000;
      XValues.MajorUnitTickMarkColor := clSilver;
      XValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MinorUnitFont.Color := clWindowText;
      XValues.MinorUnitFont.Height := -12;
      XValues.MinorUnitFont.Name := 'Segoe UI';
      XValues.MinorUnitFont.Style := [];
      XValues.MinorUnitFormat := '%.0f';
      XValues.MinorUnitSpacing := 5.000000000000000000;
      XValues.MinorUnitTickMarkSize := 7.000000000000000000;
      XValues.MinorUnitTickMarkColor := clSilver;
      XValues.Title.Font.Charset := DEFAULT_CHARSET;
      XValues.Title.Font.Color := clWindowText;
      XValues.Title.Font.Height := -12;
      XValues.Title.Font.Name := 'Segoe UI';
      XValues.Title.Font.Style := [];
      XValues.Title.TextMargins.Left := 0;
      XValues.Title.TextMargins.Top := 0;
      XValues.Title.TextMargins.Right := 0;
      XValues.Title.TextMargins.Bottom := 0;
      YValues.MajorUnit := 1.000000000000000000;
      YValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MajorUnitFont.Color := clWindowText;
      YValues.MajorUnitFont.Height := -12;
      YValues.MajorUnitFont.Name := 'Segoe UI';
      YValues.MajorUnitFont.Style := [];
      YValues.MajorUnitFormat := '%.0f';
      YValues.MajorUnitSpacing := 5.000000000000000000;
      YValues.MajorUnitTickMarkSize := 10.000000000000000000;
      YValues.MajorUnitTickMarkColor := clSilver;
      YValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MinorUnitFont.Color := clWindowText;
      YValues.MinorUnitFont.Height := -12;
      YValues.MinorUnitFont.Name := 'Segoe UI';
      YValues.MinorUnitFont.Style := [];
      YValues.MinorUnitFormat := '%.0f';
      YValues.MinorUnitSpacing := 5.000000000000000000;
      YValues.MinorUnitTickMarkSize := 7.000000000000000000;
      YValues.MinorUnitTickMarkColor := clSilver;
      YValues.Title.Font.Charset := DEFAULT_CHARSET;
      YValues.Title.Font.Color := clWindowText;
      YValues.Title.Font.Height := -12;
      YValues.Title.Font.Name := 'Segoe UI';
      YValues.Title.Font.Style := [];
      YValues.Title.TextMargins.Left := 0;
      YValues.Title.TextMargins.Top := 0;
      YValues.Title.TextMargins.Right := 0;
      YValues.Title.TextMargins.Bottom := 0;
      YValues.SpiderValues := False;
      YValues.Positions := [];
      Crosshair.XTextStroke.Color := 5644279;
      Crosshair.XTextFill.Color := 5644279;
      Crosshair.XTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.XTextFont.Color := clWhite;
      Crosshair.XTextFont.Height := -12;
      Crosshair.XTextFont.Name := 'Segoe UI';
      Crosshair.XTextFont.Style := [];
      Crosshair.YTextStroke.Color := 5644279;
      Crosshair.YTextFill.Color := 5644279;
      Crosshair.YTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.YTextFont.Color := clWhite;
      Crosshair.YTextFont.Height := -12;
      Crosshair.YTextFont.Name := 'Segoe UI';
      Crosshair.YTextFont.Style := [];
      Crosshair.HorizontalLineStroke.Color := 5644279;
      Crosshair.VerticalLineStroke.Color := 5644279;
    end;
    with cCompanyCount.Series.Add do
    begin
      AnimationFactor := 4.000000000000000000;
      AutoXRange := arEnabled;
      AutoYRange := arCommonZeroBased;
      Bar.Width := 65.000000000000000000;
      Bar.Spacing := 20.000000000000000000;
      MultiPoint.Width := 65.000000000000000000;
      Pie.Size := 200.000000000000000000;
      Pie.Margins.Left := 10;
      Pie.Margins.Top := 10;
      Pie.Margins.Right := 10;
      Pie.Margins.Bottom := 10;
      Pie.SweepAngle := 360.000000000000000000;
      ChartType := ctBar;
      Fill.Color := 7936771;
      LegendText := 'Not Invoiced';
      Labels.Font.Charset := DEFAULT_CHARSET;
      Labels.Font.Color := clWindowText;
      Labels.Font.Height := -12;
      Labels.Font.Name := 'Segoe UI';
      Labels.Font.Style := [];
      Labels.Format := '%.0f';
      Labels.OffsetY := 5.000000000000000000;
      Labels.Visible := True;
      Markers.Fill.Color := 7936771;
      Markers.Height := 10.000000000000000000;
      Markers.Stroke.Color := 3935746;
      Markers.Width := 10.000000000000000000;
      MaxX := 10.000000000000000000;
      MaxY := 10.000000000000000000;
      Offset3DX := 15.000000000000000000;
      Offset3DY := 15.000000000000000000;
      Legend.Font.Charset := DEFAULT_CHARSET;
      Legend.Font.Color := clWindowText;
      Legend.Font.Height := -12;
      Legend.Font.Name := 'Segoe UI';
      Legend.Font.Style := [];
      Legend.Left := -10.000000000000000000;
      Stroke.Color := 7936771;
      XValues.MajorUnit := 1.000000000000000000;
      XValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MajorUnitFont.Color := clWindowText;
      XValues.MajorUnitFont.Height := -12;
      XValues.MajorUnitFont.Name := 'Segoe UI';
      XValues.MajorUnitFont.Style := [];
      XValues.MajorUnitFormat := '%.0f';
      XValues.MajorUnitSpacing := 5.000000000000000000;
      XValues.MajorUnitTickMarkSize := 10.000000000000000000;
      XValues.MajorUnitTickMarkColor := clSilver;
      XValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MinorUnitFont.Color := clWindowText;
      XValues.MinorUnitFont.Height := -12;
      XValues.MinorUnitFont.Name := 'Segoe UI';
      XValues.MinorUnitFont.Style := [];
      XValues.MinorUnitFormat := '%.0f';
      XValues.MinorUnitSpacing := 5.000000000000000000;
      XValues.MinorUnitTickMarkSize := 7.000000000000000000;
      XValues.MinorUnitTickMarkColor := clSilver;
      XValues.Title.Font.Charset := DEFAULT_CHARSET;
      XValues.Title.Font.Color := clWindowText;
      XValues.Title.Font.Height := -12;
      XValues.Title.Font.Name := 'Segoe UI';
      XValues.Title.Font.Style := [];
      XValues.Title.TextMargins.Left := 0;
      XValues.Title.TextMargins.Top := 0;
      XValues.Title.TextMargins.Right := 0;
      XValues.Title.TextMargins.Bottom := 0;
      YValues.MajorUnit := 1.000000000000000000;
      YValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MajorUnitFont.Color := clWindowText;
      YValues.MajorUnitFont.Height := -12;
      YValues.MajorUnitFont.Name := 'Segoe UI';
      YValues.MajorUnitFont.Style := [];
      YValues.MajorUnitFormat := '%.0f';
      YValues.MajorUnitSpacing := 5.000000000000000000;
      YValues.MajorUnitTickMarkSize := 10.000000000000000000;
      YValues.MajorUnitTickMarkColor := clSilver;
      YValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MinorUnitFont.Color := clWindowText;
      YValues.MinorUnitFont.Height := -12;
      YValues.MinorUnitFont.Name := 'Segoe UI';
      YValues.MinorUnitFont.Style := [];
      YValues.MinorUnitFormat := '%.0f';
      YValues.MinorUnitSpacing := 5.000000000000000000;
      YValues.MinorUnitTickMarkSize := 7.000000000000000000;
      YValues.MinorUnitTickMarkColor := clSilver;
      YValues.Title.Font.Charset := DEFAULT_CHARSET;
      YValues.Title.Font.Color := clWindowText;
      YValues.Title.Font.Height := -12;
      YValues.Title.Font.Name := 'Segoe UI';
      YValues.Title.Font.Style := [];
      YValues.Title.TextMargins.Left := 0;
      YValues.Title.TextMargins.Top := 0;
      YValues.Title.TextMargins.Right := 0;
      YValues.Title.TextMargins.Bottom := 0;
      YValues.SpiderValues := False;
      YValues.Positions := [];
      Crosshair.XTextStroke.Color := 7936771;
      Crosshair.XTextFill.Color := 7936771;
      Crosshair.XTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.XTextFont.Color := clWhite;
      Crosshair.XTextFont.Height := -12;
      Crosshair.XTextFont.Name := 'Segoe UI';
      Crosshair.XTextFont.Style := [];
      Crosshair.YTextStroke.Color := 7936771;
      Crosshair.YTextFill.Color := 7936771;
      Crosshair.YTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.YTextFont.Color := clWhite;
      Crosshair.YTextFont.Height := -12;
      Crosshair.YTextFont.Name := 'Segoe UI';
      Crosshair.YTextFont.Style := [];
      Crosshair.HorizontalLineStroke.Color := 7936771;
      Crosshair.VerticalLineStroke.Color := 7936771;
    end;
    with cCompanyCount.Series.Add do
    begin
      AnimationFactor := 4.000000000000000000;
      AutoXRange := arEnabled;
      AutoYRange := arCommonZeroBased;
      Bar.Width := 65.000000000000000000;
      Bar.Spacing := 20.000000000000000000;
      MultiPoint.Width := 65.000000000000000000;
      Pie.Size := 200.000000000000000000;
      Pie.Margins.Left := 10;
      Pie.Margins.Top := 10;
      Pie.Margins.Right := 10;
      Pie.Margins.Bottom := 10;
      Pie.SweepAngle := 360.000000000000000000;
      ChartType := ctBar;
      Fill.Color := 12275349;
      LegendText := 'Not Received';
      Labels.Font.Charset := DEFAULT_CHARSET;
      Labels.Font.Color := clWindowText;
      Labels.Font.Height := -12;
      Labels.Font.Name := 'Segoe UI';
      Labels.Font.Style := [];
      Labels.Format := '%.0f';
      Labels.OffsetY := 5.000000000000000000;
      Labels.Visible := True;
      Markers.Fill.Color := 12275349;
      Markers.Height := 10.000000000000000000;
      Markers.Stroke.Color := 6170442;
      Markers.Width := 10.000000000000000000;
      MaxX := 10.000000000000000000;
      MaxY := 10.000000000000000000;
      Offset3DX := 15.000000000000000000;
      Offset3DY := 15.000000000000000000;
      Legend.Font.Charset := DEFAULT_CHARSET;
      Legend.Font.Color := clWindowText;
      Legend.Font.Height := -12;
      Legend.Font.Name := 'Segoe UI';
      Legend.Font.Style := [];
      Legend.Left := -10.000000000000000000;
      Stroke.Color := 12275349;
      XValues.MajorUnit := 1.000000000000000000;
      XValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MajorUnitFont.Color := clWindowText;
      XValues.MajorUnitFont.Height := -12;
      XValues.MajorUnitFont.Name := 'Segoe UI';
      XValues.MajorUnitFont.Style := [];
      XValues.MajorUnitFormat := '%.0f';
      XValues.MajorUnitSpacing := 5.000000000000000000;
      XValues.MajorUnitTickMarkSize := 10.000000000000000000;
      XValues.MajorUnitTickMarkColor := clSilver;
      XValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MinorUnitFont.Color := clWindowText;
      XValues.MinorUnitFont.Height := -12;
      XValues.MinorUnitFont.Name := 'Segoe UI';
      XValues.MinorUnitFont.Style := [];
      XValues.MinorUnitFormat := '%.0f';
      XValues.MinorUnitSpacing := 5.000000000000000000;
      XValues.MinorUnitTickMarkSize := 7.000000000000000000;
      XValues.MinorUnitTickMarkColor := clSilver;
      XValues.Title.Font.Charset := DEFAULT_CHARSET;
      XValues.Title.Font.Color := clWindowText;
      XValues.Title.Font.Height := -12;
      XValues.Title.Font.Name := 'Segoe UI';
      XValues.Title.Font.Style := [];
      XValues.Title.TextMargins.Left := 0;
      XValues.Title.TextMargins.Top := 0;
      XValues.Title.TextMargins.Right := 0;
      XValues.Title.TextMargins.Bottom := 0;
      YGrid.SpiderVisible := False;
      YValues.MajorUnit := 1.000000000000000000;
      YValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MajorUnitFont.Color := clWindowText;
      YValues.MajorUnitFont.Height := -12;
      YValues.MajorUnitFont.Name := 'Segoe UI';
      YValues.MajorUnitFont.Style := [];
      YValues.MajorUnitFormat := '%.0f';
      YValues.MajorUnitSpacing := 5.000000000000000000;
      YValues.MajorUnitTickMarkSize := 10.000000000000000000;
      YValues.MajorUnitTickMarkColor := clSilver;
      YValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MinorUnitFont.Color := clWindowText;
      YValues.MinorUnitFont.Height := -12;
      YValues.MinorUnitFont.Name := 'Segoe UI';
      YValues.MinorUnitFont.Style := [];
      YValues.MinorUnitFormat := '%.0f';
      YValues.MinorUnitSpacing := 5.000000000000000000;
      YValues.MinorUnitTickMarkSize := 7.000000000000000000;
      YValues.MinorUnitTickMarkColor := clSilver;
      YValues.Title.Font.Charset := DEFAULT_CHARSET;
      YValues.Title.Font.Color := clWindowText;
      YValues.Title.Font.Height := -12;
      YValues.Title.Font.Name := 'Segoe UI';
      YValues.Title.Font.Style := [];
      YValues.Title.TextMargins.Left := 0;
      YValues.Title.TextMargins.Top := 0;
      YValues.Title.TextMargins.Right := 0;
      YValues.Title.TextMargins.Bottom := 0;
      YValues.SpiderValues := False;
      YValues.Positions := [];
      Crosshair.XTextStroke.Color := 12275349;
      Crosshair.XTextFill.Color := 12275349;
      Crosshair.XTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.XTextFont.Color := clWhite;
      Crosshair.XTextFont.Height := -12;
      Crosshair.XTextFont.Name := 'Segoe UI';
      Crosshair.XTextFont.Style := [];
      Crosshair.YTextStroke.Color := 12275349;
      Crosshair.YTextFill.Color := 12275349;
      Crosshair.YTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.YTextFont.Color := clWhite;
      Crosshair.YTextFont.Height := -12;
      Crosshair.YTextFont.Name := 'Segoe UI';
      Crosshair.YTextFont.Style := [];
      Crosshair.HorizontalLineStroke.Color := 12275349;
      Crosshair.VerticalLineStroke.Color := 12275349;
    end;
    cCompanyCount.Title.Stroke.Kind := gskSolid;
    cCompanyCount.Title.Font.Charset := DEFAULT_CHARSET;
    cCompanyCount.Title.Font.Color := clWindowText;
    cCompanyCount.Title.Font.Height := -12;
    cCompanyCount.Title.Font.Name := 'Segoe UI';
    cCompanyCount.Title.Font.Style := [];
    cCompanyCount.Title.Height := 35.000000000000000000;
    cCompanyCount.Title.TextMargins.Left := 3;
    cCompanyCount.Title.TextMargins.Top := 3;
    cCompanyCount.Title.TextMargins.Right := 3;
    cCompanyCount.Title.TextMargins.Bottom := 3;
    cCompanyCount.Title.Text := 'Total Loads Count';
    cCompanyCount.XAxis.Stroke.Kind := gskSolid;
    cCompanyCount.XAxis.AutoSize := False;
    cCompanyCount.XAxis.Height := 35.000000000000000000;
    cCompanyCount.YAxis.Stroke.Kind := gskSolid;
    cCompanyCount.YAxis.Width := 35.000000000000000000;
    cCompanyCount.DefaultLoadOptions.XValuesFormatString := '%.0f';
    cCompanyCount.DefaultLoadOptions.YValuesFormatString := '%.2f';
    cCompanyCount.DefaultLoadOptions.MaxYOffsetPercentage := 5.000000000000000000;
    cCompanyCount.Align := alTop;
    cCompanyCount.TabOrder := 0;
    wpCompanyRevenue.SetParentComponent(wpMainCompany);
    wpCompanyRevenue.Name := 'wpCompanyRevenue';
    wpCompanyRevenue.Left := 512;
    wpCompanyRevenue.Top := 0;
    wpCompanyRevenue.Width := 512;
    wpCompanyRevenue.Height := 351;
    wpCompanyRevenue.Align := alClient;
    wpCompanyRevenue.Caption := 'wpCompanyRevenue';
    wpCompanyRevenue.ChildOrder := 1;
    wpCompanyRevenue.ShowCaption := False;
    wpCompanyRevenue.TabOrder := 1;
    cCompanyRevenue.SetParentComponent(wpCompanyRevenue);
    cCompanyRevenue.Name := 'cCompanyRevenue';
    cCompanyRevenue.Left := 0;
    cCompanyRevenue.Top := 0;
    cCompanyRevenue.Width := 512;
    cCompanyRevenue.Height := 350;
    cCompanyRevenue.Appearance.ColorList.Clear;
    with cCompanyRevenue.Appearance.ColorList.Add do
    begin
      Color := 16105559;
    end;
    with cCompanyRevenue.Appearance.ColorList.Add do
    begin
      Color := 5644279;
    end;
    with cCompanyRevenue.Appearance.ColorList.Add do
    begin
      Color := 7936771;
    end;
    with cCompanyRevenue.Appearance.ColorList.Add do
    begin
      Color := 12275349;
    end;
    with cCompanyRevenue.Appearance.ColorList.Add do
    begin
      Color := 1296366;
    end;
    with cCompanyRevenue.Appearance.ColorList.Add do
    begin
      Color := 4350195;
    end;
    with cCompanyRevenue.Appearance.ColorList.Add do
    begin
      Color := 16544551;
    end;
    with cCompanyRevenue.Appearance.ColorList.Add do
    begin
      Color := 5820321;
    end;
    with cCompanyRevenue.Appearance.ColorList.Add do
    begin
      Color := 10922240;
    end;
    with cCompanyRevenue.Appearance.ColorList.Add do
    begin
      Color := 16376965;
    end;
    cCompanyRevenue.Appearance.GlobalFont.Color := -1;
    cCompanyRevenue.Appearance.GlobalFont.Scale := 1.000000000000000000;
    cCompanyRevenue.Appearance.GlobalFont.Style := [];
    cCompanyRevenue.Appearance.ColorScheme := ccsColorList;
    cCompanyRevenue.Appearance.MonochromeColor := clSteelblue;
    cCompanyRevenue.ClickMargin := 10.000000000000000000;
    cCompanyRevenue.Legend.Fill.Kind := gfkSolid;
    cCompanyRevenue.Legend.Stroke.Kind := gskSolid;
    cCompanyRevenue.Legend.Font.Charset := DEFAULT_CHARSET;
    cCompanyRevenue.Legend.Font.Color := clWindowText;
    cCompanyRevenue.Legend.Font.Height := -12;
    cCompanyRevenue.Legend.Font.Name := 'Segoe UI';
    cCompanyRevenue.Legend.Font.Style := [];
    cCompanyRevenue.Legend.Left := -10.000000000000000000;
    cCompanyRevenue.Legend.Position := lpTopRight;
    cCompanyRevenue.Legend.Top := 10.000000000000000000;
    cCompanyRevenue.SeriesMargins.Left := 0;
    cCompanyRevenue.SeriesMargins.Top := 15;
    cCompanyRevenue.SeriesMargins.Right := 0;
    cCompanyRevenue.SeriesMargins.Bottom := 0;
    cCompanyRevenue.Series.Clear;
    with cCompanyRevenue.Series.Add do
    begin
      AnimationFactor := 4.000000000000000000;
      AutoXRange := arEnabled;
      AutoYRange := arCommonZeroBased;
      Bar.Width := 65.000000000000000000;
      Bar.Spacing := 20.000000000000000000;
      MultiPoint.Width := 65.000000000000000000;
      Pie.Size := 200.000000000000000000;
      Pie.Margins.Left := 10;
      Pie.Margins.Top := 10;
      Pie.Margins.Right := 10;
      Pie.Margins.Bottom := 10;
      Pie.SweepAngle := 360.000000000000000000;
      ChartType := ctBar;
      Fill.Color := clGreen;
      LegendText := 'Loads';
      Labels.Font.Charset := DEFAULT_CHARSET;
      Labels.Font.Color := clWindowText;
      Labels.Font.Height := -12;
      Labels.Font.Name := 'Segoe UI';
      Labels.Font.Style := [];
      Labels.Format := '#,##0';
      Labels.FormatType := vftFloat;
      Labels.OffsetY := 5.000000000000000000;
      Labels.Visible := True;
      Markers.Fill.Color := 16105559;
      Markers.Height := 10.000000000000000000;
      Markers.Stroke.Color := 8020012;
      Markers.Width := 10.000000000000000000;
      MaxX := 10.000000000000000000;
      MaxY := 10.000000000000000000;
      Offset3DX := 15.000000000000000000;
      Offset3DY := 15.000000000000000000;
      Legend.Font.Charset := DEFAULT_CHARSET;
      Legend.Font.Color := clWindowText;
      Legend.Font.Height := -12;
      Legend.Font.Name := 'Segoe UI';
      Legend.Font.Style := [];
      Legend.Left := -10.000000000000000000;
      Stroke.Color := clGreen;
      XValues.MajorUnit := 1.000000000000000000;
      XValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MajorUnitFont.Color := clWindowText;
      XValues.MajorUnitFont.Height := -12;
      XValues.MajorUnitFont.Name := 'Segoe UI';
      XValues.MajorUnitFont.Style := [];
      XValues.MajorUnitFormat := '%.0f';
      XValues.MajorUnitSpacing := 5.000000000000000000;
      XValues.MajorUnitTickMarkSize := 10.000000000000000000;
      XValues.MajorUnitTickMarkColor := clSilver;
      XValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MinorUnitFont.Color := clWindowText;
      XValues.MinorUnitFont.Height := -12;
      XValues.MinorUnitFont.Name := 'Segoe UI';
      XValues.MinorUnitFont.Style := [];
      XValues.MinorUnitFormat := '%.0f';
      XValues.MinorUnitSpacing := 5.000000000000000000;
      XValues.MinorUnitTickMarkSize := 7.000000000000000000;
      XValues.MinorUnitTickMarkColor := clSilver;
      XValues.Title.Font.Charset := DEFAULT_CHARSET;
      XValues.Title.Font.Color := clWindowText;
      XValues.Title.Font.Height := -12;
      XValues.Title.Font.Name := 'Segoe UI';
      XValues.Title.Font.Style := [];
      XValues.Title.TextMargins.Left := 0;
      XValues.Title.TextMargins.Top := 0;
      XValues.Title.TextMargins.Right := 0;
      XValues.Title.TextMargins.Bottom := 0;
      YValues.MajorUnit := 1.000000000000000000;
      YValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MajorUnitFont.Color := clWindowText;
      YValues.MajorUnitFont.Height := -12;
      YValues.MajorUnitFont.Name := 'Segoe UI';
      YValues.MajorUnitFont.Style := [];
      YValues.MajorUnitFormat := '#,##0';
      YValues.MajorUnitFormatType := vftFloat;
      YValues.MajorUnitSpacing := 5.000000000000000000;
      YValues.MajorUnitTickMarkSize := 10.000000000000000000;
      YValues.MajorUnitTickMarkColor := clSilver;
      YValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MinorUnitFont.Color := clWindowText;
      YValues.MinorUnitFont.Height := -12;
      YValues.MinorUnitFont.Name := 'Segoe UI';
      YValues.MinorUnitFont.Style := [];
      YValues.MinorUnitFormat := '#,##0';
      YValues.MinorUnitFormatType := vftFloat;
      YValues.MinorUnitSpacing := 5.000000000000000000;
      YValues.MinorUnitTickMarkSize := 7.000000000000000000;
      YValues.MinorUnitTickMarkColor := clSilver;
      YValues.Title.Font.Charset := DEFAULT_CHARSET;
      YValues.Title.Font.Color := clWindowText;
      YValues.Title.Font.Height := -12;
      YValues.Title.Font.Name := 'Segoe UI';
      YValues.Title.Font.Style := [];
      YValues.Title.TextMargins.Left := 0;
      YValues.Title.TextMargins.Top := 0;
      YValues.Title.TextMargins.Right := 0;
      YValues.Title.TextMargins.Bottom := 0;
      YValues.SpiderValues := False;
      Crosshair.XTextStroke.Color := 16105559;
      Crosshair.XTextFill.Color := 16105559;
      Crosshair.XTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.XTextFont.Color := clWhite;
      Crosshair.XTextFont.Height := -12;
      Crosshair.XTextFont.Name := 'Segoe UI';
      Crosshair.XTextFont.Style := [];
      Crosshair.YTextStroke.Color := 16105559;
      Crosshair.YTextFill.Color := 16105559;
      Crosshair.YTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.YTextFont.Color := clWhite;
      Crosshair.YTextFont.Height := -12;
      Crosshair.YTextFont.Name := 'Segoe UI';
      Crosshair.YTextFont.Style := [];
      Crosshair.HorizontalLineStroke.Color := 16105559;
      Crosshair.VerticalLineStroke.Color := 16105559;
    end;
    with cCompanyRevenue.Series.Add do
    begin
      AnimationFactor := 4.000000000000000000;
      AutoXRange := arEnabled;
      AutoYRange := arCommonZeroBased;
      Bar.Width := 65.000000000000000000;
      Bar.Spacing := 20.000000000000000000;
      MultiPoint.Width := 65.000000000000000000;
      Pie.Size := 200.000000000000000000;
      Pie.Margins.Left := 10;
      Pie.Margins.Top := 10;
      Pie.Margins.Right := 10;
      Pie.Margins.Bottom := 10;
      Pie.SweepAngle := 360.000000000000000000;
      ChartType := ctBar;
      Fill.Color := 5644279;
      LegendText := 'Invoiced';
      Labels.Font.Charset := DEFAULT_CHARSET;
      Labels.Font.Color := clWindowText;
      Labels.Font.Height := -12;
      Labels.Font.Name := 'Segoe UI';
      Labels.Font.Style := [];
      Labels.Format := '#,##0';
      Labels.FormatType := vftFloat;
      Labels.OffsetY := 5.000000000000000000;
      Labels.Visible := True;
      Markers.Fill.Color := 5644279;
      Markers.Height := 10.000000000000000000;
      Markers.Stroke.Color := 2822268;
      Markers.Width := 10.000000000000000000;
      MaxX := 10.000000000000000000;
      MaxY := 10.000000000000000000;
      Offset3DX := 15.000000000000000000;
      Offset3DY := 15.000000000000000000;
      Legend.Font.Charset := DEFAULT_CHARSET;
      Legend.Font.Color := clWindowText;
      Legend.Font.Height := -12;
      Legend.Font.Name := 'Segoe UI';
      Legend.Font.Style := [];
      Legend.Left := -10.000000000000000000;
      Stroke.Color := 5644279;
      XValues.MajorUnit := 1.000000000000000000;
      XValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MajorUnitFont.Color := clWindowText;
      XValues.MajorUnitFont.Height := -12;
      XValues.MajorUnitFont.Name := 'Segoe UI';
      XValues.MajorUnitFont.Style := [];
      XValues.MajorUnitFormat := '%.0f';
      XValues.MajorUnitSpacing := 5.000000000000000000;
      XValues.MajorUnitTickMarkSize := 10.000000000000000000;
      XValues.MajorUnitTickMarkColor := clSilver;
      XValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MinorUnitFont.Color := clWindowText;
      XValues.MinorUnitFont.Height := -12;
      XValues.MinorUnitFont.Name := 'Segoe UI';
      XValues.MinorUnitFont.Style := [];
      XValues.MinorUnitFormat := '%.0f';
      XValues.MinorUnitSpacing := 5.000000000000000000;
      XValues.MinorUnitTickMarkSize := 7.000000000000000000;
      XValues.MinorUnitTickMarkColor := clSilver;
      XValues.Title.Font.Charset := DEFAULT_CHARSET;
      XValues.Title.Font.Color := clWindowText;
      XValues.Title.Font.Height := -12;
      XValues.Title.Font.Name := 'Segoe UI';
      XValues.Title.Font.Style := [];
      XValues.Title.TextMargins.Left := 0;
      XValues.Title.TextMargins.Top := 0;
      XValues.Title.TextMargins.Right := 0;
      XValues.Title.TextMargins.Bottom := 0;
      YValues.MajorUnit := 1.000000000000000000;
      YValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MajorUnitFont.Color := clWindowText;
      YValues.MajorUnitFont.Height := -12;
      YValues.MajorUnitFont.Name := 'Segoe UI';
      YValues.MajorUnitFont.Style := [];
      YValues.MajorUnitFormat := '#,##0';
      YValues.MajorUnitFormatType := vftFloat;
      YValues.MajorUnitSpacing := 5.000000000000000000;
      YValues.MajorUnitTickMarkSize := 10.000000000000000000;
      YValues.MajorUnitTickMarkColor := clSilver;
      YValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MinorUnitFont.Color := clWindowText;
      YValues.MinorUnitFont.Height := -12;
      YValues.MinorUnitFont.Name := 'Segoe UI';
      YValues.MinorUnitFont.Style := [];
      YValues.MinorUnitFormat := '#,##0';
      YValues.MinorUnitFormatType := vftFloat;
      YValues.MinorUnitSpacing := 5.000000000000000000;
      YValues.MinorUnitTickMarkSize := 7.000000000000000000;
      YValues.MinorUnitTickMarkColor := clSilver;
      YValues.Title.Font.Charset := DEFAULT_CHARSET;
      YValues.Title.Font.Color := clWindowText;
      YValues.Title.Font.Height := -12;
      YValues.Title.Font.Name := 'Segoe UI';
      YValues.Title.Font.Style := [];
      YValues.Title.TextMargins.Left := 0;
      YValues.Title.TextMargins.Top := 0;
      YValues.Title.TextMargins.Right := 0;
      YValues.Title.TextMargins.Bottom := 0;
      YValues.SpiderValues := False;
      YValues.Positions := [];
      Crosshair.XTextStroke.Color := 5644279;
      Crosshair.XTextFill.Color := 5644279;
      Crosshair.XTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.XTextFont.Color := clWhite;
      Crosshair.XTextFont.Height := -12;
      Crosshair.XTextFont.Name := 'Segoe UI';
      Crosshair.XTextFont.Style := [];
      Crosshair.YTextStroke.Color := 5644279;
      Crosshair.YTextFill.Color := 5644279;
      Crosshair.YTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.YTextFont.Color := clWhite;
      Crosshair.YTextFont.Height := -12;
      Crosshair.YTextFont.Name := 'Segoe UI';
      Crosshair.YTextFont.Style := [];
      Crosshair.HorizontalLineStroke.Color := 5644279;
      Crosshair.VerticalLineStroke.Color := 5644279;
    end;
    with cCompanyRevenue.Series.Add do
    begin
      AnimationFactor := 4.000000000000000000;
      AutoXRange := arEnabled;
      AutoYRange := arCommonZeroBased;
      Bar.Width := 65.000000000000000000;
      Bar.Spacing := 20.000000000000000000;
      MultiPoint.Width := 65.000000000000000000;
      Pie.Size := 200.000000000000000000;
      Pie.Margins.Left := 10;
      Pie.Margins.Top := 10;
      Pie.Margins.Right := 10;
      Pie.Margins.Bottom := 10;
      Pie.SweepAngle := 360.000000000000000000;
      ChartType := ctBar;
      Fill.Color := clBlue;
      LegendText := 'Not Invoiced';
      Labels.Font.Charset := DEFAULT_CHARSET;
      Labels.Font.Color := clWindowText;
      Labels.Font.Height := -12;
      Labels.Font.Name := 'Segoe UI';
      Labels.Font.Style := [];
      Labels.Format := '#,##0';
      Labels.FormatType := vftFloat;
      Labels.OffsetY := 5.000000000000000000;
      Labels.Visible := True;
      Markers.Fill.Color := 7936771;
      Markers.Height := 10.000000000000000000;
      Markers.Stroke.Color := 3935746;
      Markers.Width := 10.000000000000000000;
      MaxX := 10.000000000000000000;
      MaxY := 10.000000000000000000;
      Offset3DX := 15.000000000000000000;
      Offset3DY := 15.000000000000000000;
      Legend.Font.Charset := DEFAULT_CHARSET;
      Legend.Font.Color := clWindowText;
      Legend.Font.Height := -12;
      Legend.Font.Name := 'Segoe UI';
      Legend.Font.Style := [];
      Legend.Left := -10.000000000000000000;
      Stroke.Color := clBlue;
      XValues.MajorUnit := 1.000000000000000000;
      XValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MajorUnitFont.Color := clWindowText;
      XValues.MajorUnitFont.Height := -12;
      XValues.MajorUnitFont.Name := 'Segoe UI';
      XValues.MajorUnitFont.Style := [];
      XValues.MajorUnitFormat := '%.0f';
      XValues.MajorUnitSpacing := 5.000000000000000000;
      XValues.MajorUnitTickMarkSize := 10.000000000000000000;
      XValues.MajorUnitTickMarkColor := clSilver;
      XValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MinorUnitFont.Color := clWindowText;
      XValues.MinorUnitFont.Height := -12;
      XValues.MinorUnitFont.Name := 'Segoe UI';
      XValues.MinorUnitFont.Style := [];
      XValues.MinorUnitFormat := '%.0f';
      XValues.MinorUnitSpacing := 5.000000000000000000;
      XValues.MinorUnitTickMarkSize := 7.000000000000000000;
      XValues.MinorUnitTickMarkColor := clSilver;
      XValues.Title.Font.Charset := DEFAULT_CHARSET;
      XValues.Title.Font.Color := clWindowText;
      XValues.Title.Font.Height := -12;
      XValues.Title.Font.Name := 'Segoe UI';
      XValues.Title.Font.Style := [];
      XValues.Title.TextMargins.Left := 0;
      XValues.Title.TextMargins.Top := 0;
      XValues.Title.TextMargins.Right := 0;
      XValues.Title.TextMargins.Bottom := 0;
      YValues.MajorUnit := 1.000000000000000000;
      YValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MajorUnitFont.Color := clWindowText;
      YValues.MajorUnitFont.Height := -12;
      YValues.MajorUnitFont.Name := 'Segoe UI';
      YValues.MajorUnitFont.Style := [];
      YValues.MajorUnitFormat := '#,##0';
      YValues.MajorUnitFormatType := vftFloat;
      YValues.MajorUnitSpacing := 5.000000000000000000;
      YValues.MajorUnitTickMarkSize := 10.000000000000000000;
      YValues.MajorUnitTickMarkColor := clSilver;
      YValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MinorUnitFont.Color := clWindowText;
      YValues.MinorUnitFont.Height := -12;
      YValues.MinorUnitFont.Name := 'Segoe UI';
      YValues.MinorUnitFont.Style := [];
      YValues.MinorUnitFormat := '#,##0';
      YValues.MinorUnitFormatType := vftFloat;
      YValues.MinorUnitSpacing := 5.000000000000000000;
      YValues.MinorUnitTickMarkSize := 7.000000000000000000;
      YValues.MinorUnitTickMarkColor := clSilver;
      YValues.Title.Font.Charset := DEFAULT_CHARSET;
      YValues.Title.Font.Color := clWindowText;
      YValues.Title.Font.Height := -12;
      YValues.Title.Font.Name := 'Segoe UI';
      YValues.Title.Font.Style := [];
      YValues.Title.TextMargins.Left := 0;
      YValues.Title.TextMargins.Top := 0;
      YValues.Title.TextMargins.Right := 0;
      YValues.Title.TextMargins.Bottom := 0;
      YValues.SpiderValues := False;
      YValues.Positions := [];
      Crosshair.XTextStroke.Color := 7936771;
      Crosshair.XTextFill.Color := 7936771;
      Crosshair.XTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.XTextFont.Color := clWhite;
      Crosshair.XTextFont.Height := -12;
      Crosshair.XTextFont.Name := 'Segoe UI';
      Crosshair.XTextFont.Style := [];
      Crosshair.YTextStroke.Color := 7936771;
      Crosshair.YTextFill.Color := 7936771;
      Crosshair.YTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.YTextFont.Color := clWhite;
      Crosshair.YTextFont.Height := -12;
      Crosshair.YTextFont.Name := 'Segoe UI';
      Crosshair.YTextFont.Style := [];
      Crosshair.HorizontalLineStroke.Color := 7936771;
      Crosshair.VerticalLineStroke.Color := 7936771;
    end;
    with cCompanyRevenue.Series.Add do
    begin
      AnimationFactor := 4.000000000000000000;
      AutoXRange := arEnabled;
      AutoYRange := arCommonZeroBased;
      Bar.Width := 65.000000000000000000;
      Bar.Spacing := 20.000000000000000000;
      MultiPoint.Width := 65.000000000000000000;
      Pie.Size := 200.000000000000000000;
      Pie.Margins.Left := 10;
      Pie.Margins.Top := 10;
      Pie.Margins.Right := 10;
      Pie.Margins.Bottom := 10;
      Pie.SweepAngle := 360.000000000000000000;
      ChartType := ctBar;
      Fill.Color := clLime;
      LegendText := 'Not Received';
      Labels.Font.Charset := DEFAULT_CHARSET;
      Labels.Font.Color := clWindowText;
      Labels.Font.Height := -12;
      Labels.Font.Name := 'Segoe UI';
      Labels.Font.Style := [];
      Labels.Format := '#,##0';
      Labels.FormatType := vftFloat;
      Labels.OffsetY := 5.000000000000000000;
      Labels.Visible := True;
      Markers.Fill.Color := 12275349;
      Markers.Height := 10.000000000000000000;
      Markers.Stroke.Color := 6170442;
      Markers.Width := 10.000000000000000000;
      MaxX := 10.000000000000000000;
      MaxY := 10.000000000000000000;
      Offset3DX := 15.000000000000000000;
      Offset3DY := 15.000000000000000000;
      Legend.Font.Charset := DEFAULT_CHARSET;
      Legend.Font.Color := clWindowText;
      Legend.Font.Height := -12;
      Legend.Font.Name := 'Segoe UI';
      Legend.Font.Style := [];
      Legend.Left := -10.000000000000000000;
      Stroke.Color := clLime;
      XValues.MajorUnit := 1.000000000000000000;
      XValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MajorUnitFont.Color := clWindowText;
      XValues.MajorUnitFont.Height := -12;
      XValues.MajorUnitFont.Name := 'Segoe UI';
      XValues.MajorUnitFont.Style := [];
      XValues.MajorUnitFormat := '%.0f';
      XValues.MajorUnitSpacing := 5.000000000000000000;
      XValues.MajorUnitTickMarkSize := 10.000000000000000000;
      XValues.MajorUnitTickMarkColor := clSilver;
      XValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MinorUnitFont.Color := clWindowText;
      XValues.MinorUnitFont.Height := -12;
      XValues.MinorUnitFont.Name := 'Segoe UI';
      XValues.MinorUnitFont.Style := [];
      XValues.MinorUnitFormat := '%.0f';
      XValues.MinorUnitSpacing := 5.000000000000000000;
      XValues.MinorUnitTickMarkSize := 7.000000000000000000;
      XValues.MinorUnitTickMarkColor := clSilver;
      XValues.Title.Font.Charset := DEFAULT_CHARSET;
      XValues.Title.Font.Color := clWindowText;
      XValues.Title.Font.Height := -12;
      XValues.Title.Font.Name := 'Segoe UI';
      XValues.Title.Font.Style := [];
      XValues.Title.TextMargins.Left := 0;
      XValues.Title.TextMargins.Top := 0;
      XValues.Title.TextMargins.Right := 0;
      XValues.Title.TextMargins.Bottom := 0;
      YGrid.SpiderVisible := False;
      YValues.MajorUnit := 1.000000000000000000;
      YValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MajorUnitFont.Color := clWindowText;
      YValues.MajorUnitFont.Height := -12;
      YValues.MajorUnitFont.Name := 'Segoe UI';
      YValues.MajorUnitFont.Style := [];
      YValues.MajorUnitFormat := '#,##0';
      YValues.MajorUnitFormatType := vftFloat;
      YValues.MajorUnitSpacing := 5.000000000000000000;
      YValues.MajorUnitTickMarkSize := 10.000000000000000000;
      YValues.MajorUnitTickMarkColor := clSilver;
      YValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MinorUnitFont.Color := clWindowText;
      YValues.MinorUnitFont.Height := -12;
      YValues.MinorUnitFont.Name := 'Segoe UI';
      YValues.MinorUnitFont.Style := [];
      YValues.MinorUnitFormat := '#,##0';
      YValues.MinorUnitFormatType := vftFloat;
      YValues.MinorUnitSpacing := 5.000000000000000000;
      YValues.MinorUnitTickMarkSize := 7.000000000000000000;
      YValues.MinorUnitTickMarkColor := clSilver;
      YValues.Title.Font.Charset := DEFAULT_CHARSET;
      YValues.Title.Font.Color := clWindowText;
      YValues.Title.Font.Height := -12;
      YValues.Title.Font.Name := 'Segoe UI';
      YValues.Title.Font.Style := [];
      YValues.Title.TextMargins.Left := 0;
      YValues.Title.TextMargins.Top := 0;
      YValues.Title.TextMargins.Right := 0;
      YValues.Title.TextMargins.Bottom := 0;
      YValues.SpiderValues := False;
      YValues.Positions := [];
      Crosshair.XTextStroke.Color := 12275349;
      Crosshair.XTextFill.Color := 12275349;
      Crosshair.XTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.XTextFont.Color := clWhite;
      Crosshair.XTextFont.Height := -12;
      Crosshair.XTextFont.Name := 'Segoe UI';
      Crosshair.XTextFont.Style := [];
      Crosshair.YTextStroke.Color := 12275349;
      Crosshair.YTextFill.Color := 12275349;
      Crosshair.YTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.YTextFont.Color := clWhite;
      Crosshair.YTextFont.Height := -12;
      Crosshair.YTextFont.Name := 'Segoe UI';
      Crosshair.YTextFont.Style := [];
      Crosshair.HorizontalLineStroke.Color := 12275349;
      Crosshair.VerticalLineStroke.Color := 12275349;
    end;
    cCompanyRevenue.Title.Stroke.Kind := gskSolid;
    cCompanyRevenue.Title.Font.Charset := DEFAULT_CHARSET;
    cCompanyRevenue.Title.Font.Color := clWindowText;
    cCompanyRevenue.Title.Font.Height := -12;
    cCompanyRevenue.Title.Font.Name := 'Segoe UI';
    cCompanyRevenue.Title.Font.Style := [];
    cCompanyRevenue.Title.Height := 35.000000000000000000;
    cCompanyRevenue.Title.TextMargins.Left := 3;
    cCompanyRevenue.Title.TextMargins.Top := 3;
    cCompanyRevenue.Title.TextMargins.Right := 3;
    cCompanyRevenue.Title.TextMargins.Bottom := 3;
    cCompanyRevenue.Title.Text := 'Total Loads Revenue';
    cCompanyRevenue.XAxis.Stroke.Kind := gskSolid;
    cCompanyRevenue.XAxis.AutoSize := False;
    cCompanyRevenue.XAxis.Height := 35.000000000000000000;
    cCompanyRevenue.YAxis.Stroke.Kind := gskSolid;
    cCompanyRevenue.YAxis.Width := 35.000000000000000000;
    cCompanyRevenue.DefaultLoadOptions.XValuesFormatString := '%.0f';
    cCompanyRevenue.DefaultLoadOptions.YValuesFormatString := '%.2f';
    cCompanyRevenue.DefaultLoadOptions.MaxYOffsetPercentage := 5.000000000000000000;
    cCompanyRevenue.Align := alTop;
    cCompanyRevenue.TabOrder := 0;
    wpOwnFleet.SetParentComponent(WebScrollBox1);
    wpOwnFleet.Name := 'wpOwnFleet';
    wpOwnFleet.Left := 0;
    wpOwnFleet.Top := 405;
    wpOwnFleet.Width := 1024;
    wpOwnFleet.Height := 440;
    wpOwnFleet.Align := alTop;
    wpOwnFleet.ChildOrder := 2;
    wpOwnFleet.TabOrder := 1;
    wpOwnFleetInfo.SetParentComponent(wpOwnFleet);
    wpOwnFleetInfo.Name := 'wpOwnFleetInfo';
    wpOwnFleetInfo.Left := 0;
    wpOwnFleetInfo.Top := 0;
    wpOwnFleetInfo.Width := 1024;
    wpOwnFleetInfo.Height := 41;
    wpOwnFleetInfo.Align := alTop;
    wpOwnFleetInfo.Caption := 'Own Fleet Information';
    wpOwnFleetInfo.Color := clBlack;
    wpOwnFleetInfo.Font.Charset := DEFAULT_CHARSET;
    wpOwnFleetInfo.Font.Color := clWhite;
    wpOwnFleetInfo.Font.Height := -12;
    wpOwnFleetInfo.Font.Name := 'Segoe UI';
    wpOwnFleetInfo.Font.Style := [fsBold];
    wpOwnFleetInfo.ParentFont := False;
    wpOwnFleetInfo.TabOrder := 0;
    wpOwnFleetButtons.SetParentComponent(wpOwnFleet);
    wpOwnFleetButtons.Name := 'wpOwnFleetButtons';
    wpOwnFleetButtons.Left := 0;
    wpOwnFleetButtons.Top := 391;
    wpOwnFleetButtons.Width := 1024;
    wpOwnFleetButtons.Height := 49;
    wpOwnFleetButtons.Align := alBottom;
    wpOwnFleetButtons.ChildOrder := 1;
    wpOwnFleetButtons.TabOrder := 1;
    TMSFNCButton1.SetParentComponent(wpOwnFleetButtons);
    TMSFNCButton1.Name := 'TMSFNCButton1';
    TMSFNCButton1.Left := 8;
    TMSFNCButton1.Top := 10;
    TMSFNCButton1.Width := 145;
    TMSFNCButton1.Height := 25;
    TMSFNCButton1.Font.Charset := DEFAULT_CHARSET;
    TMSFNCButton1.Font.Color := clWindowText;
    TMSFNCButton1.Font.Height := -12;
    TMSFNCButton1.Font.Name := 'Segoe UI';
    TMSFNCButton1.Font.Style := [];
    TMSFNCButton1.Text := 'Controller Outstanding';
    TMSFNCButton1.TabOrder := 0;
    SetEvent(TMSFNCButton1, Self, 'OnClick', 'TMSFNCButton1Click');
    TMSFNCButton3.SetParentComponent(wpOwnFleetButtons);
    TMSFNCButton3.Name := 'TMSFNCButton3';
    TMSFNCButton3.Left := 358;
    TMSFNCButton3.Top := 10;
    TMSFNCButton3.Width := 145;
    TMSFNCButton3.Height := 25;
    TMSFNCButton3.Font.Charset := DEFAULT_CHARSET;
    TMSFNCButton3.Font.Color := clWindowText;
    TMSFNCButton3.Font.Height := -12;
    TMSFNCButton3.Font.Name := 'Segoe UI';
    TMSFNCButton3.Font.Style := [];
    TMSFNCButton3.Text := 'Loads Not Invoiced';
    TMSFNCButton3.TabOrder := 1;
    SetEvent(TMSFNCButton3, Self, 'OnClick', 'TMSFNCButton3Click');
    wpOwnFleetCount.SetParentComponent(wpOwnFleet);
    wpOwnFleetCount.Name := 'wpOwnFleetCount';
    wpOwnFleetCount.Left := 0;
    wpOwnFleetCount.Top := 41;
    wpOwnFleetCount.Width := 512;
    wpOwnFleetCount.Height := 350;
    wpOwnFleetCount.Align := alLeft;
    wpOwnFleetCount.ChildOrder := 2;
    wpOwnFleetCount.TabOrder := 2;
    cOwnFleetCount.SetParentComponent(wpOwnFleetCount);
    cOwnFleetCount.Name := 'cOwnFleetCount';
    cOwnFleetCount.Left := 0;
    cOwnFleetCount.Top := 0;
    cOwnFleetCount.Width := 512;
    cOwnFleetCount.Height := 350;
    cOwnFleetCount.Appearance.ColorList.Clear;
    with cOwnFleetCount.Appearance.ColorList.Add do
    begin
      Color := 16105559;
    end;
    with cOwnFleetCount.Appearance.ColorList.Add do
    begin
      Color := 5644279;
    end;
    with cOwnFleetCount.Appearance.ColorList.Add do
    begin
      Color := 7936771;
    end;
    with cOwnFleetCount.Appearance.ColorList.Add do
    begin
      Color := 12275349;
    end;
    with cOwnFleetCount.Appearance.ColorList.Add do
    begin
      Color := 1296366;
    end;
    with cOwnFleetCount.Appearance.ColorList.Add do
    begin
      Color := 4350195;
    end;
    with cOwnFleetCount.Appearance.ColorList.Add do
    begin
      Color := 16544551;
    end;
    with cOwnFleetCount.Appearance.ColorList.Add do
    begin
      Color := 5820321;
    end;
    with cOwnFleetCount.Appearance.ColorList.Add do
    begin
      Color := 10922240;
    end;
    with cOwnFleetCount.Appearance.ColorList.Add do
    begin
      Color := 16376965;
    end;
    cOwnFleetCount.Appearance.GlobalFont.Color := -1;
    cOwnFleetCount.Appearance.GlobalFont.Scale := 1.000000000000000000;
    cOwnFleetCount.Appearance.GlobalFont.Style := [];
    cOwnFleetCount.Appearance.ColorScheme := ccsColorList;
    cOwnFleetCount.Appearance.MonochromeColor := clSteelblue;
    cOwnFleetCount.ClickMargin := 10.000000000000000000;
    cOwnFleetCount.Legend.Fill.Kind := gfkSolid;
    cOwnFleetCount.Legend.Stroke.Kind := gskSolid;
    cOwnFleetCount.Legend.Font.Charset := DEFAULT_CHARSET;
    cOwnFleetCount.Legend.Font.Color := clWindowText;
    cOwnFleetCount.Legend.Font.Height := -12;
    cOwnFleetCount.Legend.Font.Name := 'Segoe UI';
    cOwnFleetCount.Legend.Font.Style := [];
    cOwnFleetCount.Legend.Left := -10.000000000000000000;
    cOwnFleetCount.Legend.Position := lpTopRight;
    cOwnFleetCount.Legend.Top := 10.000000000000000000;
    cOwnFleetCount.SeriesMargins.Left := 0;
    cOwnFleetCount.SeriesMargins.Top := 15;
    cOwnFleetCount.SeriesMargins.Right := 0;
    cOwnFleetCount.SeriesMargins.Bottom := 0;
    cOwnFleetCount.Series.Clear;
    with cOwnFleetCount.Series.Add do
    begin
      AnimationFactor := 4.000000000000000000;
      AutoXRange := arEnabled;
      AutoYRange := arCommonZeroBased;
      Bar.Width := 65.000000000000000000;
      Bar.Spacing := 20.000000000000000000;
      MultiPoint.Width := 65.000000000000000000;
      Pie.Size := 200.000000000000000000;
      Pie.Margins.Left := 10;
      Pie.Margins.Top := 10;
      Pie.Margins.Right := 10;
      Pie.Margins.Bottom := 10;
      Pie.SweepAngle := 360.000000000000000000;
      ChartType := ctBar;
      Fill.Color := 16105559;
      LegendText := 'Loads';
      Labels.Font.Charset := DEFAULT_CHARSET;
      Labels.Font.Color := clWindowText;
      Labels.Font.Height := -12;
      Labels.Font.Name := 'Segoe UI';
      Labels.Font.Style := [];
      Labels.Format := '%.0f';
      Labels.OffsetY := 5.000000000000000000;
      Labels.Visible := True;
      Markers.Fill.Color := 16105559;
      Markers.Height := 10.000000000000000000;
      Markers.Stroke.Color := 8020012;
      Markers.Width := 10.000000000000000000;
      MaxX := 10.000000000000000000;
      MaxY := 10.000000000000000000;
      Offset3DX := 15.000000000000000000;
      Offset3DY := 15.000000000000000000;
      Legend.Font.Charset := DEFAULT_CHARSET;
      Legend.Font.Color := clWindowText;
      Legend.Font.Height := -12;
      Legend.Font.Name := 'Segoe UI';
      Legend.Font.Style := [];
      Legend.Left := -10.000000000000000000;
      Stroke.Color := 16105559;
      XValues.MajorUnit := 1.000000000000000000;
      XValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MajorUnitFont.Color := clWindowText;
      XValues.MajorUnitFont.Height := -12;
      XValues.MajorUnitFont.Name := 'Segoe UI';
      XValues.MajorUnitFont.Style := [];
      XValues.MajorUnitFormat := '%.0f';
      XValues.MajorUnitSpacing := 5.000000000000000000;
      XValues.MajorUnitTickMarkSize := 10.000000000000000000;
      XValues.MajorUnitTickMarkColor := clSilver;
      XValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MinorUnitFont.Color := clWindowText;
      XValues.MinorUnitFont.Height := -12;
      XValues.MinorUnitFont.Name := 'Segoe UI';
      XValues.MinorUnitFont.Style := [];
      XValues.MinorUnitFormat := '%.0f';
      XValues.MinorUnitSpacing := 5.000000000000000000;
      XValues.MinorUnitTickMarkSize := 7.000000000000000000;
      XValues.MinorUnitTickMarkColor := clSilver;
      XValues.Title.Font.Charset := DEFAULT_CHARSET;
      XValues.Title.Font.Color := clWindowText;
      XValues.Title.Font.Height := -12;
      XValues.Title.Font.Name := 'Segoe UI';
      XValues.Title.Font.Style := [];
      XValues.Title.TextMargins.Left := 0;
      XValues.Title.TextMargins.Top := 0;
      XValues.Title.TextMargins.Right := 0;
      XValues.Title.TextMargins.Bottom := 0;
      YValues.MajorUnit := 1.000000000000000000;
      YValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MajorUnitFont.Color := clWindowText;
      YValues.MajorUnitFont.Height := -12;
      YValues.MajorUnitFont.Name := 'Segoe UI';
      YValues.MajorUnitFont.Style := [];
      YValues.MajorUnitFormat := '%.0f';
      YValues.MajorUnitSpacing := 5.000000000000000000;
      YValues.MajorUnitTickMarkSize := 10.000000000000000000;
      YValues.MajorUnitTickMarkColor := clSilver;
      YValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MinorUnitFont.Color := clWindowText;
      YValues.MinorUnitFont.Height := -12;
      YValues.MinorUnitFont.Name := 'Segoe UI';
      YValues.MinorUnitFont.Style := [];
      YValues.MinorUnitFormat := '%.0f';
      YValues.MinorUnitSpacing := 5.000000000000000000;
      YValues.MinorUnitTickMarkSize := 7.000000000000000000;
      YValues.MinorUnitTickMarkColor := clSilver;
      YValues.Title.Font.Charset := DEFAULT_CHARSET;
      YValues.Title.Font.Color := clWindowText;
      YValues.Title.Font.Height := -12;
      YValues.Title.Font.Name := 'Segoe UI';
      YValues.Title.Font.Style := [];
      YValues.Title.TextMargins.Left := 0;
      YValues.Title.TextMargins.Top := 0;
      YValues.Title.TextMargins.Right := 0;
      YValues.Title.TextMargins.Bottom := 0;
      YValues.SpiderValues := False;
      Crosshair.XTextStroke.Color := 16105559;
      Crosshair.XTextFill.Color := 16105559;
      Crosshair.XTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.XTextFont.Color := clWhite;
      Crosshair.XTextFont.Height := -12;
      Crosshair.XTextFont.Name := 'Segoe UI';
      Crosshair.XTextFont.Style := [];
      Crosshair.YTextStroke.Color := 16105559;
      Crosshair.YTextFill.Color := 16105559;
      Crosshair.YTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.YTextFont.Color := clWhite;
      Crosshair.YTextFont.Height := -12;
      Crosshair.YTextFont.Name := 'Segoe UI';
      Crosshair.YTextFont.Style := [];
      Crosshair.HorizontalLineStroke.Color := 16105559;
      Crosshair.VerticalLineStroke.Color := 16105559;
    end;
    with cOwnFleetCount.Series.Add do
    begin
      AnimationFactor := 4.000000000000000000;
      AutoXRange := arEnabled;
      AutoYRange := arCommonZeroBased;
      Bar.Width := 65.000000000000000000;
      Bar.Spacing := 20.000000000000000000;
      MultiPoint.Width := 65.000000000000000000;
      Pie.Size := 200.000000000000000000;
      Pie.Margins.Left := 10;
      Pie.Margins.Top := 10;
      Pie.Margins.Right := 10;
      Pie.Margins.Bottom := 10;
      Pie.SweepAngle := 360.000000000000000000;
      ChartType := ctBar;
      Fill.Color := 5644279;
      LegendText := 'Invoiced';
      Labels.Font.Charset := DEFAULT_CHARSET;
      Labels.Font.Color := clWindowText;
      Labels.Font.Height := -12;
      Labels.Font.Name := 'Segoe UI';
      Labels.Font.Style := [];
      Labels.Format := '%.0f';
      Labels.OffsetY := 5.000000000000000000;
      Labels.Visible := True;
      Markers.Fill.Color := 5644279;
      Markers.Height := 10.000000000000000000;
      Markers.Stroke.Color := 2822268;
      Markers.Width := 10.000000000000000000;
      MaxX := 10.000000000000000000;
      MaxY := 10.000000000000000000;
      Offset3DX := 15.000000000000000000;
      Offset3DY := 15.000000000000000000;
      Legend.Font.Charset := DEFAULT_CHARSET;
      Legend.Font.Color := clWindowText;
      Legend.Font.Height := -12;
      Legend.Font.Name := 'Segoe UI';
      Legend.Font.Style := [];
      Legend.Left := -10.000000000000000000;
      Stroke.Color := 5644279;
      XValues.MajorUnit := 1.000000000000000000;
      XValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MajorUnitFont.Color := clWindowText;
      XValues.MajorUnitFont.Height := -12;
      XValues.MajorUnitFont.Name := 'Segoe UI';
      XValues.MajorUnitFont.Style := [];
      XValues.MajorUnitFormat := '%.0f';
      XValues.MajorUnitSpacing := 5.000000000000000000;
      XValues.MajorUnitTickMarkSize := 10.000000000000000000;
      XValues.MajorUnitTickMarkColor := clSilver;
      XValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MinorUnitFont.Color := clWindowText;
      XValues.MinorUnitFont.Height := -12;
      XValues.MinorUnitFont.Name := 'Segoe UI';
      XValues.MinorUnitFont.Style := [];
      XValues.MinorUnitFormat := '%.0f';
      XValues.MinorUnitSpacing := 5.000000000000000000;
      XValues.MinorUnitTickMarkSize := 7.000000000000000000;
      XValues.MinorUnitTickMarkColor := clSilver;
      XValues.Title.Font.Charset := DEFAULT_CHARSET;
      XValues.Title.Font.Color := clWindowText;
      XValues.Title.Font.Height := -12;
      XValues.Title.Font.Name := 'Segoe UI';
      XValues.Title.Font.Style := [];
      XValues.Title.TextMargins.Left := 0;
      XValues.Title.TextMargins.Top := 0;
      XValues.Title.TextMargins.Right := 0;
      XValues.Title.TextMargins.Bottom := 0;
      YValues.MajorUnit := 1.000000000000000000;
      YValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MajorUnitFont.Color := clWindowText;
      YValues.MajorUnitFont.Height := -12;
      YValues.MajorUnitFont.Name := 'Segoe UI';
      YValues.MajorUnitFont.Style := [];
      YValues.MajorUnitFormat := '%.0f';
      YValues.MajorUnitSpacing := 5.000000000000000000;
      YValues.MajorUnitTickMarkSize := 10.000000000000000000;
      YValues.MajorUnitTickMarkColor := clSilver;
      YValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MinorUnitFont.Color := clWindowText;
      YValues.MinorUnitFont.Height := -12;
      YValues.MinorUnitFont.Name := 'Segoe UI';
      YValues.MinorUnitFont.Style := [];
      YValues.MinorUnitFormat := '%.0f';
      YValues.MinorUnitSpacing := 5.000000000000000000;
      YValues.MinorUnitTickMarkSize := 7.000000000000000000;
      YValues.MinorUnitTickMarkColor := clSilver;
      YValues.Title.Font.Charset := DEFAULT_CHARSET;
      YValues.Title.Font.Color := clWindowText;
      YValues.Title.Font.Height := -12;
      YValues.Title.Font.Name := 'Segoe UI';
      YValues.Title.Font.Style := [];
      YValues.Title.TextMargins.Left := 0;
      YValues.Title.TextMargins.Top := 0;
      YValues.Title.TextMargins.Right := 0;
      YValues.Title.TextMargins.Bottom := 0;
      YValues.SpiderValues := False;
      YValues.Positions := [];
      Crosshair.XTextStroke.Color := 5644279;
      Crosshair.XTextFill.Color := 5644279;
      Crosshair.XTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.XTextFont.Color := clWhite;
      Crosshair.XTextFont.Height := -12;
      Crosshair.XTextFont.Name := 'Segoe UI';
      Crosshair.XTextFont.Style := [];
      Crosshair.YTextStroke.Color := 5644279;
      Crosshair.YTextFill.Color := 5644279;
      Crosshair.YTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.YTextFont.Color := clWhite;
      Crosshair.YTextFont.Height := -12;
      Crosshair.YTextFont.Name := 'Segoe UI';
      Crosshair.YTextFont.Style := [];
      Crosshair.HorizontalLineStroke.Color := 5644279;
      Crosshair.VerticalLineStroke.Color := 5644279;
    end;
    with cOwnFleetCount.Series.Add do
    begin
      AnimationFactor := 4.000000000000000000;
      AutoXRange := arEnabled;
      AutoYRange := arCommonZeroBased;
      Bar.Width := 65.000000000000000000;
      Bar.Spacing := 20.000000000000000000;
      MultiPoint.Width := 65.000000000000000000;
      Pie.Size := 200.000000000000000000;
      Pie.Margins.Left := 10;
      Pie.Margins.Top := 10;
      Pie.Margins.Right := 10;
      Pie.Margins.Bottom := 10;
      Pie.SweepAngle := 360.000000000000000000;
      ChartType := ctBar;
      Fill.Color := 7936771;
      LegendText := 'Not Invoiced';
      Labels.Font.Charset := DEFAULT_CHARSET;
      Labels.Font.Color := clWindowText;
      Labels.Font.Height := -12;
      Labels.Font.Name := 'Segoe UI';
      Labels.Font.Style := [];
      Labels.Format := '%.0f';
      Labels.OffsetY := 5.000000000000000000;
      Labels.Visible := True;
      Markers.Fill.Color := 7936771;
      Markers.Height := 10.000000000000000000;
      Markers.Stroke.Color := 3935746;
      Markers.Width := 10.000000000000000000;
      MaxX := 10.000000000000000000;
      MaxY := 10.000000000000000000;
      Offset3DX := 15.000000000000000000;
      Offset3DY := 15.000000000000000000;
      Legend.Font.Charset := DEFAULT_CHARSET;
      Legend.Font.Color := clWindowText;
      Legend.Font.Height := -12;
      Legend.Font.Name := 'Segoe UI';
      Legend.Font.Style := [];
      Legend.Left := -10.000000000000000000;
      Stroke.Color := 7936771;
      XValues.MajorUnit := 1.000000000000000000;
      XValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MajorUnitFont.Color := clWindowText;
      XValues.MajorUnitFont.Height := -12;
      XValues.MajorUnitFont.Name := 'Segoe UI';
      XValues.MajorUnitFont.Style := [];
      XValues.MajorUnitFormat := '%.0f';
      XValues.MajorUnitSpacing := 5.000000000000000000;
      XValues.MajorUnitTickMarkSize := 10.000000000000000000;
      XValues.MajorUnitTickMarkColor := clSilver;
      XValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MinorUnitFont.Color := clWindowText;
      XValues.MinorUnitFont.Height := -12;
      XValues.MinorUnitFont.Name := 'Segoe UI';
      XValues.MinorUnitFont.Style := [];
      XValues.MinorUnitFormat := '%.0f';
      XValues.MinorUnitSpacing := 5.000000000000000000;
      XValues.MinorUnitTickMarkSize := 7.000000000000000000;
      XValues.MinorUnitTickMarkColor := clSilver;
      XValues.Title.Font.Charset := DEFAULT_CHARSET;
      XValues.Title.Font.Color := clWindowText;
      XValues.Title.Font.Height := -12;
      XValues.Title.Font.Name := 'Segoe UI';
      XValues.Title.Font.Style := [];
      XValues.Title.TextMargins.Left := 0;
      XValues.Title.TextMargins.Top := 0;
      XValues.Title.TextMargins.Right := 0;
      XValues.Title.TextMargins.Bottom := 0;
      YValues.MajorUnit := 1.000000000000000000;
      YValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MajorUnitFont.Color := clWindowText;
      YValues.MajorUnitFont.Height := -12;
      YValues.MajorUnitFont.Name := 'Segoe UI';
      YValues.MajorUnitFont.Style := [];
      YValues.MajorUnitFormat := '%.0f';
      YValues.MajorUnitSpacing := 5.000000000000000000;
      YValues.MajorUnitTickMarkSize := 10.000000000000000000;
      YValues.MajorUnitTickMarkColor := clSilver;
      YValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MinorUnitFont.Color := clWindowText;
      YValues.MinorUnitFont.Height := -12;
      YValues.MinorUnitFont.Name := 'Segoe UI';
      YValues.MinorUnitFont.Style := [];
      YValues.MinorUnitFormat := '%.0f';
      YValues.MinorUnitSpacing := 5.000000000000000000;
      YValues.MinorUnitTickMarkSize := 7.000000000000000000;
      YValues.MinorUnitTickMarkColor := clSilver;
      YValues.Title.Font.Charset := DEFAULT_CHARSET;
      YValues.Title.Font.Color := clWindowText;
      YValues.Title.Font.Height := -12;
      YValues.Title.Font.Name := 'Segoe UI';
      YValues.Title.Font.Style := [];
      YValues.Title.TextMargins.Left := 0;
      YValues.Title.TextMargins.Top := 0;
      YValues.Title.TextMargins.Right := 0;
      YValues.Title.TextMargins.Bottom := 0;
      YValues.SpiderValues := False;
      YValues.Positions := [];
      Crosshair.XTextStroke.Color := 7936771;
      Crosshair.XTextFill.Color := 7936771;
      Crosshair.XTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.XTextFont.Color := clWhite;
      Crosshair.XTextFont.Height := -12;
      Crosshair.XTextFont.Name := 'Segoe UI';
      Crosshair.XTextFont.Style := [];
      Crosshair.YTextStroke.Color := 7936771;
      Crosshair.YTextFill.Color := 7936771;
      Crosshair.YTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.YTextFont.Color := clWhite;
      Crosshair.YTextFont.Height := -12;
      Crosshair.YTextFont.Name := 'Segoe UI';
      Crosshair.YTextFont.Style := [];
      Crosshair.HorizontalLineStroke.Color := 7936771;
      Crosshair.VerticalLineStroke.Color := 7936771;
    end;
    with cOwnFleetCount.Series.Add do
    begin
      AnimationFactor := 4.000000000000000000;
      AutoXRange := arEnabled;
      AutoYRange := arCommonZeroBased;
      Bar.Width := 65.000000000000000000;
      Bar.Spacing := 20.000000000000000000;
      MultiPoint.Width := 65.000000000000000000;
      Pie.Size := 200.000000000000000000;
      Pie.Margins.Left := 10;
      Pie.Margins.Top := 10;
      Pie.Margins.Right := 10;
      Pie.Margins.Bottom := 10;
      Pie.SweepAngle := 360.000000000000000000;
      ChartType := ctBar;
      Fill.Color := 12275349;
      LegendText := 'Not Received';
      Labels.Font.Charset := DEFAULT_CHARSET;
      Labels.Font.Color := clWindowText;
      Labels.Font.Height := -12;
      Labels.Font.Name := 'Segoe UI';
      Labels.Font.Style := [];
      Labels.Format := '%.0f';
      Labels.OffsetY := 5.000000000000000000;
      Labels.Visible := True;
      Markers.Fill.Color := 12275349;
      Markers.Height := 10.000000000000000000;
      Markers.Stroke.Color := 6170442;
      Markers.Width := 10.000000000000000000;
      MaxX := 10.000000000000000000;
      MaxY := 10.000000000000000000;
      Offset3DX := 15.000000000000000000;
      Offset3DY := 15.000000000000000000;
      Legend.Font.Charset := DEFAULT_CHARSET;
      Legend.Font.Color := clWindowText;
      Legend.Font.Height := -12;
      Legend.Font.Name := 'Segoe UI';
      Legend.Font.Style := [];
      Legend.Left := -10.000000000000000000;
      Stroke.Color := 12275349;
      XValues.MajorUnit := 1.000000000000000000;
      XValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MajorUnitFont.Color := clWindowText;
      XValues.MajorUnitFont.Height := -12;
      XValues.MajorUnitFont.Name := 'Segoe UI';
      XValues.MajorUnitFont.Style := [];
      XValues.MajorUnitFormat := '%.0f';
      XValues.MajorUnitSpacing := 5.000000000000000000;
      XValues.MajorUnitTickMarkSize := 10.000000000000000000;
      XValues.MajorUnitTickMarkColor := clSilver;
      XValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MinorUnitFont.Color := clWindowText;
      XValues.MinorUnitFont.Height := -12;
      XValues.MinorUnitFont.Name := 'Segoe UI';
      XValues.MinorUnitFont.Style := [];
      XValues.MinorUnitFormat := '%.0f';
      XValues.MinorUnitSpacing := 5.000000000000000000;
      XValues.MinorUnitTickMarkSize := 7.000000000000000000;
      XValues.MinorUnitTickMarkColor := clSilver;
      XValues.Title.Font.Charset := DEFAULT_CHARSET;
      XValues.Title.Font.Color := clWindowText;
      XValues.Title.Font.Height := -12;
      XValues.Title.Font.Name := 'Segoe UI';
      XValues.Title.Font.Style := [];
      XValues.Title.TextMargins.Left := 0;
      XValues.Title.TextMargins.Top := 0;
      XValues.Title.TextMargins.Right := 0;
      XValues.Title.TextMargins.Bottom := 0;
      YGrid.SpiderVisible := False;
      YValues.MajorUnit := 1.000000000000000000;
      YValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MajorUnitFont.Color := clWindowText;
      YValues.MajorUnitFont.Height := -12;
      YValues.MajorUnitFont.Name := 'Segoe UI';
      YValues.MajorUnitFont.Style := [];
      YValues.MajorUnitFormat := '%.0f';
      YValues.MajorUnitSpacing := 5.000000000000000000;
      YValues.MajorUnitTickMarkSize := 10.000000000000000000;
      YValues.MajorUnitTickMarkColor := clSilver;
      YValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MinorUnitFont.Color := clWindowText;
      YValues.MinorUnitFont.Height := -12;
      YValues.MinorUnitFont.Name := 'Segoe UI';
      YValues.MinorUnitFont.Style := [];
      YValues.MinorUnitFormat := '%.0f';
      YValues.MinorUnitSpacing := 5.000000000000000000;
      YValues.MinorUnitTickMarkSize := 7.000000000000000000;
      YValues.MinorUnitTickMarkColor := clSilver;
      YValues.Title.Font.Charset := DEFAULT_CHARSET;
      YValues.Title.Font.Color := clWindowText;
      YValues.Title.Font.Height := -12;
      YValues.Title.Font.Name := 'Segoe UI';
      YValues.Title.Font.Style := [];
      YValues.Title.TextMargins.Left := 0;
      YValues.Title.TextMargins.Top := 0;
      YValues.Title.TextMargins.Right := 0;
      YValues.Title.TextMargins.Bottom := 0;
      YValues.SpiderValues := False;
      YValues.Positions := [];
      Crosshair.XTextStroke.Color := 12275349;
      Crosshair.XTextFill.Color := 12275349;
      Crosshair.XTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.XTextFont.Color := clWhite;
      Crosshair.XTextFont.Height := -12;
      Crosshair.XTextFont.Name := 'Segoe UI';
      Crosshair.XTextFont.Style := [];
      Crosshair.YTextStroke.Color := 12275349;
      Crosshair.YTextFill.Color := 12275349;
      Crosshair.YTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.YTextFont.Color := clWhite;
      Crosshair.YTextFont.Height := -12;
      Crosshair.YTextFont.Name := 'Segoe UI';
      Crosshair.YTextFont.Style := [];
      Crosshair.HorizontalLineStroke.Color := 12275349;
      Crosshair.VerticalLineStroke.Color := 12275349;
    end;
    cOwnFleetCount.Title.Stroke.Kind := gskSolid;
    cOwnFleetCount.Title.Font.Charset := DEFAULT_CHARSET;
    cOwnFleetCount.Title.Font.Color := clWindowText;
    cOwnFleetCount.Title.Font.Height := -12;
    cOwnFleetCount.Title.Font.Name := 'Segoe UI';
    cOwnFleetCount.Title.Font.Style := [];
    cOwnFleetCount.Title.Height := 35.000000000000000000;
    cOwnFleetCount.Title.TextMargins.Left := 3;
    cOwnFleetCount.Title.TextMargins.Top := 3;
    cOwnFleetCount.Title.TextMargins.Right := 3;
    cOwnFleetCount.Title.TextMargins.Bottom := 3;
    cOwnFleetCount.Title.Text := 'Own Fleet Total Loads Count';
    cOwnFleetCount.XAxis.Stroke.Kind := gskSolid;
    cOwnFleetCount.XAxis.AutoSize := False;
    cOwnFleetCount.XAxis.Height := 35.000000000000000000;
    cOwnFleetCount.YAxis.Stroke.Kind := gskSolid;
    cOwnFleetCount.YAxis.Width := 35.000000000000000000;
    cOwnFleetCount.DefaultLoadOptions.XValuesFormatString := '%.0f';
    cOwnFleetCount.DefaultLoadOptions.YValuesFormatString := '%.2f';
    cOwnFleetCount.DefaultLoadOptions.MaxYOffsetPercentage := 5.000000000000000000;
    cOwnFleetCount.Align := alTop;
    cOwnFleetCount.TabOrder := 0;
    wpOwnFleetRevenue.SetParentComponent(wpOwnFleet);
    wpOwnFleetRevenue.Name := 'wpOwnFleetRevenue';
    wpOwnFleetRevenue.Left := 512;
    wpOwnFleetRevenue.Top := 41;
    wpOwnFleetRevenue.Width := 512;
    wpOwnFleetRevenue.Height := 350;
    wpOwnFleetRevenue.Align := alClient;
    wpOwnFleetRevenue.ChildOrder := 3;
    wpOwnFleetRevenue.TabOrder := 3;
    cOwnFleetRevenue.SetParentComponent(wpOwnFleetRevenue);
    cOwnFleetRevenue.Name := 'cOwnFleetRevenue';
    cOwnFleetRevenue.Left := 0;
    cOwnFleetRevenue.Top := 0;
    cOwnFleetRevenue.Width := 512;
    cOwnFleetRevenue.Height := 350;
    cOwnFleetRevenue.Appearance.ColorList.Clear;
    with cOwnFleetRevenue.Appearance.ColorList.Add do
    begin
      Color := 16105559;
    end;
    with cOwnFleetRevenue.Appearance.ColorList.Add do
    begin
      Color := 5644279;
    end;
    with cOwnFleetRevenue.Appearance.ColorList.Add do
    begin
      Color := 7936771;
    end;
    with cOwnFleetRevenue.Appearance.ColorList.Add do
    begin
      Color := 12275349;
    end;
    with cOwnFleetRevenue.Appearance.ColorList.Add do
    begin
      Color := 1296366;
    end;
    with cOwnFleetRevenue.Appearance.ColorList.Add do
    begin
      Color := 4350195;
    end;
    with cOwnFleetRevenue.Appearance.ColorList.Add do
    begin
      Color := 16544551;
    end;
    with cOwnFleetRevenue.Appearance.ColorList.Add do
    begin
      Color := 5820321;
    end;
    with cOwnFleetRevenue.Appearance.ColorList.Add do
    begin
      Color := 10922240;
    end;
    with cOwnFleetRevenue.Appearance.ColorList.Add do
    begin
      Color := 16376965;
    end;
    cOwnFleetRevenue.Appearance.GlobalFont.Color := -1;
    cOwnFleetRevenue.Appearance.GlobalFont.Scale := 1.000000000000000000;
    cOwnFleetRevenue.Appearance.GlobalFont.Style := [];
    cOwnFleetRevenue.Appearance.ColorScheme := ccsColorList;
    cOwnFleetRevenue.Appearance.MonochromeColor := clSteelblue;
    cOwnFleetRevenue.ClickMargin := 10.000000000000000000;
    cOwnFleetRevenue.Legend.Fill.Kind := gfkSolid;
    cOwnFleetRevenue.Legend.Stroke.Kind := gskSolid;
    cOwnFleetRevenue.Legend.Font.Charset := DEFAULT_CHARSET;
    cOwnFleetRevenue.Legend.Font.Color := clWindowText;
    cOwnFleetRevenue.Legend.Font.Height := -12;
    cOwnFleetRevenue.Legend.Font.Name := 'Segoe UI';
    cOwnFleetRevenue.Legend.Font.Style := [];
    cOwnFleetRevenue.Legend.Left := -10.000000000000000000;
    cOwnFleetRevenue.Legend.Position := lpTopRight;
    cOwnFleetRevenue.Legend.Top := 10.000000000000000000;
    cOwnFleetRevenue.SeriesMargins.Left := 0;
    cOwnFleetRevenue.SeriesMargins.Top := 15;
    cOwnFleetRevenue.SeriesMargins.Right := 0;
    cOwnFleetRevenue.SeriesMargins.Bottom := 0;
    cOwnFleetRevenue.Series.Clear;
    with cOwnFleetRevenue.Series.Add do
    begin
      AnimationFactor := 4.000000000000000000;
      AutoXRange := arEnabled;
      AutoYRange := arCommonZeroBased;
      Bar.Width := 65.000000000000000000;
      Bar.Spacing := 20.000000000000000000;
      MultiPoint.Width := 65.000000000000000000;
      Pie.Size := 200.000000000000000000;
      Pie.Margins.Left := 10;
      Pie.Margins.Top := 10;
      Pie.Margins.Right := 10;
      Pie.Margins.Bottom := 10;
      Pie.SweepAngle := 360.000000000000000000;
      ChartType := ctBar;
      Fill.Color := clGreen;
      LegendText := 'Loads';
      Labels.Font.Charset := DEFAULT_CHARSET;
      Labels.Font.Color := clWindowText;
      Labels.Font.Height := -12;
      Labels.Font.Name := 'Segoe UI';
      Labels.Font.Style := [];
      Labels.Format := '#,##0';
      Labels.FormatType := vftFloat;
      Labels.OffsetY := 5.000000000000000000;
      Labels.Visible := True;
      Markers.Fill.Color := 16105559;
      Markers.Height := 10.000000000000000000;
      Markers.Stroke.Color := 8020012;
      Markers.Width := 10.000000000000000000;
      MaxX := 10.000000000000000000;
      MaxY := 10.000000000000000000;
      Offset3DX := 15.000000000000000000;
      Offset3DY := 15.000000000000000000;
      Legend.Font.Charset := DEFAULT_CHARSET;
      Legend.Font.Color := clWindowText;
      Legend.Font.Height := -12;
      Legend.Font.Name := 'Segoe UI';
      Legend.Font.Style := [];
      Legend.Left := -10.000000000000000000;
      Stroke.Color := clGreen;
      XValues.MajorUnit := 1.000000000000000000;
      XValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MajorUnitFont.Color := clWindowText;
      XValues.MajorUnitFont.Height := -12;
      XValues.MajorUnitFont.Name := 'Segoe UI';
      XValues.MajorUnitFont.Style := [];
      XValues.MajorUnitFormat := '%.0f';
      XValues.MajorUnitSpacing := 5.000000000000000000;
      XValues.MajorUnitTickMarkSize := 10.000000000000000000;
      XValues.MajorUnitTickMarkColor := clSilver;
      XValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MinorUnitFont.Color := clWindowText;
      XValues.MinorUnitFont.Height := -12;
      XValues.MinorUnitFont.Name := 'Segoe UI';
      XValues.MinorUnitFont.Style := [];
      XValues.MinorUnitFormat := '%.0f';
      XValues.MinorUnitSpacing := 5.000000000000000000;
      XValues.MinorUnitTickMarkSize := 7.000000000000000000;
      XValues.MinorUnitTickMarkColor := clSilver;
      XValues.Title.Font.Charset := DEFAULT_CHARSET;
      XValues.Title.Font.Color := clWindowText;
      XValues.Title.Font.Height := -12;
      XValues.Title.Font.Name := 'Segoe UI';
      XValues.Title.Font.Style := [];
      XValues.Title.TextMargins.Left := 0;
      XValues.Title.TextMargins.Top := 0;
      XValues.Title.TextMargins.Right := 0;
      XValues.Title.TextMargins.Bottom := 0;
      YValues.MajorUnit := 1.000000000000000000;
      YValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MajorUnitFont.Color := clWindowText;
      YValues.MajorUnitFont.Height := -12;
      YValues.MajorUnitFont.Name := 'Segoe UI';
      YValues.MajorUnitFont.Style := [];
      YValues.MajorUnitFormat := '#,##0';
      YValues.MajorUnitFormatType := vftFloat;
      YValues.MajorUnitSpacing := 5.000000000000000000;
      YValues.MajorUnitTickMarkSize := 10.000000000000000000;
      YValues.MajorUnitTickMarkColor := clSilver;
      YValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MinorUnitFont.Color := clWindowText;
      YValues.MinorUnitFont.Height := -12;
      YValues.MinorUnitFont.Name := 'Segoe UI';
      YValues.MinorUnitFont.Style := [];
      YValues.MinorUnitFormat := '#,##0';
      YValues.MinorUnitFormatType := vftFloat;
      YValues.MinorUnitSpacing := 5.000000000000000000;
      YValues.MinorUnitTickMarkSize := 7.000000000000000000;
      YValues.MinorUnitTickMarkColor := clSilver;
      YValues.Title.Font.Charset := DEFAULT_CHARSET;
      YValues.Title.Font.Color := clWindowText;
      YValues.Title.Font.Height := -12;
      YValues.Title.Font.Name := 'Segoe UI';
      YValues.Title.Font.Style := [];
      YValues.Title.TextMargins.Left := 0;
      YValues.Title.TextMargins.Top := 0;
      YValues.Title.TextMargins.Right := 0;
      YValues.Title.TextMargins.Bottom := 0;
      YValues.SpiderValues := False;
      Crosshair.XTextStroke.Color := 16105559;
      Crosshair.XTextFill.Color := 16105559;
      Crosshair.XTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.XTextFont.Color := clWhite;
      Crosshair.XTextFont.Height := -12;
      Crosshair.XTextFont.Name := 'Segoe UI';
      Crosshair.XTextFont.Style := [];
      Crosshair.YTextStroke.Color := 16105559;
      Crosshair.YTextFill.Color := 16105559;
      Crosshair.YTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.YTextFont.Color := clWhite;
      Crosshair.YTextFont.Height := -12;
      Crosshair.YTextFont.Name := 'Segoe UI';
      Crosshair.YTextFont.Style := [];
      Crosshair.HorizontalLineStroke.Color := 16105559;
      Crosshair.VerticalLineStroke.Color := 16105559;
    end;
    with cOwnFleetRevenue.Series.Add do
    begin
      AnimationFactor := 4.000000000000000000;
      AutoXRange := arEnabled;
      AutoYRange := arCommonZeroBased;
      Bar.Width := 65.000000000000000000;
      Bar.Spacing := 20.000000000000000000;
      MultiPoint.Width := 65.000000000000000000;
      Pie.Size := 200.000000000000000000;
      Pie.Margins.Left := 10;
      Pie.Margins.Top := 10;
      Pie.Margins.Right := 10;
      Pie.Margins.Bottom := 10;
      Pie.SweepAngle := 360.000000000000000000;
      ChartType := ctBar;
      Fill.Color := 5644279;
      LegendText := 'Invoiced';
      Labels.Font.Charset := DEFAULT_CHARSET;
      Labels.Font.Color := clWindowText;
      Labels.Font.Height := -12;
      Labels.Font.Name := 'Segoe UI';
      Labels.Font.Style := [];
      Labels.Format := '#,##0';
      Labels.FormatType := vftFloat;
      Labels.OffsetY := 5.000000000000000000;
      Labels.Visible := True;
      Markers.Fill.Color := 5644279;
      Markers.Height := 10.000000000000000000;
      Markers.Stroke.Color := 2822268;
      Markers.Width := 10.000000000000000000;
      MaxX := 10.000000000000000000;
      MaxY := 10.000000000000000000;
      Offset3DX := 15.000000000000000000;
      Offset3DY := 15.000000000000000000;
      Legend.Font.Charset := DEFAULT_CHARSET;
      Legend.Font.Color := clWindowText;
      Legend.Font.Height := -12;
      Legend.Font.Name := 'Segoe UI';
      Legend.Font.Style := [];
      Legend.Left := -10.000000000000000000;
      Stroke.Color := 5644279;
      XValues.MajorUnit := 1.000000000000000000;
      XValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MajorUnitFont.Color := clWindowText;
      XValues.MajorUnitFont.Height := -12;
      XValues.MajorUnitFont.Name := 'Segoe UI';
      XValues.MajorUnitFont.Style := [];
      XValues.MajorUnitFormat := '%.0f';
      XValues.MajorUnitSpacing := 5.000000000000000000;
      XValues.MajorUnitTickMarkSize := 10.000000000000000000;
      XValues.MajorUnitTickMarkColor := clSilver;
      XValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MinorUnitFont.Color := clWindowText;
      XValues.MinorUnitFont.Height := -12;
      XValues.MinorUnitFont.Name := 'Segoe UI';
      XValues.MinorUnitFont.Style := [];
      XValues.MinorUnitFormat := '%.0f';
      XValues.MinorUnitSpacing := 5.000000000000000000;
      XValues.MinorUnitTickMarkSize := 7.000000000000000000;
      XValues.MinorUnitTickMarkColor := clSilver;
      XValues.Title.Font.Charset := DEFAULT_CHARSET;
      XValues.Title.Font.Color := clWindowText;
      XValues.Title.Font.Height := -12;
      XValues.Title.Font.Name := 'Segoe UI';
      XValues.Title.Font.Style := [];
      XValues.Title.TextMargins.Left := 0;
      XValues.Title.TextMargins.Top := 0;
      XValues.Title.TextMargins.Right := 0;
      XValues.Title.TextMargins.Bottom := 0;
      YValues.MajorUnit := 1.000000000000000000;
      YValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MajorUnitFont.Color := clWindowText;
      YValues.MajorUnitFont.Height := -12;
      YValues.MajorUnitFont.Name := 'Segoe UI';
      YValues.MajorUnitFont.Style := [];
      YValues.MajorUnitFormat := '#,##0';
      YValues.MajorUnitFormatType := vftFloat;
      YValues.MajorUnitSpacing := 5.000000000000000000;
      YValues.MajorUnitTickMarkSize := 10.000000000000000000;
      YValues.MajorUnitTickMarkColor := clSilver;
      YValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MinorUnitFont.Color := clWindowText;
      YValues.MinorUnitFont.Height := -12;
      YValues.MinorUnitFont.Name := 'Segoe UI';
      YValues.MinorUnitFont.Style := [];
      YValues.MinorUnitFormat := '#,##0';
      YValues.MinorUnitFormatType := vftFloat;
      YValues.MinorUnitSpacing := 5.000000000000000000;
      YValues.MinorUnitTickMarkSize := 7.000000000000000000;
      YValues.MinorUnitTickMarkColor := clSilver;
      YValues.Title.Font.Charset := DEFAULT_CHARSET;
      YValues.Title.Font.Color := clWindowText;
      YValues.Title.Font.Height := -12;
      YValues.Title.Font.Name := 'Segoe UI';
      YValues.Title.Font.Style := [];
      YValues.Title.TextMargins.Left := 0;
      YValues.Title.TextMargins.Top := 0;
      YValues.Title.TextMargins.Right := 0;
      YValues.Title.TextMargins.Bottom := 0;
      YValues.SpiderValues := False;
      YValues.Positions := [];
      Crosshair.XTextStroke.Color := 5644279;
      Crosshair.XTextFill.Color := 5644279;
      Crosshair.XTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.XTextFont.Color := clWhite;
      Crosshair.XTextFont.Height := -12;
      Crosshair.XTextFont.Name := 'Segoe UI';
      Crosshair.XTextFont.Style := [];
      Crosshair.YTextStroke.Color := 5644279;
      Crosshair.YTextFill.Color := 5644279;
      Crosshair.YTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.YTextFont.Color := clWhite;
      Crosshair.YTextFont.Height := -12;
      Crosshair.YTextFont.Name := 'Segoe UI';
      Crosshair.YTextFont.Style := [];
      Crosshair.HorizontalLineStroke.Color := 5644279;
      Crosshair.VerticalLineStroke.Color := 5644279;
    end;
    with cOwnFleetRevenue.Series.Add do
    begin
      AnimationFactor := 4.000000000000000000;
      AutoXRange := arEnabled;
      AutoYRange := arCommonZeroBased;
      Bar.Width := 65.000000000000000000;
      Bar.Spacing := 20.000000000000000000;
      MultiPoint.Width := 65.000000000000000000;
      Pie.Size := 200.000000000000000000;
      Pie.Margins.Left := 10;
      Pie.Margins.Top := 10;
      Pie.Margins.Right := 10;
      Pie.Margins.Bottom := 10;
      Pie.SweepAngle := 360.000000000000000000;
      ChartType := ctBar;
      Fill.Color := clBlue;
      LegendText := 'Not Invoiced';
      Labels.Font.Charset := DEFAULT_CHARSET;
      Labels.Font.Color := clWindowText;
      Labels.Font.Height := -12;
      Labels.Font.Name := 'Segoe UI';
      Labels.Font.Style := [];
      Labels.Format := '#,##0';
      Labels.FormatType := vftFloat;
      Labels.OffsetY := 5.000000000000000000;
      Labels.Visible := True;
      Markers.Fill.Color := 7936771;
      Markers.Height := 10.000000000000000000;
      Markers.Stroke.Color := 3935746;
      Markers.Width := 10.000000000000000000;
      MaxX := 10.000000000000000000;
      MaxY := 10.000000000000000000;
      Offset3DX := 15.000000000000000000;
      Offset3DY := 15.000000000000000000;
      Legend.Font.Charset := DEFAULT_CHARSET;
      Legend.Font.Color := clWindowText;
      Legend.Font.Height := -12;
      Legend.Font.Name := 'Segoe UI';
      Legend.Font.Style := [];
      Legend.Left := -10.000000000000000000;
      Stroke.Color := clBlue;
      XValues.MajorUnit := 1.000000000000000000;
      XValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MajorUnitFont.Color := clWindowText;
      XValues.MajorUnitFont.Height := -12;
      XValues.MajorUnitFont.Name := 'Segoe UI';
      XValues.MajorUnitFont.Style := [];
      XValues.MajorUnitFormat := '%.0f';
      XValues.MajorUnitSpacing := 5.000000000000000000;
      XValues.MajorUnitTickMarkSize := 10.000000000000000000;
      XValues.MajorUnitTickMarkColor := clSilver;
      XValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MinorUnitFont.Color := clWindowText;
      XValues.MinorUnitFont.Height := -12;
      XValues.MinorUnitFont.Name := 'Segoe UI';
      XValues.MinorUnitFont.Style := [];
      XValues.MinorUnitFormat := '%.0f';
      XValues.MinorUnitSpacing := 5.000000000000000000;
      XValues.MinorUnitTickMarkSize := 7.000000000000000000;
      XValues.MinorUnitTickMarkColor := clSilver;
      XValues.Title.Font.Charset := DEFAULT_CHARSET;
      XValues.Title.Font.Color := clWindowText;
      XValues.Title.Font.Height := -12;
      XValues.Title.Font.Name := 'Segoe UI';
      XValues.Title.Font.Style := [];
      XValues.Title.TextMargins.Left := 0;
      XValues.Title.TextMargins.Top := 0;
      XValues.Title.TextMargins.Right := 0;
      XValues.Title.TextMargins.Bottom := 0;
      YValues.MajorUnit := 1.000000000000000000;
      YValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MajorUnitFont.Color := clWindowText;
      YValues.MajorUnitFont.Height := -12;
      YValues.MajorUnitFont.Name := 'Segoe UI';
      YValues.MajorUnitFont.Style := [];
      YValues.MajorUnitFormat := '#,##0';
      YValues.MajorUnitFormatType := vftFloat;
      YValues.MajorUnitSpacing := 5.000000000000000000;
      YValues.MajorUnitTickMarkSize := 10.000000000000000000;
      YValues.MajorUnitTickMarkColor := clSilver;
      YValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MinorUnitFont.Color := clWindowText;
      YValues.MinorUnitFont.Height := -12;
      YValues.MinorUnitFont.Name := 'Segoe UI';
      YValues.MinorUnitFont.Style := [];
      YValues.MinorUnitFormat := '#,##0';
      YValues.MinorUnitFormatType := vftFloat;
      YValues.MinorUnitSpacing := 5.000000000000000000;
      YValues.MinorUnitTickMarkSize := 7.000000000000000000;
      YValues.MinorUnitTickMarkColor := clSilver;
      YValues.Title.Font.Charset := DEFAULT_CHARSET;
      YValues.Title.Font.Color := clWindowText;
      YValues.Title.Font.Height := -12;
      YValues.Title.Font.Name := 'Segoe UI';
      YValues.Title.Font.Style := [];
      YValues.Title.TextMargins.Left := 0;
      YValues.Title.TextMargins.Top := 0;
      YValues.Title.TextMargins.Right := 0;
      YValues.Title.TextMargins.Bottom := 0;
      YValues.SpiderValues := False;
      YValues.Positions := [];
      Crosshair.XTextStroke.Color := 7936771;
      Crosshair.XTextFill.Color := 7936771;
      Crosshair.XTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.XTextFont.Color := clWhite;
      Crosshair.XTextFont.Height := -12;
      Crosshair.XTextFont.Name := 'Segoe UI';
      Crosshair.XTextFont.Style := [];
      Crosshair.YTextStroke.Color := 7936771;
      Crosshair.YTextFill.Color := 7936771;
      Crosshair.YTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.YTextFont.Color := clWhite;
      Crosshair.YTextFont.Height := -12;
      Crosshair.YTextFont.Name := 'Segoe UI';
      Crosshair.YTextFont.Style := [];
      Crosshair.HorizontalLineStroke.Color := 7936771;
      Crosshair.VerticalLineStroke.Color := 7936771;
    end;
    with cOwnFleetRevenue.Series.Add do
    begin
      AnimationFactor := 4.000000000000000000;
      AutoXRange := arEnabled;
      AutoYRange := arCommonZeroBased;
      Bar.Width := 65.000000000000000000;
      Bar.Spacing := 20.000000000000000000;
      MultiPoint.Width := 65.000000000000000000;
      Pie.Size := 200.000000000000000000;
      Pie.Margins.Left := 10;
      Pie.Margins.Top := 10;
      Pie.Margins.Right := 10;
      Pie.Margins.Bottom := 10;
      Pie.SweepAngle := 360.000000000000000000;
      ChartType := ctBar;
      Fill.Color := clLime;
      LegendText := 'Not Received';
      Labels.Font.Charset := DEFAULT_CHARSET;
      Labels.Font.Color := clWindowText;
      Labels.Font.Height := -12;
      Labels.Font.Name := 'Segoe UI';
      Labels.Font.Style := [];
      Labels.Format := '#,##0';
      Labels.FormatType := vftFloat;
      Labels.OffsetY := 5.000000000000000000;
      Labels.Visible := True;
      Markers.Fill.Color := 12275349;
      Markers.Height := 10.000000000000000000;
      Markers.Stroke.Color := 6170442;
      Markers.Width := 10.000000000000000000;
      MaxX := 10.000000000000000000;
      MaxY := 10.000000000000000000;
      Offset3DX := 15.000000000000000000;
      Offset3DY := 15.000000000000000000;
      Legend.Font.Charset := DEFAULT_CHARSET;
      Legend.Font.Color := clWindowText;
      Legend.Font.Height := -12;
      Legend.Font.Name := 'Segoe UI';
      Legend.Font.Style := [];
      Legend.Left := -10.000000000000000000;
      Stroke.Color := clLime;
      XValues.MajorUnit := 1.000000000000000000;
      XValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MajorUnitFont.Color := clWindowText;
      XValues.MajorUnitFont.Height := -12;
      XValues.MajorUnitFont.Name := 'Segoe UI';
      XValues.MajorUnitFont.Style := [];
      XValues.MajorUnitFormat := '%.0f';
      XValues.MajorUnitSpacing := 5.000000000000000000;
      XValues.MajorUnitTickMarkSize := 10.000000000000000000;
      XValues.MajorUnitTickMarkColor := clSilver;
      XValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MinorUnitFont.Color := clWindowText;
      XValues.MinorUnitFont.Height := -12;
      XValues.MinorUnitFont.Name := 'Segoe UI';
      XValues.MinorUnitFont.Style := [];
      XValues.MinorUnitFormat := '%.0f';
      XValues.MinorUnitSpacing := 5.000000000000000000;
      XValues.MinorUnitTickMarkSize := 7.000000000000000000;
      XValues.MinorUnitTickMarkColor := clSilver;
      XValues.Title.Font.Charset := DEFAULT_CHARSET;
      XValues.Title.Font.Color := clWindowText;
      XValues.Title.Font.Height := -12;
      XValues.Title.Font.Name := 'Segoe UI';
      XValues.Title.Font.Style := [];
      XValues.Title.TextMargins.Left := 0;
      XValues.Title.TextMargins.Top := 0;
      XValues.Title.TextMargins.Right := 0;
      XValues.Title.TextMargins.Bottom := 0;
      YGrid.SpiderVisible := False;
      YValues.MajorUnit := 1.000000000000000000;
      YValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MajorUnitFont.Color := clWindowText;
      YValues.MajorUnitFont.Height := -12;
      YValues.MajorUnitFont.Name := 'Segoe UI';
      YValues.MajorUnitFont.Style := [];
      YValues.MajorUnitFormat := '#,##0';
      YValues.MajorUnitFormatType := vftFloat;
      YValues.MajorUnitSpacing := 5.000000000000000000;
      YValues.MajorUnitTickMarkSize := 10.000000000000000000;
      YValues.MajorUnitTickMarkColor := clSilver;
      YValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MinorUnitFont.Color := clWindowText;
      YValues.MinorUnitFont.Height := -12;
      YValues.MinorUnitFont.Name := 'Segoe UI';
      YValues.MinorUnitFont.Style := [];
      YValues.MinorUnitFormat := '#,##0';
      YValues.MinorUnitFormatType := vftFloat;
      YValues.MinorUnitSpacing := 5.000000000000000000;
      YValues.MinorUnitTickMarkSize := 7.000000000000000000;
      YValues.MinorUnitTickMarkColor := clSilver;
      YValues.Title.Font.Charset := DEFAULT_CHARSET;
      YValues.Title.Font.Color := clWindowText;
      YValues.Title.Font.Height := -12;
      YValues.Title.Font.Name := 'Segoe UI';
      YValues.Title.Font.Style := [];
      YValues.Title.TextMargins.Left := 0;
      YValues.Title.TextMargins.Top := 0;
      YValues.Title.TextMargins.Right := 0;
      YValues.Title.TextMargins.Bottom := 0;
      YValues.SpiderValues := False;
      YValues.Positions := [];
      Crosshair.XTextStroke.Color := 12275349;
      Crosshair.XTextFill.Color := 12275349;
      Crosshair.XTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.XTextFont.Color := clWhite;
      Crosshair.XTextFont.Height := -12;
      Crosshair.XTextFont.Name := 'Segoe UI';
      Crosshair.XTextFont.Style := [];
      Crosshair.YTextStroke.Color := 12275349;
      Crosshair.YTextFill.Color := 12275349;
      Crosshair.YTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.YTextFont.Color := clWhite;
      Crosshair.YTextFont.Height := -12;
      Crosshair.YTextFont.Name := 'Segoe UI';
      Crosshair.YTextFont.Style := [];
      Crosshair.HorizontalLineStroke.Color := 12275349;
      Crosshair.VerticalLineStroke.Color := 12275349;
    end;
    cOwnFleetRevenue.Title.Stroke.Kind := gskSolid;
    cOwnFleetRevenue.Title.Font.Charset := DEFAULT_CHARSET;
    cOwnFleetRevenue.Title.Font.Color := clWindowText;
    cOwnFleetRevenue.Title.Font.Height := -12;
    cOwnFleetRevenue.Title.Font.Name := 'Segoe UI';
    cOwnFleetRevenue.Title.Font.Style := [];
    cOwnFleetRevenue.Title.Height := 35.000000000000000000;
    cOwnFleetRevenue.Title.TextMargins.Left := 3;
    cOwnFleetRevenue.Title.TextMargins.Top := 3;
    cOwnFleetRevenue.Title.TextMargins.Right := 3;
    cOwnFleetRevenue.Title.TextMargins.Bottom := 3;
    cOwnFleetRevenue.Title.Text := 'Own Fleet Total Loads Revenue';
    cOwnFleetRevenue.XAxis.Stroke.Kind := gskSolid;
    cOwnFleetRevenue.XAxis.AutoSize := False;
    cOwnFleetRevenue.XAxis.Height := 35.000000000000000000;
    cOwnFleetRevenue.YAxis.Stroke.Kind := gskSolid;
    cOwnFleetRevenue.YAxis.Width := 35.000000000000000000;
    cOwnFleetRevenue.DefaultLoadOptions.XValuesFormatString := '%.0f';
    cOwnFleetRevenue.DefaultLoadOptions.YValuesFormatString := '%.2f';
    cOwnFleetRevenue.DefaultLoadOptions.MaxYOffsetPercentage := 5.000000000000000000;
    cOwnFleetRevenue.Align := alTop;
    cOwnFleetRevenue.TabOrder := 0;
    wpSubsFleet.SetParentComponent(WebScrollBox1);
    wpSubsFleet.Name := 'wpSubsFleet';
    wpSubsFleet.Left := 0;
    wpSubsFleet.Top := 845;
    wpSubsFleet.Width := 1024;
    wpSubsFleet.Height := 440;
    wpSubsFleet.Align := alTop;
    wpSubsFleet.ChildOrder := 2;
    wpSubsFleet.TabOrder := 2;
    wpSubsFleetInfo.SetParentComponent(wpSubsFleet);
    wpSubsFleetInfo.Name := 'wpSubsFleetInfo';
    wpSubsFleetInfo.Left := 0;
    wpSubsFleetInfo.Top := 0;
    wpSubsFleetInfo.Width := 1024;
    wpSubsFleetInfo.Height := 41;
    wpSubsFleetInfo.Align := alTop;
    wpSubsFleetInfo.Caption := 'Subs Fleet Information';
    wpSubsFleetInfo.Color := clBlack;
    wpSubsFleetInfo.Font.Charset := DEFAULT_CHARSET;
    wpSubsFleetInfo.Font.Color := clWhite;
    wpSubsFleetInfo.Font.Height := -12;
    wpSubsFleetInfo.Font.Name := 'Segoe UI';
    wpSubsFleetInfo.Font.Style := [fsBold];
    wpSubsFleetInfo.ParentFont := False;
    wpSubsFleetInfo.TabOrder := 0;
    wpSubsFleetButtons.SetParentComponent(wpSubsFleet);
    wpSubsFleetButtons.Name := 'wpSubsFleetButtons';
    wpSubsFleetButtons.Left := 0;
    wpSubsFleetButtons.Top := 391;
    wpSubsFleetButtons.Width := 1024;
    wpSubsFleetButtons.Height := 49;
    wpSubsFleetButtons.Align := alBottom;
    wpSubsFleetButtons.ChildOrder := 1;
    wpSubsFleetButtons.TabOrder := 1;
    TMSFNCButton2.SetParentComponent(wpSubsFleetButtons);
    TMSFNCButton2.Name := 'TMSFNCButton2';
    TMSFNCButton2.Left := 8;
    TMSFNCButton2.Top := 14;
    TMSFNCButton2.Width := 145;
    TMSFNCButton2.Height := 25;
    TMSFNCButton2.Font.Charset := DEFAULT_CHARSET;
    TMSFNCButton2.Font.Color := clWindowText;
    TMSFNCButton2.Font.Height := -12;
    TMSFNCButton2.Font.Name := 'Segoe UI';
    TMSFNCButton2.Font.Style := [];
    TMSFNCButton2.Text := 'Controller Outstanding';
    TMSFNCButton2.TabOrder := 0;
    SetEvent(TMSFNCButton2, Self, 'OnClick', 'TMSFNCButton2Click');
    wpSubsFleetCount.SetParentComponent(wpSubsFleet);
    wpSubsFleetCount.Name := 'wpSubsFleetCount';
    wpSubsFleetCount.Left := 0;
    wpSubsFleetCount.Top := 41;
    wpSubsFleetCount.Width := 512;
    wpSubsFleetCount.Height := 350;
    wpSubsFleetCount.Align := alLeft;
    wpSubsFleetCount.ChildOrder := 2;
    wpSubsFleetCount.TabOrder := 2;
    cSubsFleetCount.SetParentComponent(wpSubsFleetCount);
    cSubsFleetCount.Name := 'cSubsFleetCount';
    cSubsFleetCount.Left := 0;
    cSubsFleetCount.Top := 0;
    cSubsFleetCount.Width := 512;
    cSubsFleetCount.Height := 350;
    cSubsFleetCount.Appearance.ColorList.Clear;
    with cSubsFleetCount.Appearance.ColorList.Add do
    begin
      Color := 16105559;
    end;
    with cSubsFleetCount.Appearance.ColorList.Add do
    begin
      Color := 5644279;
    end;
    with cSubsFleetCount.Appearance.ColorList.Add do
    begin
      Color := 7936771;
    end;
    with cSubsFleetCount.Appearance.ColorList.Add do
    begin
      Color := 12275349;
    end;
    with cSubsFleetCount.Appearance.ColorList.Add do
    begin
      Color := 1296366;
    end;
    with cSubsFleetCount.Appearance.ColorList.Add do
    begin
      Color := 4350195;
    end;
    with cSubsFleetCount.Appearance.ColorList.Add do
    begin
      Color := 16544551;
    end;
    with cSubsFleetCount.Appearance.ColorList.Add do
    begin
      Color := 5820321;
    end;
    with cSubsFleetCount.Appearance.ColorList.Add do
    begin
      Color := 10922240;
    end;
    with cSubsFleetCount.Appearance.ColorList.Add do
    begin
      Color := 16376965;
    end;
    cSubsFleetCount.Appearance.GlobalFont.Color := -1;
    cSubsFleetCount.Appearance.GlobalFont.Scale := 1.000000000000000000;
    cSubsFleetCount.Appearance.GlobalFont.Style := [];
    cSubsFleetCount.Appearance.ColorScheme := ccsColorList;
    cSubsFleetCount.Appearance.MonochromeColor := clSteelblue;
    cSubsFleetCount.ClickMargin := 10.000000000000000000;
    cSubsFleetCount.Legend.Fill.Kind := gfkSolid;
    cSubsFleetCount.Legend.Stroke.Kind := gskSolid;
    cSubsFleetCount.Legend.Font.Charset := DEFAULT_CHARSET;
    cSubsFleetCount.Legend.Font.Color := clWindowText;
    cSubsFleetCount.Legend.Font.Height := -12;
    cSubsFleetCount.Legend.Font.Name := 'Segoe UI';
    cSubsFleetCount.Legend.Font.Style := [];
    cSubsFleetCount.Legend.Left := -10.000000000000000000;
    cSubsFleetCount.Legend.Position := lpTopRight;
    cSubsFleetCount.Legend.Top := 10.000000000000000000;
    cSubsFleetCount.SeriesMargins.Left := 0;
    cSubsFleetCount.SeriesMargins.Top := 15;
    cSubsFleetCount.SeriesMargins.Right := 0;
    cSubsFleetCount.SeriesMargins.Bottom := 0;
    cSubsFleetCount.Series.Clear;
    with cSubsFleetCount.Series.Add do
    begin
      AnimationFactor := 4.000000000000000000;
      AutoXRange := arEnabled;
      AutoYRange := arCommonZeroBased;
      Bar.Width := 65.000000000000000000;
      Bar.Spacing := 20.000000000000000000;
      MultiPoint.Width := 65.000000000000000000;
      Pie.Size := 200.000000000000000000;
      Pie.Margins.Left := 10;
      Pie.Margins.Top := 10;
      Pie.Margins.Right := 10;
      Pie.Margins.Bottom := 10;
      Pie.SweepAngle := 360.000000000000000000;
      ChartType := ctBar;
      Fill.Color := 16105559;
      LegendText := 'Loads';
      Labels.Font.Charset := DEFAULT_CHARSET;
      Labels.Font.Color := clWindowText;
      Labels.Font.Height := -12;
      Labels.Font.Name := 'Segoe UI';
      Labels.Font.Style := [];
      Labels.Format := '%.0f';
      Labels.OffsetY := 5.000000000000000000;
      Labels.Visible := True;
      Markers.Fill.Color := 16105559;
      Markers.Height := 10.000000000000000000;
      Markers.Stroke.Color := 8020012;
      Markers.Width := 10.000000000000000000;
      MaxX := 10.000000000000000000;
      MaxY := 10.000000000000000000;
      Offset3DX := 15.000000000000000000;
      Offset3DY := 15.000000000000000000;
      Legend.Font.Charset := DEFAULT_CHARSET;
      Legend.Font.Color := clWindowText;
      Legend.Font.Height := -12;
      Legend.Font.Name := 'Segoe UI';
      Legend.Font.Style := [];
      Legend.Left := -10.000000000000000000;
      Stroke.Color := 16105559;
      XValues.MajorUnit := 1.000000000000000000;
      XValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MajorUnitFont.Color := clWindowText;
      XValues.MajorUnitFont.Height := -12;
      XValues.MajorUnitFont.Name := 'Segoe UI';
      XValues.MajorUnitFont.Style := [];
      XValues.MajorUnitFormat := '%.0f';
      XValues.MajorUnitSpacing := 5.000000000000000000;
      XValues.MajorUnitTickMarkSize := 10.000000000000000000;
      XValues.MajorUnitTickMarkColor := clSilver;
      XValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MinorUnitFont.Color := clWindowText;
      XValues.MinorUnitFont.Height := -12;
      XValues.MinorUnitFont.Name := 'Segoe UI';
      XValues.MinorUnitFont.Style := [];
      XValues.MinorUnitFormat := '%.0f';
      XValues.MinorUnitSpacing := 5.000000000000000000;
      XValues.MinorUnitTickMarkSize := 7.000000000000000000;
      XValues.MinorUnitTickMarkColor := clSilver;
      XValues.Title.Font.Charset := DEFAULT_CHARSET;
      XValues.Title.Font.Color := clWindowText;
      XValues.Title.Font.Height := -12;
      XValues.Title.Font.Name := 'Segoe UI';
      XValues.Title.Font.Style := [];
      XValues.Title.TextMargins.Left := 0;
      XValues.Title.TextMargins.Top := 0;
      XValues.Title.TextMargins.Right := 0;
      XValues.Title.TextMargins.Bottom := 0;
      YValues.MajorUnit := 1.000000000000000000;
      YValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MajorUnitFont.Color := clWindowText;
      YValues.MajorUnitFont.Height := -12;
      YValues.MajorUnitFont.Name := 'Segoe UI';
      YValues.MajorUnitFont.Style := [];
      YValues.MajorUnitFormat := '%.0f';
      YValues.MajorUnitSpacing := 5.000000000000000000;
      YValues.MajorUnitTickMarkSize := 10.000000000000000000;
      YValues.MajorUnitTickMarkColor := clSilver;
      YValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MinorUnitFont.Color := clWindowText;
      YValues.MinorUnitFont.Height := -12;
      YValues.MinorUnitFont.Name := 'Segoe UI';
      YValues.MinorUnitFont.Style := [];
      YValues.MinorUnitFormat := '%.0f';
      YValues.MinorUnitSpacing := 5.000000000000000000;
      YValues.MinorUnitTickMarkSize := 7.000000000000000000;
      YValues.MinorUnitTickMarkColor := clSilver;
      YValues.Title.Font.Charset := DEFAULT_CHARSET;
      YValues.Title.Font.Color := clWindowText;
      YValues.Title.Font.Height := -12;
      YValues.Title.Font.Name := 'Segoe UI';
      YValues.Title.Font.Style := [];
      YValues.Title.TextMargins.Left := 0;
      YValues.Title.TextMargins.Top := 0;
      YValues.Title.TextMargins.Right := 0;
      YValues.Title.TextMargins.Bottom := 0;
      YValues.SpiderValues := False;
      Crosshair.XTextStroke.Color := 16105559;
      Crosshair.XTextFill.Color := 16105559;
      Crosshair.XTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.XTextFont.Color := clWhite;
      Crosshair.XTextFont.Height := -12;
      Crosshair.XTextFont.Name := 'Segoe UI';
      Crosshair.XTextFont.Style := [];
      Crosshair.YTextStroke.Color := 16105559;
      Crosshair.YTextFill.Color := 16105559;
      Crosshair.YTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.YTextFont.Color := clWhite;
      Crosshair.YTextFont.Height := -12;
      Crosshair.YTextFont.Name := 'Segoe UI';
      Crosshair.YTextFont.Style := [];
      Crosshair.HorizontalLineStroke.Color := 16105559;
      Crosshair.VerticalLineStroke.Color := 16105559;
    end;
    with cSubsFleetCount.Series.Add do
    begin
      AnimationFactor := 4.000000000000000000;
      AutoXRange := arEnabled;
      AutoYRange := arCommonZeroBased;
      Bar.Width := 65.000000000000000000;
      Bar.Spacing := 20.000000000000000000;
      MultiPoint.Width := 65.000000000000000000;
      Pie.Size := 200.000000000000000000;
      Pie.Margins.Left := 10;
      Pie.Margins.Top := 10;
      Pie.Margins.Right := 10;
      Pie.Margins.Bottom := 10;
      Pie.SweepAngle := 360.000000000000000000;
      ChartType := ctBar;
      Fill.Color := 5644279;
      LegendText := 'Invoiced';
      Labels.Font.Charset := DEFAULT_CHARSET;
      Labels.Font.Color := clWindowText;
      Labels.Font.Height := -12;
      Labels.Font.Name := 'Segoe UI';
      Labels.Font.Style := [];
      Labels.Format := '%.0f';
      Labels.OffsetY := 5.000000000000000000;
      Labels.Visible := True;
      Markers.Fill.Color := 5644279;
      Markers.Height := 10.000000000000000000;
      Markers.Stroke.Color := 2822268;
      Markers.Width := 10.000000000000000000;
      MaxX := 10.000000000000000000;
      MaxY := 10.000000000000000000;
      Offset3DX := 15.000000000000000000;
      Offset3DY := 15.000000000000000000;
      Legend.Font.Charset := DEFAULT_CHARSET;
      Legend.Font.Color := clWindowText;
      Legend.Font.Height := -12;
      Legend.Font.Name := 'Segoe UI';
      Legend.Font.Style := [];
      Legend.Left := -10.000000000000000000;
      Stroke.Color := 5644279;
      XValues.MajorUnit := 1.000000000000000000;
      XValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MajorUnitFont.Color := clWindowText;
      XValues.MajorUnitFont.Height := -12;
      XValues.MajorUnitFont.Name := 'Segoe UI';
      XValues.MajorUnitFont.Style := [];
      XValues.MajorUnitFormat := '%.0f';
      XValues.MajorUnitSpacing := 5.000000000000000000;
      XValues.MajorUnitTickMarkSize := 10.000000000000000000;
      XValues.MajorUnitTickMarkColor := clSilver;
      XValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MinorUnitFont.Color := clWindowText;
      XValues.MinorUnitFont.Height := -12;
      XValues.MinorUnitFont.Name := 'Segoe UI';
      XValues.MinorUnitFont.Style := [];
      XValues.MinorUnitFormat := '%.0f';
      XValues.MinorUnitSpacing := 5.000000000000000000;
      XValues.MinorUnitTickMarkSize := 7.000000000000000000;
      XValues.MinorUnitTickMarkColor := clSilver;
      XValues.Title.Font.Charset := DEFAULT_CHARSET;
      XValues.Title.Font.Color := clWindowText;
      XValues.Title.Font.Height := -12;
      XValues.Title.Font.Name := 'Segoe UI';
      XValues.Title.Font.Style := [];
      XValues.Title.TextMargins.Left := 0;
      XValues.Title.TextMargins.Top := 0;
      XValues.Title.TextMargins.Right := 0;
      XValues.Title.TextMargins.Bottom := 0;
      YValues.MajorUnit := 1.000000000000000000;
      YValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MajorUnitFont.Color := clWindowText;
      YValues.MajorUnitFont.Height := -12;
      YValues.MajorUnitFont.Name := 'Segoe UI';
      YValues.MajorUnitFont.Style := [];
      YValues.MajorUnitFormat := '%.0f';
      YValues.MajorUnitSpacing := 5.000000000000000000;
      YValues.MajorUnitTickMarkSize := 10.000000000000000000;
      YValues.MajorUnitTickMarkColor := clSilver;
      YValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MinorUnitFont.Color := clWindowText;
      YValues.MinorUnitFont.Height := -12;
      YValues.MinorUnitFont.Name := 'Segoe UI';
      YValues.MinorUnitFont.Style := [];
      YValues.MinorUnitFormat := '%.0f';
      YValues.MinorUnitSpacing := 5.000000000000000000;
      YValues.MinorUnitTickMarkSize := 7.000000000000000000;
      YValues.MinorUnitTickMarkColor := clSilver;
      YValues.Title.Font.Charset := DEFAULT_CHARSET;
      YValues.Title.Font.Color := clWindowText;
      YValues.Title.Font.Height := -12;
      YValues.Title.Font.Name := 'Segoe UI';
      YValues.Title.Font.Style := [];
      YValues.Title.TextMargins.Left := 0;
      YValues.Title.TextMargins.Top := 0;
      YValues.Title.TextMargins.Right := 0;
      YValues.Title.TextMargins.Bottom := 0;
      YValues.SpiderValues := False;
      YValues.Positions := [];
      Crosshair.XTextStroke.Color := 5644279;
      Crosshair.XTextFill.Color := 5644279;
      Crosshair.XTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.XTextFont.Color := clWhite;
      Crosshair.XTextFont.Height := -12;
      Crosshair.XTextFont.Name := 'Segoe UI';
      Crosshair.XTextFont.Style := [];
      Crosshair.YTextStroke.Color := 5644279;
      Crosshair.YTextFill.Color := 5644279;
      Crosshair.YTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.YTextFont.Color := clWhite;
      Crosshair.YTextFont.Height := -12;
      Crosshair.YTextFont.Name := 'Segoe UI';
      Crosshair.YTextFont.Style := [];
      Crosshair.HorizontalLineStroke.Color := 5644279;
      Crosshair.VerticalLineStroke.Color := 5644279;
    end;
    with cSubsFleetCount.Series.Add do
    begin
      AnimationFactor := 4.000000000000000000;
      AutoXRange := arEnabled;
      AutoYRange := arCommonZeroBased;
      Bar.Width := 65.000000000000000000;
      Bar.Spacing := 20.000000000000000000;
      MultiPoint.Width := 65.000000000000000000;
      Pie.Size := 200.000000000000000000;
      Pie.Margins.Left := 10;
      Pie.Margins.Top := 10;
      Pie.Margins.Right := 10;
      Pie.Margins.Bottom := 10;
      Pie.SweepAngle := 360.000000000000000000;
      ChartType := ctBar;
      Fill.Color := 7936771;
      LegendText := 'Not Invoiced';
      Labels.Font.Charset := DEFAULT_CHARSET;
      Labels.Font.Color := clWindowText;
      Labels.Font.Height := -12;
      Labels.Font.Name := 'Segoe UI';
      Labels.Font.Style := [];
      Labels.Format := '%.0f';
      Labels.OffsetY := 5.000000000000000000;
      Labels.Visible := True;
      Markers.Fill.Color := 7936771;
      Markers.Height := 10.000000000000000000;
      Markers.Stroke.Color := 3935746;
      Markers.Width := 10.000000000000000000;
      MaxX := 10.000000000000000000;
      MaxY := 10.000000000000000000;
      Offset3DX := 15.000000000000000000;
      Offset3DY := 15.000000000000000000;
      Legend.Font.Charset := DEFAULT_CHARSET;
      Legend.Font.Color := clWindowText;
      Legend.Font.Height := -12;
      Legend.Font.Name := 'Segoe UI';
      Legend.Font.Style := [];
      Legend.Left := -10.000000000000000000;
      Stroke.Color := 7936771;
      XValues.MajorUnit := 1.000000000000000000;
      XValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MajorUnitFont.Color := clWindowText;
      XValues.MajorUnitFont.Height := -12;
      XValues.MajorUnitFont.Name := 'Segoe UI';
      XValues.MajorUnitFont.Style := [];
      XValues.MajorUnitFormat := '%.0f';
      XValues.MajorUnitSpacing := 5.000000000000000000;
      XValues.MajorUnitTickMarkSize := 10.000000000000000000;
      XValues.MajorUnitTickMarkColor := clSilver;
      XValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MinorUnitFont.Color := clWindowText;
      XValues.MinorUnitFont.Height := -12;
      XValues.MinorUnitFont.Name := 'Segoe UI';
      XValues.MinorUnitFont.Style := [];
      XValues.MinorUnitFormat := '%.0f';
      XValues.MinorUnitSpacing := 5.000000000000000000;
      XValues.MinorUnitTickMarkSize := 7.000000000000000000;
      XValues.MinorUnitTickMarkColor := clSilver;
      XValues.Title.Font.Charset := DEFAULT_CHARSET;
      XValues.Title.Font.Color := clWindowText;
      XValues.Title.Font.Height := -12;
      XValues.Title.Font.Name := 'Segoe UI';
      XValues.Title.Font.Style := [];
      XValues.Title.TextMargins.Left := 0;
      XValues.Title.TextMargins.Top := 0;
      XValues.Title.TextMargins.Right := 0;
      XValues.Title.TextMargins.Bottom := 0;
      YValues.MajorUnit := 1.000000000000000000;
      YValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MajorUnitFont.Color := clWindowText;
      YValues.MajorUnitFont.Height := -12;
      YValues.MajorUnitFont.Name := 'Segoe UI';
      YValues.MajorUnitFont.Style := [];
      YValues.MajorUnitFormat := '%.0f';
      YValues.MajorUnitSpacing := 5.000000000000000000;
      YValues.MajorUnitTickMarkSize := 10.000000000000000000;
      YValues.MajorUnitTickMarkColor := clSilver;
      YValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MinorUnitFont.Color := clWindowText;
      YValues.MinorUnitFont.Height := -12;
      YValues.MinorUnitFont.Name := 'Segoe UI';
      YValues.MinorUnitFont.Style := [];
      YValues.MinorUnitFormat := '%.0f';
      YValues.MinorUnitSpacing := 5.000000000000000000;
      YValues.MinorUnitTickMarkSize := 7.000000000000000000;
      YValues.MinorUnitTickMarkColor := clSilver;
      YValues.Title.Font.Charset := DEFAULT_CHARSET;
      YValues.Title.Font.Color := clWindowText;
      YValues.Title.Font.Height := -12;
      YValues.Title.Font.Name := 'Segoe UI';
      YValues.Title.Font.Style := [];
      YValues.Title.TextMargins.Left := 0;
      YValues.Title.TextMargins.Top := 0;
      YValues.Title.TextMargins.Right := 0;
      YValues.Title.TextMargins.Bottom := 0;
      YValues.SpiderValues := False;
      YValues.Positions := [];
      Crosshair.XTextStroke.Color := 7936771;
      Crosshair.XTextFill.Color := 7936771;
      Crosshair.XTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.XTextFont.Color := clWhite;
      Crosshair.XTextFont.Height := -12;
      Crosshair.XTextFont.Name := 'Segoe UI';
      Crosshair.XTextFont.Style := [];
      Crosshair.YTextStroke.Color := 7936771;
      Crosshair.YTextFill.Color := 7936771;
      Crosshair.YTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.YTextFont.Color := clWhite;
      Crosshair.YTextFont.Height := -12;
      Crosshair.YTextFont.Name := 'Segoe UI';
      Crosshair.YTextFont.Style := [];
      Crosshair.HorizontalLineStroke.Color := 7936771;
      Crosshair.VerticalLineStroke.Color := 7936771;
    end;
    with cSubsFleetCount.Series.Add do
    begin
      AnimationFactor := 4.000000000000000000;
      AutoXRange := arEnabled;
      AutoYRange := arCommonZeroBased;
      Bar.Width := 65.000000000000000000;
      Bar.Spacing := 20.000000000000000000;
      MultiPoint.Width := 65.000000000000000000;
      Pie.Size := 200.000000000000000000;
      Pie.Margins.Left := 10;
      Pie.Margins.Top := 10;
      Pie.Margins.Right := 10;
      Pie.Margins.Bottom := 10;
      Pie.SweepAngle := 360.000000000000000000;
      ChartType := ctBar;
      Fill.Color := 12275349;
      LegendText := 'Not Received';
      Labels.Font.Charset := DEFAULT_CHARSET;
      Labels.Font.Color := clWindowText;
      Labels.Font.Height := -12;
      Labels.Font.Name := 'Segoe UI';
      Labels.Font.Style := [];
      Labels.Format := '%.0f';
      Labels.OffsetY := 5.000000000000000000;
      Labels.Visible := True;
      Markers.Fill.Color := 12275349;
      Markers.Height := 10.000000000000000000;
      Markers.Stroke.Color := 6170442;
      Markers.Width := 10.000000000000000000;
      MaxX := 10.000000000000000000;
      MaxY := 10.000000000000000000;
      Offset3DX := 15.000000000000000000;
      Offset3DY := 15.000000000000000000;
      Legend.Font.Charset := DEFAULT_CHARSET;
      Legend.Font.Color := clWindowText;
      Legend.Font.Height := -12;
      Legend.Font.Name := 'Segoe UI';
      Legend.Font.Style := [];
      Legend.Left := -10.000000000000000000;
      Stroke.Color := 12275349;
      XValues.MajorUnit := 1.000000000000000000;
      XValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MajorUnitFont.Color := clWindowText;
      XValues.MajorUnitFont.Height := -12;
      XValues.MajorUnitFont.Name := 'Segoe UI';
      XValues.MajorUnitFont.Style := [];
      XValues.MajorUnitFormat := '%.0f';
      XValues.MajorUnitSpacing := 5.000000000000000000;
      XValues.MajorUnitTickMarkSize := 10.000000000000000000;
      XValues.MajorUnitTickMarkColor := clSilver;
      XValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MinorUnitFont.Color := clWindowText;
      XValues.MinorUnitFont.Height := -12;
      XValues.MinorUnitFont.Name := 'Segoe UI';
      XValues.MinorUnitFont.Style := [];
      XValues.MinorUnitFormat := '%.0f';
      XValues.MinorUnitSpacing := 5.000000000000000000;
      XValues.MinorUnitTickMarkSize := 7.000000000000000000;
      XValues.MinorUnitTickMarkColor := clSilver;
      XValues.Title.Font.Charset := DEFAULT_CHARSET;
      XValues.Title.Font.Color := clWindowText;
      XValues.Title.Font.Height := -12;
      XValues.Title.Font.Name := 'Segoe UI';
      XValues.Title.Font.Style := [];
      XValues.Title.TextMargins.Left := 0;
      XValues.Title.TextMargins.Top := 0;
      XValues.Title.TextMargins.Right := 0;
      XValues.Title.TextMargins.Bottom := 0;
      YGrid.SpiderVisible := False;
      YValues.MajorUnit := 1.000000000000000000;
      YValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MajorUnitFont.Color := clWindowText;
      YValues.MajorUnitFont.Height := -12;
      YValues.MajorUnitFont.Name := 'Segoe UI';
      YValues.MajorUnitFont.Style := [];
      YValues.MajorUnitFormat := '%.0f';
      YValues.MajorUnitSpacing := 5.000000000000000000;
      YValues.MajorUnitTickMarkSize := 10.000000000000000000;
      YValues.MajorUnitTickMarkColor := clSilver;
      YValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MinorUnitFont.Color := clWindowText;
      YValues.MinorUnitFont.Height := -12;
      YValues.MinorUnitFont.Name := 'Segoe UI';
      YValues.MinorUnitFont.Style := [];
      YValues.MinorUnitFormat := '%.0f';
      YValues.MinorUnitSpacing := 5.000000000000000000;
      YValues.MinorUnitTickMarkSize := 7.000000000000000000;
      YValues.MinorUnitTickMarkColor := clSilver;
      YValues.Title.Font.Charset := DEFAULT_CHARSET;
      YValues.Title.Font.Color := clWindowText;
      YValues.Title.Font.Height := -12;
      YValues.Title.Font.Name := 'Segoe UI';
      YValues.Title.Font.Style := [];
      YValues.Title.TextMargins.Left := 0;
      YValues.Title.TextMargins.Top := 0;
      YValues.Title.TextMargins.Right := 0;
      YValues.Title.TextMargins.Bottom := 0;
      YValues.SpiderValues := False;
      YValues.Positions := [];
      Crosshair.XTextStroke.Color := 12275349;
      Crosshair.XTextFill.Color := 12275349;
      Crosshair.XTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.XTextFont.Color := clWhite;
      Crosshair.XTextFont.Height := -12;
      Crosshair.XTextFont.Name := 'Segoe UI';
      Crosshair.XTextFont.Style := [];
      Crosshair.YTextStroke.Color := 12275349;
      Crosshair.YTextFill.Color := 12275349;
      Crosshair.YTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.YTextFont.Color := clWhite;
      Crosshair.YTextFont.Height := -12;
      Crosshair.YTextFont.Name := 'Segoe UI';
      Crosshair.YTextFont.Style := [];
      Crosshair.HorizontalLineStroke.Color := 12275349;
      Crosshair.VerticalLineStroke.Color := 12275349;
    end;
    cSubsFleetCount.Title.Stroke.Kind := gskSolid;
    cSubsFleetCount.Title.Font.Charset := DEFAULT_CHARSET;
    cSubsFleetCount.Title.Font.Color := clWindowText;
    cSubsFleetCount.Title.Font.Height := -12;
    cSubsFleetCount.Title.Font.Name := 'Segoe UI';
    cSubsFleetCount.Title.Font.Style := [];
    cSubsFleetCount.Title.Height := 35.000000000000000000;
    cSubsFleetCount.Title.TextMargins.Left := 3;
    cSubsFleetCount.Title.TextMargins.Top := 3;
    cSubsFleetCount.Title.TextMargins.Right := 3;
    cSubsFleetCount.Title.TextMargins.Bottom := 3;
    cSubsFleetCount.Title.Text := 'Subs Fleet Total Loads Count';
    cSubsFleetCount.XAxis.Stroke.Kind := gskSolid;
    cSubsFleetCount.XAxis.AutoSize := False;
    cSubsFleetCount.XAxis.Height := 35.000000000000000000;
    cSubsFleetCount.YAxis.Stroke.Kind := gskSolid;
    cSubsFleetCount.YAxis.Width := 35.000000000000000000;
    cSubsFleetCount.DefaultLoadOptions.XValuesFormatString := '%.0f';
    cSubsFleetCount.DefaultLoadOptions.YValuesFormatString := '%.2f';
    cSubsFleetCount.DefaultLoadOptions.MaxYOffsetPercentage := 5.000000000000000000;
    cSubsFleetCount.Align := alTop;
    cSubsFleetCount.TabOrder := 0;
    wpSubsFleetRevenue.SetParentComponent(wpSubsFleet);
    wpSubsFleetRevenue.Name := 'wpSubsFleetRevenue';
    wpSubsFleetRevenue.Left := 512;
    wpSubsFleetRevenue.Top := 41;
    wpSubsFleetRevenue.Width := 512;
    wpSubsFleetRevenue.Height := 350;
    wpSubsFleetRevenue.Align := alClient;
    wpSubsFleetRevenue.ChildOrder := 3;
    wpSubsFleetRevenue.TabOrder := 3;
    cSubsFleetRevenue.SetParentComponent(wpSubsFleetRevenue);
    cSubsFleetRevenue.Name := 'cSubsFleetRevenue';
    cSubsFleetRevenue.Left := 0;
    cSubsFleetRevenue.Top := 0;
    cSubsFleetRevenue.Width := 512;
    cSubsFleetRevenue.Height := 350;
    cSubsFleetRevenue.Appearance.ColorList.Clear;
    with cSubsFleetRevenue.Appearance.ColorList.Add do
    begin
      Color := 16105559;
    end;
    with cSubsFleetRevenue.Appearance.ColorList.Add do
    begin
      Color := 5644279;
    end;
    with cSubsFleetRevenue.Appearance.ColorList.Add do
    begin
      Color := 7936771;
    end;
    with cSubsFleetRevenue.Appearance.ColorList.Add do
    begin
      Color := 12275349;
    end;
    with cSubsFleetRevenue.Appearance.ColorList.Add do
    begin
      Color := 1296366;
    end;
    with cSubsFleetRevenue.Appearance.ColorList.Add do
    begin
      Color := 4350195;
    end;
    with cSubsFleetRevenue.Appearance.ColorList.Add do
    begin
      Color := 16544551;
    end;
    with cSubsFleetRevenue.Appearance.ColorList.Add do
    begin
      Color := 5820321;
    end;
    with cSubsFleetRevenue.Appearance.ColorList.Add do
    begin
      Color := 10922240;
    end;
    with cSubsFleetRevenue.Appearance.ColorList.Add do
    begin
      Color := 16376965;
    end;
    cSubsFleetRevenue.Appearance.GlobalFont.Color := -1;
    cSubsFleetRevenue.Appearance.GlobalFont.Scale := 1.000000000000000000;
    cSubsFleetRevenue.Appearance.GlobalFont.Style := [];
    cSubsFleetRevenue.Appearance.ColorScheme := ccsColorList;
    cSubsFleetRevenue.Appearance.MonochromeColor := clSteelblue;
    cSubsFleetRevenue.ClickMargin := 10.000000000000000000;
    cSubsFleetRevenue.Legend.Fill.Kind := gfkSolid;
    cSubsFleetRevenue.Legend.Stroke.Kind := gskSolid;
    cSubsFleetRevenue.Legend.Font.Charset := DEFAULT_CHARSET;
    cSubsFleetRevenue.Legend.Font.Color := clWindowText;
    cSubsFleetRevenue.Legend.Font.Height := -12;
    cSubsFleetRevenue.Legend.Font.Name := 'Segoe UI';
    cSubsFleetRevenue.Legend.Font.Style := [];
    cSubsFleetRevenue.Legend.Left := -10.000000000000000000;
    cSubsFleetRevenue.Legend.Position := lpTopRight;
    cSubsFleetRevenue.Legend.Top := 10.000000000000000000;
    cSubsFleetRevenue.SeriesMargins.Left := 0;
    cSubsFleetRevenue.SeriesMargins.Top := 15;
    cSubsFleetRevenue.SeriesMargins.Right := 0;
    cSubsFleetRevenue.SeriesMargins.Bottom := 0;
    cSubsFleetRevenue.Series.Clear;
    with cSubsFleetRevenue.Series.Add do
    begin
      AnimationFactor := 4.000000000000000000;
      AutoXRange := arEnabled;
      AutoYRange := arCommonZeroBased;
      Bar.Width := 65.000000000000000000;
      Bar.Spacing := 20.000000000000000000;
      MultiPoint.Width := 65.000000000000000000;
      Pie.Size := 200.000000000000000000;
      Pie.Margins.Left := 10;
      Pie.Margins.Top := 10;
      Pie.Margins.Right := 10;
      Pie.Margins.Bottom := 10;
      Pie.SweepAngle := 360.000000000000000000;
      ChartType := ctBar;
      Fill.Color := clGreen;
      LegendText := 'Loads';
      Labels.Font.Charset := DEFAULT_CHARSET;
      Labels.Font.Color := clWindowText;
      Labels.Font.Height := -12;
      Labels.Font.Name := 'Segoe UI';
      Labels.Font.Style := [];
      Labels.Format := '#,##0';
      Labels.FormatType := vftFloat;
      Labels.OffsetY := 5.000000000000000000;
      Labels.Visible := True;
      Markers.Fill.Color := 16105559;
      Markers.Height := 10.000000000000000000;
      Markers.Stroke.Color := 8020012;
      Markers.Width := 10.000000000000000000;
      MaxX := 10.000000000000000000;
      MaxY := 10.000000000000000000;
      Offset3DX := 15.000000000000000000;
      Offset3DY := 15.000000000000000000;
      Legend.Font.Charset := DEFAULT_CHARSET;
      Legend.Font.Color := clWindowText;
      Legend.Font.Height := -12;
      Legend.Font.Name := 'Segoe UI';
      Legend.Font.Style := [];
      Legend.Left := -10.000000000000000000;
      Stroke.Color := clGreen;
      XValues.MajorUnit := 1.000000000000000000;
      XValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MajorUnitFont.Color := clWindowText;
      XValues.MajorUnitFont.Height := -12;
      XValues.MajorUnitFont.Name := 'Segoe UI';
      XValues.MajorUnitFont.Style := [];
      XValues.MajorUnitFormat := '%.0f';
      XValues.MajorUnitSpacing := 5.000000000000000000;
      XValues.MajorUnitTickMarkSize := 10.000000000000000000;
      XValues.MajorUnitTickMarkColor := clSilver;
      XValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MinorUnitFont.Color := clWindowText;
      XValues.MinorUnitFont.Height := -12;
      XValues.MinorUnitFont.Name := 'Segoe UI';
      XValues.MinorUnitFont.Style := [];
      XValues.MinorUnitFormat := '%.0f';
      XValues.MinorUnitSpacing := 5.000000000000000000;
      XValues.MinorUnitTickMarkSize := 7.000000000000000000;
      XValues.MinorUnitTickMarkColor := clSilver;
      XValues.Title.Font.Charset := DEFAULT_CHARSET;
      XValues.Title.Font.Color := clWindowText;
      XValues.Title.Font.Height := -12;
      XValues.Title.Font.Name := 'Segoe UI';
      XValues.Title.Font.Style := [];
      XValues.Title.TextMargins.Left := 0;
      XValues.Title.TextMargins.Top := 0;
      XValues.Title.TextMargins.Right := 0;
      XValues.Title.TextMargins.Bottom := 0;
      YValues.MajorUnit := 1.000000000000000000;
      YValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MajorUnitFont.Color := clWindowText;
      YValues.MajorUnitFont.Height := -12;
      YValues.MajorUnitFont.Name := 'Segoe UI';
      YValues.MajorUnitFont.Style := [];
      YValues.MajorUnitFormat := '#,##0';
      YValues.MajorUnitFormatType := vftFloat;
      YValues.MajorUnitSpacing := 5.000000000000000000;
      YValues.MajorUnitTickMarkSize := 10.000000000000000000;
      YValues.MajorUnitTickMarkColor := clSilver;
      YValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MinorUnitFont.Color := clWindowText;
      YValues.MinorUnitFont.Height := -12;
      YValues.MinorUnitFont.Name := 'Segoe UI';
      YValues.MinorUnitFont.Style := [];
      YValues.MinorUnitFormat := '#,##0';
      YValues.MinorUnitFormatType := vftFloat;
      YValues.MinorUnitSpacing := 5.000000000000000000;
      YValues.MinorUnitTickMarkSize := 7.000000000000000000;
      YValues.MinorUnitTickMarkColor := clSilver;
      YValues.Title.Font.Charset := DEFAULT_CHARSET;
      YValues.Title.Font.Color := clWindowText;
      YValues.Title.Font.Height := -12;
      YValues.Title.Font.Name := 'Segoe UI';
      YValues.Title.Font.Style := [];
      YValues.Title.TextMargins.Left := 0;
      YValues.Title.TextMargins.Top := 0;
      YValues.Title.TextMargins.Right := 0;
      YValues.Title.TextMargins.Bottom := 0;
      YValues.SpiderValues := False;
      Crosshair.XTextStroke.Color := 16105559;
      Crosshair.XTextFill.Color := 16105559;
      Crosshair.XTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.XTextFont.Color := clWhite;
      Crosshair.XTextFont.Height := -12;
      Crosshair.XTextFont.Name := 'Segoe UI';
      Crosshair.XTextFont.Style := [];
      Crosshair.YTextStroke.Color := 16105559;
      Crosshair.YTextFill.Color := 16105559;
      Crosshair.YTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.YTextFont.Color := clWhite;
      Crosshair.YTextFont.Height := -12;
      Crosshair.YTextFont.Name := 'Segoe UI';
      Crosshair.YTextFont.Style := [];
      Crosshair.HorizontalLineStroke.Color := 16105559;
      Crosshair.VerticalLineStroke.Color := 16105559;
    end;
    with cSubsFleetRevenue.Series.Add do
    begin
      AnimationFactor := 4.000000000000000000;
      AutoXRange := arEnabled;
      AutoYRange := arCommonZeroBased;
      Bar.Width := 65.000000000000000000;
      Bar.Spacing := 20.000000000000000000;
      MultiPoint.Width := 65.000000000000000000;
      Pie.Size := 200.000000000000000000;
      Pie.Margins.Left := 10;
      Pie.Margins.Top := 10;
      Pie.Margins.Right := 10;
      Pie.Margins.Bottom := 10;
      Pie.SweepAngle := 360.000000000000000000;
      ChartType := ctBar;
      Fill.Color := 5644279;
      LegendText := 'Invoiced';
      Labels.Font.Charset := DEFAULT_CHARSET;
      Labels.Font.Color := clWindowText;
      Labels.Font.Height := -12;
      Labels.Font.Name := 'Segoe UI';
      Labels.Font.Style := [];
      Labels.Format := '#,##0';
      Labels.FormatType := vftFloat;
      Labels.OffsetY := 5.000000000000000000;
      Labels.Visible := True;
      Markers.Fill.Color := 5644279;
      Markers.Height := 10.000000000000000000;
      Markers.Stroke.Color := 2822268;
      Markers.Width := 10.000000000000000000;
      MaxX := 10.000000000000000000;
      MaxY := 10.000000000000000000;
      Offset3DX := 15.000000000000000000;
      Offset3DY := 15.000000000000000000;
      Legend.Font.Charset := DEFAULT_CHARSET;
      Legend.Font.Color := clWindowText;
      Legend.Font.Height := -12;
      Legend.Font.Name := 'Segoe UI';
      Legend.Font.Style := [];
      Legend.Left := -10.000000000000000000;
      Stroke.Color := 5644279;
      XValues.MajorUnit := 1.000000000000000000;
      XValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MajorUnitFont.Color := clWindowText;
      XValues.MajorUnitFont.Height := -12;
      XValues.MajorUnitFont.Name := 'Segoe UI';
      XValues.MajorUnitFont.Style := [];
      XValues.MajorUnitFormat := '%.0f';
      XValues.MajorUnitSpacing := 5.000000000000000000;
      XValues.MajorUnitTickMarkSize := 10.000000000000000000;
      XValues.MajorUnitTickMarkColor := clSilver;
      XValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MinorUnitFont.Color := clWindowText;
      XValues.MinorUnitFont.Height := -12;
      XValues.MinorUnitFont.Name := 'Segoe UI';
      XValues.MinorUnitFont.Style := [];
      XValues.MinorUnitFormat := '%.0f';
      XValues.MinorUnitSpacing := 5.000000000000000000;
      XValues.MinorUnitTickMarkSize := 7.000000000000000000;
      XValues.MinorUnitTickMarkColor := clSilver;
      XValues.Title.Font.Charset := DEFAULT_CHARSET;
      XValues.Title.Font.Color := clWindowText;
      XValues.Title.Font.Height := -12;
      XValues.Title.Font.Name := 'Segoe UI';
      XValues.Title.Font.Style := [];
      XValues.Title.TextMargins.Left := 0;
      XValues.Title.TextMargins.Top := 0;
      XValues.Title.TextMargins.Right := 0;
      XValues.Title.TextMargins.Bottom := 0;
      YValues.MajorUnit := 1.000000000000000000;
      YValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MajorUnitFont.Color := clWindowText;
      YValues.MajorUnitFont.Height := -12;
      YValues.MajorUnitFont.Name := 'Segoe UI';
      YValues.MajorUnitFont.Style := [];
      YValues.MajorUnitFormat := '#,##0';
      YValues.MajorUnitFormatType := vftFloat;
      YValues.MajorUnitSpacing := 5.000000000000000000;
      YValues.MajorUnitTickMarkSize := 10.000000000000000000;
      YValues.MajorUnitTickMarkColor := clSilver;
      YValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MinorUnitFont.Color := clWindowText;
      YValues.MinorUnitFont.Height := -12;
      YValues.MinorUnitFont.Name := 'Segoe UI';
      YValues.MinorUnitFont.Style := [];
      YValues.MinorUnitFormat := '#,##0';
      YValues.MinorUnitFormatType := vftFloat;
      YValues.MinorUnitSpacing := 5.000000000000000000;
      YValues.MinorUnitTickMarkSize := 7.000000000000000000;
      YValues.MinorUnitTickMarkColor := clSilver;
      YValues.Title.Font.Charset := DEFAULT_CHARSET;
      YValues.Title.Font.Color := clWindowText;
      YValues.Title.Font.Height := -12;
      YValues.Title.Font.Name := 'Segoe UI';
      YValues.Title.Font.Style := [];
      YValues.Title.TextMargins.Left := 0;
      YValues.Title.TextMargins.Top := 0;
      YValues.Title.TextMargins.Right := 0;
      YValues.Title.TextMargins.Bottom := 0;
      YValues.SpiderValues := False;
      YValues.Positions := [];
      Crosshair.XTextStroke.Color := 5644279;
      Crosshair.XTextFill.Color := 5644279;
      Crosshair.XTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.XTextFont.Color := clWhite;
      Crosshair.XTextFont.Height := -12;
      Crosshair.XTextFont.Name := 'Segoe UI';
      Crosshair.XTextFont.Style := [];
      Crosshair.YTextStroke.Color := 5644279;
      Crosshair.YTextFill.Color := 5644279;
      Crosshair.YTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.YTextFont.Color := clWhite;
      Crosshair.YTextFont.Height := -12;
      Crosshair.YTextFont.Name := 'Segoe UI';
      Crosshair.YTextFont.Style := [];
      Crosshair.HorizontalLineStroke.Color := 5644279;
      Crosshair.VerticalLineStroke.Color := 5644279;
    end;
    with cSubsFleetRevenue.Series.Add do
    begin
      AnimationFactor := 4.000000000000000000;
      AutoXRange := arEnabled;
      AutoYRange := arCommonZeroBased;
      Bar.Width := 65.000000000000000000;
      Bar.Spacing := 20.000000000000000000;
      MultiPoint.Width := 65.000000000000000000;
      Pie.Size := 200.000000000000000000;
      Pie.Margins.Left := 10;
      Pie.Margins.Top := 10;
      Pie.Margins.Right := 10;
      Pie.Margins.Bottom := 10;
      Pie.SweepAngle := 360.000000000000000000;
      ChartType := ctBar;
      Fill.Color := clBlue;
      LegendText := 'Not Invoiced';
      Labels.Font.Charset := DEFAULT_CHARSET;
      Labels.Font.Color := clWindowText;
      Labels.Font.Height := -12;
      Labels.Font.Name := 'Segoe UI';
      Labels.Font.Style := [];
      Labels.Format := '#,##0';
      Labels.FormatType := vftFloat;
      Labels.OffsetY := 5.000000000000000000;
      Labels.Visible := True;
      Markers.Fill.Color := 7936771;
      Markers.Height := 10.000000000000000000;
      Markers.Stroke.Color := 3935746;
      Markers.Width := 10.000000000000000000;
      MaxX := 10.000000000000000000;
      MaxY := 10.000000000000000000;
      Offset3DX := 15.000000000000000000;
      Offset3DY := 15.000000000000000000;
      Legend.Font.Charset := DEFAULT_CHARSET;
      Legend.Font.Color := clWindowText;
      Legend.Font.Height := -12;
      Legend.Font.Name := 'Segoe UI';
      Legend.Font.Style := [];
      Legend.Left := -10.000000000000000000;
      Stroke.Color := clBlue;
      XValues.MajorUnit := 1.000000000000000000;
      XValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MajorUnitFont.Color := clWindowText;
      XValues.MajorUnitFont.Height := -12;
      XValues.MajorUnitFont.Name := 'Segoe UI';
      XValues.MajorUnitFont.Style := [];
      XValues.MajorUnitFormat := '%.0f';
      XValues.MajorUnitSpacing := 5.000000000000000000;
      XValues.MajorUnitTickMarkSize := 10.000000000000000000;
      XValues.MajorUnitTickMarkColor := clSilver;
      XValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MinorUnitFont.Color := clWindowText;
      XValues.MinorUnitFont.Height := -12;
      XValues.MinorUnitFont.Name := 'Segoe UI';
      XValues.MinorUnitFont.Style := [];
      XValues.MinorUnitFormat := '%.0f';
      XValues.MinorUnitSpacing := 5.000000000000000000;
      XValues.MinorUnitTickMarkSize := 7.000000000000000000;
      XValues.MinorUnitTickMarkColor := clSilver;
      XValues.Title.Font.Charset := DEFAULT_CHARSET;
      XValues.Title.Font.Color := clWindowText;
      XValues.Title.Font.Height := -12;
      XValues.Title.Font.Name := 'Segoe UI';
      XValues.Title.Font.Style := [];
      XValues.Title.TextMargins.Left := 0;
      XValues.Title.TextMargins.Top := 0;
      XValues.Title.TextMargins.Right := 0;
      XValues.Title.TextMargins.Bottom := 0;
      YValues.MajorUnit := 1.000000000000000000;
      YValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MajorUnitFont.Color := clWindowText;
      YValues.MajorUnitFont.Height := -12;
      YValues.MajorUnitFont.Name := 'Segoe UI';
      YValues.MajorUnitFont.Style := [];
      YValues.MajorUnitFormat := '#,##0';
      YValues.MajorUnitFormatType := vftFloat;
      YValues.MajorUnitSpacing := 5.000000000000000000;
      YValues.MajorUnitTickMarkSize := 10.000000000000000000;
      YValues.MajorUnitTickMarkColor := clSilver;
      YValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MinorUnitFont.Color := clWindowText;
      YValues.MinorUnitFont.Height := -12;
      YValues.MinorUnitFont.Name := 'Segoe UI';
      YValues.MinorUnitFont.Style := [];
      YValues.MinorUnitFormat := '#,##0';
      YValues.MinorUnitFormatType := vftFloat;
      YValues.MinorUnitSpacing := 5.000000000000000000;
      YValues.MinorUnitTickMarkSize := 7.000000000000000000;
      YValues.MinorUnitTickMarkColor := clSilver;
      YValues.Title.Font.Charset := DEFAULT_CHARSET;
      YValues.Title.Font.Color := clWindowText;
      YValues.Title.Font.Height := -12;
      YValues.Title.Font.Name := 'Segoe UI';
      YValues.Title.Font.Style := [];
      YValues.Title.TextMargins.Left := 0;
      YValues.Title.TextMargins.Top := 0;
      YValues.Title.TextMargins.Right := 0;
      YValues.Title.TextMargins.Bottom := 0;
      YValues.SpiderValues := False;
      YValues.Positions := [];
      Crosshair.XTextStroke.Color := 7936771;
      Crosshair.XTextFill.Color := 7936771;
      Crosshair.XTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.XTextFont.Color := clWhite;
      Crosshair.XTextFont.Height := -12;
      Crosshair.XTextFont.Name := 'Segoe UI';
      Crosshair.XTextFont.Style := [];
      Crosshair.YTextStroke.Color := 7936771;
      Crosshair.YTextFill.Color := 7936771;
      Crosshair.YTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.YTextFont.Color := clWhite;
      Crosshair.YTextFont.Height := -12;
      Crosshair.YTextFont.Name := 'Segoe UI';
      Crosshair.YTextFont.Style := [];
      Crosshair.HorizontalLineStroke.Color := 7936771;
      Crosshair.VerticalLineStroke.Color := 7936771;
    end;
    with cSubsFleetRevenue.Series.Add do
    begin
      AnimationFactor := 4.000000000000000000;
      AutoXRange := arEnabled;
      AutoYRange := arCommonZeroBased;
      Bar.Width := 65.000000000000000000;
      Bar.Spacing := 20.000000000000000000;
      MultiPoint.Width := 65.000000000000000000;
      Pie.Size := 200.000000000000000000;
      Pie.Margins.Left := 10;
      Pie.Margins.Top := 10;
      Pie.Margins.Right := 10;
      Pie.Margins.Bottom := 10;
      Pie.SweepAngle := 360.000000000000000000;
      ChartType := ctBar;
      Fill.Color := clLime;
      LegendText := 'Not Received';
      Labels.Font.Charset := DEFAULT_CHARSET;
      Labels.Font.Color := clWindowText;
      Labels.Font.Height := -12;
      Labels.Font.Name := 'Segoe UI';
      Labels.Font.Style := [];
      Labels.Format := '#,##0';
      Labels.FormatType := vftFloat;
      Labels.OffsetY := 5.000000000000000000;
      Labels.Visible := True;
      Markers.Fill.Color := 12275349;
      Markers.Height := 10.000000000000000000;
      Markers.Stroke.Color := 6170442;
      Markers.Width := 10.000000000000000000;
      MaxX := 10.000000000000000000;
      MaxY := 10.000000000000000000;
      Offset3DX := 15.000000000000000000;
      Offset3DY := 15.000000000000000000;
      Legend.Font.Charset := DEFAULT_CHARSET;
      Legend.Font.Color := clWindowText;
      Legend.Font.Height := -12;
      Legend.Font.Name := 'Segoe UI';
      Legend.Font.Style := [];
      Legend.Left := -10.000000000000000000;
      Stroke.Color := clLime;
      XValues.MajorUnit := 1.000000000000000000;
      XValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MajorUnitFont.Color := clWindowText;
      XValues.MajorUnitFont.Height := -12;
      XValues.MajorUnitFont.Name := 'Segoe UI';
      XValues.MajorUnitFont.Style := [];
      XValues.MajorUnitFormat := '%.0f';
      XValues.MajorUnitSpacing := 5.000000000000000000;
      XValues.MajorUnitTickMarkSize := 10.000000000000000000;
      XValues.MajorUnitTickMarkColor := clSilver;
      XValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MinorUnitFont.Color := clWindowText;
      XValues.MinorUnitFont.Height := -12;
      XValues.MinorUnitFont.Name := 'Segoe UI';
      XValues.MinorUnitFont.Style := [];
      XValues.MinorUnitFormat := '%.0f';
      XValues.MinorUnitSpacing := 5.000000000000000000;
      XValues.MinorUnitTickMarkSize := 7.000000000000000000;
      XValues.MinorUnitTickMarkColor := clSilver;
      XValues.Title.Font.Charset := DEFAULT_CHARSET;
      XValues.Title.Font.Color := clWindowText;
      XValues.Title.Font.Height := -12;
      XValues.Title.Font.Name := 'Segoe UI';
      XValues.Title.Font.Style := [];
      XValues.Title.TextMargins.Left := 0;
      XValues.Title.TextMargins.Top := 0;
      XValues.Title.TextMargins.Right := 0;
      XValues.Title.TextMargins.Bottom := 0;
      YGrid.SpiderVisible := False;
      YValues.MajorUnit := 1.000000000000000000;
      YValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MajorUnitFont.Color := clWindowText;
      YValues.MajorUnitFont.Height := -12;
      YValues.MajorUnitFont.Name := 'Segoe UI';
      YValues.MajorUnitFont.Style := [];
      YValues.MajorUnitFormat := '#,##0';
      YValues.MajorUnitFormatType := vftFloat;
      YValues.MajorUnitSpacing := 5.000000000000000000;
      YValues.MajorUnitTickMarkSize := 10.000000000000000000;
      YValues.MajorUnitTickMarkColor := clSilver;
      YValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MinorUnitFont.Color := clWindowText;
      YValues.MinorUnitFont.Height := -12;
      YValues.MinorUnitFont.Name := 'Segoe UI';
      YValues.MinorUnitFont.Style := [];
      YValues.MinorUnitFormat := '#,##0';
      YValues.MinorUnitFormatType := vftFloat;
      YValues.MinorUnitSpacing := 5.000000000000000000;
      YValues.MinorUnitTickMarkSize := 7.000000000000000000;
      YValues.MinorUnitTickMarkColor := clSilver;
      YValues.Title.Font.Charset := DEFAULT_CHARSET;
      YValues.Title.Font.Color := clWindowText;
      YValues.Title.Font.Height := -12;
      YValues.Title.Font.Name := 'Segoe UI';
      YValues.Title.Font.Style := [];
      YValues.Title.TextMargins.Left := 0;
      YValues.Title.TextMargins.Top := 0;
      YValues.Title.TextMargins.Right := 0;
      YValues.Title.TextMargins.Bottom := 0;
      YValues.SpiderValues := False;
      YValues.Positions := [];
      Crosshair.XTextStroke.Color := 12275349;
      Crosshair.XTextFill.Color := 12275349;
      Crosshair.XTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.XTextFont.Color := clWhite;
      Crosshair.XTextFont.Height := -12;
      Crosshair.XTextFont.Name := 'Segoe UI';
      Crosshair.XTextFont.Style := [];
      Crosshair.YTextStroke.Color := 12275349;
      Crosshair.YTextFill.Color := 12275349;
      Crosshair.YTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.YTextFont.Color := clWhite;
      Crosshair.YTextFont.Height := -12;
      Crosshair.YTextFont.Name := 'Segoe UI';
      Crosshair.YTextFont.Style := [];
      Crosshair.HorizontalLineStroke.Color := 12275349;
      Crosshair.VerticalLineStroke.Color := 12275349;
    end;
    cSubsFleetRevenue.Title.Stroke.Kind := gskSolid;
    cSubsFleetRevenue.Title.Font.Charset := DEFAULT_CHARSET;
    cSubsFleetRevenue.Title.Font.Color := clWindowText;
    cSubsFleetRevenue.Title.Font.Height := -12;
    cSubsFleetRevenue.Title.Font.Name := 'Segoe UI';
    cSubsFleetRevenue.Title.Font.Style := [];
    cSubsFleetRevenue.Title.Height := 35.000000000000000000;
    cSubsFleetRevenue.Title.TextMargins.Left := 3;
    cSubsFleetRevenue.Title.TextMargins.Top := 3;
    cSubsFleetRevenue.Title.TextMargins.Right := 3;
    cSubsFleetRevenue.Title.TextMargins.Bottom := 3;
    cSubsFleetRevenue.Title.Text := 'Subs Fleet Total Loads Revenue';
    cSubsFleetRevenue.XAxis.Stroke.Kind := gskSolid;
    cSubsFleetRevenue.XAxis.AutoSize := False;
    cSubsFleetRevenue.XAxis.Height := 35.000000000000000000;
    cSubsFleetRevenue.YAxis.Stroke.Kind := gskSolid;
    cSubsFleetRevenue.YAxis.Width := 35.000000000000000000;
    cSubsFleetRevenue.DefaultLoadOptions.XValuesFormatString := '%.0f';
    cSubsFleetRevenue.DefaultLoadOptions.YValuesFormatString := '%.2f';
    cSubsFleetRevenue.DefaultLoadOptions.MaxYOffsetPercentage := 5.000000000000000000;
    cSubsFleetRevenue.Align := alTop;
    cSubsFleetRevenue.TabOrder := 0;
    wpDate.SetParentComponent(WebScrollBox1);
    wpDate.Name := 'wpDate';
    wpDate.Left := 0;
    wpDate.Top := 0;
    wpDate.Width := 1024;
    wpDate.Height := 54;
    wpDate.Align := alTop;
    wpDate.ChildOrder := 3;
    wpDate.Color := clBlack;
    wpDate.TabOrder := 3;
    wlMonth.SetParentComponent(wpDate);
    wlMonth.Name := 'wlMonth';
    wlMonth.Left := 421;
    wlMonth.Top := 20;
    wlMonth.Width := 156;
    wlMonth.Height := 15;
    wlMonth.Alignment := taCenter;
    wlMonth.AutoSize := False;
    wlMonth.Caption := 'Month';
    wlMonth.Font.Charset := DEFAULT_CHARSET;
    wlMonth.Font.Color := clWhite;
    wlMonth.Font.Height := -12;
    wlMonth.Font.Name := 'Segoe UI';
    wlMonth.Font.Style := [fsBold];
    wlMonth.HeightPercent := 100.000000000000000000;
    wlMonth.ParentFont := False;
    wlMonth.WidthPercent := 100.000000000000000000;
    btnPrevMonth.SetParentComponent(wpDate);
    btnPrevMonth.Name := 'btnPrevMonth';
    btnPrevMonth.Left := 358;
    btnPrevMonth.Top := 16;
    btnPrevMonth.Width := 57;
    btnPrevMonth.Height := 25;
    btnPrevMonth.Font.Charset := DEFAULT_CHARSET;
    btnPrevMonth.Font.Color := clWindowText;
    btnPrevMonth.Font.Height := -12;
    btnPrevMonth.Font.Name := 'Segoe UI';
    btnPrevMonth.Font.Style := [fsBold];
    btnPrevMonth.Text := '<';
    btnPrevMonth.TabOrder := 0;
    SetEvent(btnPrevMonth, Self, 'OnClick', 'btnPrevMonthClick');
    btnNextMonth.SetParentComponent(wpDate);
    btnNextMonth.Name := 'btnNextMonth';
    btnNextMonth.Left := 611;
    btnNextMonth.Top := 16;
    btnNextMonth.Width := 57;
    btnNextMonth.Height := 25;
    btnNextMonth.Font.Charset := DEFAULT_CHARSET;
    btnNextMonth.Font.Color := clWindowText;
    btnNextMonth.Font.Height := -12;
    btnNextMonth.Font.Name := 'Segoe UI';
    btnNextMonth.Font.Style := [fsBold];
    btnNextMonth.Text := '>';
    btnNextMonth.TabOrder := 1;
    SetEvent(btnNextMonth, Self, 'OnClick', 'btnNextMonthClick');
    wcCompany.SetParentComponent(Self);
    wcCompany.Name := 'wcCompany';
    wcCompany.Connection := dmData.dbConnect;
    wcCompany.Left := 232;
    wcCompany.Top := 105;
    wdsCompany.SetParentComponent(Self);
    wdsCompany.Name := 'wdsCompany';
    wdsCompany.AfterOpen := wdsCompanyAfterOpen;
    wdsCompany.Connection := dmData.dbConnect;
    wdsCompany.Left := 232;
    wdsCompany.Top := 185;
    wdsCompanyLoadsC.SetParentComponent(wdsCompany);
    wdsCompanyLoadsC.Name := 'wdsCompanyLoadsC';
    wdsCompanyLoadsC.FieldName := 'LoadsC';
    wdsCompanyLoadsR.SetParentComponent(wdsCompany);
    wdsCompanyLoadsR.Name := 'wdsCompanyLoadsR';
    wdsCompanyLoadsR.FieldName := 'LoadsR';
    wdsCompanyLoadsIC.SetParentComponent(wdsCompany);
    wdsCompanyLoadsIC.Name := 'wdsCompanyLoadsIC';
    wdsCompanyLoadsIC.FieldName := 'LoadsIC';
    wdsCompanyLoadsIR.SetParentComponent(wdsCompany);
    wdsCompanyLoadsIR.Name := 'wdsCompanyLoadsIR';
    wdsCompanyLoadsIR.FieldName := 'LoadsIR';
    wdsCompanyLoadsINRC.SetParentComponent(wdsCompany);
    wdsCompanyLoadsINRC.Name := 'wdsCompanyLoadsINRC';
    wdsCompanyLoadsINRC.FieldName := 'LoadsINRC';
    wdsCompanyLoadsINRR.SetParentComponent(wdsCompany);
    wdsCompanyLoadsINRR.Name := 'wdsCompanyLoadsINRR';
    wdsCompanyLoadsINRR.FieldName := 'LoadsINRR';
    wdsCompanyLoadsNIC.SetParentComponent(wdsCompany);
    wdsCompanyLoadsNIC.Name := 'wdsCompanyLoadsNIC';
    wdsCompanyLoadsNIC.FieldName := 'LoadsNIC';
    wdsCompanyLoadsNIR.SetParentComponent(wdsCompany);
    wdsCompanyLoadsNIR.Name := 'wdsCompanyLoadsNIR';
    wdsCompanyLoadsNIR.FieldName := 'LoadsNIR';
    wdsCompanyLoadsNRC.SetParentComponent(wdsCompany);
    wdsCompanyLoadsNRC.Name := 'wdsCompanyLoadsNRC';
    wdsCompanyLoadsNRC.FieldName := 'LoadsNRC';
    wdsCompanyLoadsNRR.SetParentComponent(wdsCompany);
    wdsCompanyLoadsNRR.Name := 'wdsCompanyLoadsNRR';
    wdsCompanyLoadsNRR.FieldName := 'LoadsNRR';
    wdsCompanyLoadsName.SetParentComponent(wdsCompany);
    wdsCompanyLoadsName.Name := 'wdsCompanyLoadsName';
    wdsCompanyLoadsName.FieldName := 'LoadsName';
    wdsCompanyLoadsIName.SetParentComponent(wdsCompany);
    wdsCompanyLoadsIName.Name := 'wdsCompanyLoadsIName';
    wdsCompanyLoadsIName.FieldName := 'LoadsIName';
    wdsCompanyLoadsINRName.SetParentComponent(wdsCompany);
    wdsCompanyLoadsINRName.Name := 'wdsCompanyLoadsINRName';
    wdsCompanyLoadsINRName.FieldName := 'LoadsINRName';
    wdsCompanyLoadsNIName.SetParentComponent(wdsCompany);
    wdsCompanyLoadsNIName.Name := 'wdsCompanyLoadsNIName';
    wdsCompanyLoadsNIName.FieldName := 'LoadsNIName';
    wdsCompanyLoadsNRName.SetParentComponent(wdsCompany);
    wdsCompanyLoadsNRName.Name := 'wdsCompanyLoadsNRName';
    wdsCompanyLoadsNRName.FieldName := 'LoadsNRName';
    wdsCompanyLoadsPos.SetParentComponent(wdsCompany);
    wdsCompanyLoadsPos.Name := 'wdsCompanyLoadsPos';
    wdsCompanyLoadsPos.FieldName := 'LoadsPos';
    wdsCompanyLoadsIPos.SetParentComponent(wdsCompany);
    wdsCompanyLoadsIPos.Name := 'wdsCompanyLoadsIPos';
    wdsCompanyLoadsIPos.FieldName := 'LoadsIPos';
    wdsCompanyLoadsINRPos.SetParentComponent(wdsCompany);
    wdsCompanyLoadsINRPos.Name := 'wdsCompanyLoadsINRPos';
    wdsCompanyLoadsINRPos.FieldName := 'LoadsINRPos';
    wdsCompanyLoadsNIPos.SetParentComponent(wdsCompany);
    wdsCompanyLoadsNIPos.Name := 'wdsCompanyLoadsNIPos';
    wdsCompanyLoadsNIPos.FieldName := 'LoadsNIPos';
    wdsCompanyLoadsNRPos.SetParentComponent(wdsCompany);
    wdsCompanyLoadsNRPos.Name := 'wdsCompanyLoadsNRPos';
    wdsCompanyLoadsNRPos.FieldName := 'LoadsNRPos';
    dsCompany.SetParentComponent(Self);
    dsCompany.Name := 'dsCompany';
    dsCompany.AutoEdit := False;
    dsCompany.DataSet := wdsCompany;
    dsCompany.Left := 328;
    dsCompany.Top := 185;
    wcOwnFleet.SetParentComponent(Self);
    wcOwnFleet.Name := 'wcOwnFleet';
    wcOwnFleet.Connection := dmData.dbConnect;
    wcOwnFleet.Left := 320;
    wcOwnFleet.Top := 425;
    wdsOwnFleet.SetParentComponent(Self);
    wdsOwnFleet.Name := 'wdsOwnFleet';
    wdsOwnFleet.AfterOpen := wdsOwnFleetAfterOpen;
    wdsOwnFleet.Connection := dmData.dbConnect;
    wdsOwnFleet.Left := 320;
    wdsOwnFleet.Top := 505;
    IntegerField1.SetParentComponent(wdsOwnFleet);
    IntegerField1.Name := 'IntegerField1';
    IntegerField1.FieldName := 'LoadsC';
    FloatField1.SetParentComponent(wdsOwnFleet);
    FloatField1.Name := 'FloatField1';
    FloatField1.FieldName := 'LoadsR';
    IntegerField2.SetParentComponent(wdsOwnFleet);
    IntegerField2.Name := 'IntegerField2';
    IntegerField2.FieldName := 'LoadsIC';
    FloatField2.SetParentComponent(wdsOwnFleet);
    FloatField2.Name := 'FloatField2';
    FloatField2.FieldName := 'LoadsIR';
    IntegerField3.SetParentComponent(wdsOwnFleet);
    IntegerField3.Name := 'IntegerField3';
    IntegerField3.FieldName := 'LoadsINRC';
    FloatField3.SetParentComponent(wdsOwnFleet);
    FloatField3.Name := 'FloatField3';
    FloatField3.FieldName := 'LoadsINRR';
    IntegerField4.SetParentComponent(wdsOwnFleet);
    IntegerField4.Name := 'IntegerField4';
    IntegerField4.FieldName := 'LoadsNIC';
    FloatField4.SetParentComponent(wdsOwnFleet);
    FloatField4.Name := 'FloatField4';
    FloatField4.FieldName := 'LoadsNIR';
    IntegerField5.SetParentComponent(wdsOwnFleet);
    IntegerField5.Name := 'IntegerField5';
    IntegerField5.FieldName := 'LoadsNRC';
    FloatField5.SetParentComponent(wdsOwnFleet);
    FloatField5.Name := 'FloatField5';
    FloatField5.FieldName := 'LoadsNRR';
    StringField1.SetParentComponent(wdsOwnFleet);
    StringField1.Name := 'StringField1';
    StringField1.FieldName := 'LoadsName';
    StringField2.SetParentComponent(wdsOwnFleet);
    StringField2.Name := 'StringField2';
    StringField2.FieldName := 'LoadsIName';
    StringField3.SetParentComponent(wdsOwnFleet);
    StringField3.Name := 'StringField3';
    StringField3.FieldName := 'LoadsINRName';
    StringField4.SetParentComponent(wdsOwnFleet);
    StringField4.Name := 'StringField4';
    StringField4.FieldName := 'LoadsNIName';
    StringField5.SetParentComponent(wdsOwnFleet);
    StringField5.Name := 'StringField5';
    StringField5.FieldName := 'LoadsNRName';
    IntegerField6.SetParentComponent(wdsOwnFleet);
    IntegerField6.Name := 'IntegerField6';
    IntegerField6.FieldName := 'LoadsPos';
    IntegerField7.SetParentComponent(wdsOwnFleet);
    IntegerField7.Name := 'IntegerField7';
    IntegerField7.FieldName := 'LoadsIPos';
    IntegerField8.SetParentComponent(wdsOwnFleet);
    IntegerField8.Name := 'IntegerField8';
    IntegerField8.FieldName := 'LoadsINRPos';
    IntegerField9.SetParentComponent(wdsOwnFleet);
    IntegerField9.Name := 'IntegerField9';
    IntegerField9.FieldName := 'LoadsNIPos';
    IntegerField10.SetParentComponent(wdsOwnFleet);
    IntegerField10.Name := 'IntegerField10';
    IntegerField10.FieldName := 'LoadsNRPos';
    dsOwnFleet.SetParentComponent(Self);
    dsOwnFleet.Name := 'dsOwnFleet';
    dsOwnFleet.AutoEdit := False;
    dsOwnFleet.DataSet := wdsOwnFleet;
    dsOwnFleet.Left := 416;
    dsOwnFleet.Top := 505;
    wcSubsFleet.SetParentComponent(Self);
    wcSubsFleet.Name := 'wcSubsFleet';
    wcSubsFleet.Connection := dmData.dbConnect;
    wcSubsFleet.Left := 296;
    wcSubsFleet.Top := 865;
    wdsSubsFleet.SetParentComponent(Self);
    wdsSubsFleet.Name := 'wdsSubsFleet';
    wdsSubsFleet.AfterOpen := wdsSubsFleetAfterOpen;
    wdsSubsFleet.Connection := dmData.dbConnect;
    wdsSubsFleet.Left := 296;
    wdsSubsFleet.Top := 945;
    IntegerField11.SetParentComponent(wdsSubsFleet);
    IntegerField11.Name := 'IntegerField11';
    IntegerField11.FieldName := 'LoadsC';
    FloatField6.SetParentComponent(wdsSubsFleet);
    FloatField6.Name := 'FloatField6';
    FloatField6.FieldName := 'LoadsR';
    IntegerField12.SetParentComponent(wdsSubsFleet);
    IntegerField12.Name := 'IntegerField12';
    IntegerField12.FieldName := 'LoadsIC';
    FloatField7.SetParentComponent(wdsSubsFleet);
    FloatField7.Name := 'FloatField7';
    FloatField7.FieldName := 'LoadsIR';
    IntegerField13.SetParentComponent(wdsSubsFleet);
    IntegerField13.Name := 'IntegerField13';
    IntegerField13.FieldName := 'LoadsINRC';
    FloatField8.SetParentComponent(wdsSubsFleet);
    FloatField8.Name := 'FloatField8';
    FloatField8.FieldName := 'LoadsINRR';
    IntegerField14.SetParentComponent(wdsSubsFleet);
    IntegerField14.Name := 'IntegerField14';
    IntegerField14.FieldName := 'LoadsNIC';
    FloatField9.SetParentComponent(wdsSubsFleet);
    FloatField9.Name := 'FloatField9';
    FloatField9.FieldName := 'LoadsNIR';
    IntegerField15.SetParentComponent(wdsSubsFleet);
    IntegerField15.Name := 'IntegerField15';
    IntegerField15.FieldName := 'LoadsNRC';
    FloatField10.SetParentComponent(wdsSubsFleet);
    FloatField10.Name := 'FloatField10';
    FloatField10.FieldName := 'LoadsNRR';
    StringField6.SetParentComponent(wdsSubsFleet);
    StringField6.Name := 'StringField6';
    StringField6.FieldName := 'LoadsName';
    StringField7.SetParentComponent(wdsSubsFleet);
    StringField7.Name := 'StringField7';
    StringField7.FieldName := 'LoadsIName';
    StringField8.SetParentComponent(wdsSubsFleet);
    StringField8.Name := 'StringField8';
    StringField8.FieldName := 'LoadsINRName';
    StringField9.SetParentComponent(wdsSubsFleet);
    StringField9.Name := 'StringField9';
    StringField9.FieldName := 'LoadsNIName';
    StringField10.SetParentComponent(wdsSubsFleet);
    StringField10.Name := 'StringField10';
    StringField10.FieldName := 'LoadsNRName';
    IntegerField16.SetParentComponent(wdsSubsFleet);
    IntegerField16.Name := 'IntegerField16';
    IntegerField16.FieldName := 'LoadsPos';
    IntegerField17.SetParentComponent(wdsSubsFleet);
    IntegerField17.Name := 'IntegerField17';
    IntegerField17.FieldName := 'LoadsIPos';
    IntegerField18.SetParentComponent(wdsSubsFleet);
    IntegerField18.Name := 'IntegerField18';
    IntegerField18.FieldName := 'LoadsINRPos';
    IntegerField19.SetParentComponent(wdsSubsFleet);
    IntegerField19.Name := 'IntegerField19';
    IntegerField19.FieldName := 'LoadsNIPos';
    IntegerField20.SetParentComponent(wdsSubsFleet);
    IntegerField20.Name := 'IntegerField20';
    IntegerField20.FieldName := 'LoadsNRPos';
    dsSubsFleet.SetParentComponent(Self);
    dsSubsFleet.Name := 'dsSubsFleet';
    dsSubsFleet.AutoEdit := False;
    dsSubsFleet.DataSet := wdsSubsFleet;
    dsSubsFleet.Left := 392;
    dsSubsFleet.Top := 945;
    WebTimer1.SetParentComponent(Self);
    WebTimer1.Name := 'WebTimer1';
    WebTimer1.Enabled := False;
    WebTimer1.Interval := 300000;
    SetEvent(WebTimer1, Self, 'OnTimer', 'WebTimer1Timer');
    WebTimer1.Left := 536;
    WebTimer1.Top := 169;
  finally
    wpTop.AfterLoadDFMValues;
    WebScrollBox1.AfterLoadDFMValues;
    wpMainCompany.AfterLoadDFMValues;
    wpCompanyCount.AfterLoadDFMValues;
    cCompanyCount.AfterLoadDFMValues;
    wpCompanyRevenue.AfterLoadDFMValues;
    cCompanyRevenue.AfterLoadDFMValues;
    wpOwnFleet.AfterLoadDFMValues;
    wpOwnFleetInfo.AfterLoadDFMValues;
    wpOwnFleetButtons.AfterLoadDFMValues;
    TMSFNCButton1.AfterLoadDFMValues;
    TMSFNCButton3.AfterLoadDFMValues;
    wpOwnFleetCount.AfterLoadDFMValues;
    cOwnFleetCount.AfterLoadDFMValues;
    wpOwnFleetRevenue.AfterLoadDFMValues;
    cOwnFleetRevenue.AfterLoadDFMValues;
    wpSubsFleet.AfterLoadDFMValues;
    wpSubsFleetInfo.AfterLoadDFMValues;
    wpSubsFleetButtons.AfterLoadDFMValues;
    TMSFNCButton2.AfterLoadDFMValues;
    wpSubsFleetCount.AfterLoadDFMValues;
    cSubsFleetCount.AfterLoadDFMValues;
    wpSubsFleetRevenue.AfterLoadDFMValues;
    cSubsFleetRevenue.AfterLoadDFMValues;
    wpDate.AfterLoadDFMValues;
    wlMonth.AfterLoadDFMValues;
    btnPrevMonth.AfterLoadDFMValues;
    btnNextMonth.AfterLoadDFMValues;
    wcCompany.AfterLoadDFMValues;
    wdsCompany.AfterLoadDFMValues;
    wdsCompanyLoadsC.AfterLoadDFMValues;
    wdsCompanyLoadsR.AfterLoadDFMValues;
    wdsCompanyLoadsIC.AfterLoadDFMValues;
    wdsCompanyLoadsIR.AfterLoadDFMValues;
    wdsCompanyLoadsINRC.AfterLoadDFMValues;
    wdsCompanyLoadsINRR.AfterLoadDFMValues;
    wdsCompanyLoadsNIC.AfterLoadDFMValues;
    wdsCompanyLoadsNIR.AfterLoadDFMValues;
    wdsCompanyLoadsNRC.AfterLoadDFMValues;
    wdsCompanyLoadsNRR.AfterLoadDFMValues;
    wdsCompanyLoadsName.AfterLoadDFMValues;
    wdsCompanyLoadsIName.AfterLoadDFMValues;
    wdsCompanyLoadsINRName.AfterLoadDFMValues;
    wdsCompanyLoadsNIName.AfterLoadDFMValues;
    wdsCompanyLoadsNRName.AfterLoadDFMValues;
    wdsCompanyLoadsPos.AfterLoadDFMValues;
    wdsCompanyLoadsIPos.AfterLoadDFMValues;
    wdsCompanyLoadsINRPos.AfterLoadDFMValues;
    wdsCompanyLoadsNIPos.AfterLoadDFMValues;
    wdsCompanyLoadsNRPos.AfterLoadDFMValues;
    dsCompany.AfterLoadDFMValues;
    wcOwnFleet.AfterLoadDFMValues;
    wdsOwnFleet.AfterLoadDFMValues;
    IntegerField1.AfterLoadDFMValues;
    FloatField1.AfterLoadDFMValues;
    IntegerField2.AfterLoadDFMValues;
    FloatField2.AfterLoadDFMValues;
    IntegerField3.AfterLoadDFMValues;
    FloatField3.AfterLoadDFMValues;
    IntegerField4.AfterLoadDFMValues;
    FloatField4.AfterLoadDFMValues;
    IntegerField5.AfterLoadDFMValues;
    FloatField5.AfterLoadDFMValues;
    StringField1.AfterLoadDFMValues;
    StringField2.AfterLoadDFMValues;
    StringField3.AfterLoadDFMValues;
    StringField4.AfterLoadDFMValues;
    StringField5.AfterLoadDFMValues;
    IntegerField6.AfterLoadDFMValues;
    IntegerField7.AfterLoadDFMValues;
    IntegerField8.AfterLoadDFMValues;
    IntegerField9.AfterLoadDFMValues;
    IntegerField10.AfterLoadDFMValues;
    dsOwnFleet.AfterLoadDFMValues;
    wcSubsFleet.AfterLoadDFMValues;
    wdsSubsFleet.AfterLoadDFMValues;
    IntegerField11.AfterLoadDFMValues;
    FloatField6.AfterLoadDFMValues;
    IntegerField12.AfterLoadDFMValues;
    FloatField7.AfterLoadDFMValues;
    IntegerField13.AfterLoadDFMValues;
    FloatField8.AfterLoadDFMValues;
    IntegerField14.AfterLoadDFMValues;
    FloatField9.AfterLoadDFMValues;
    IntegerField15.AfterLoadDFMValues;
    FloatField10.AfterLoadDFMValues;
    StringField6.AfterLoadDFMValues;
    StringField7.AfterLoadDFMValues;
    StringField8.AfterLoadDFMValues;
    StringField9.AfterLoadDFMValues;
    StringField10.AfterLoadDFMValues;
    IntegerField16.AfterLoadDFMValues;
    IntegerField17.AfterLoadDFMValues;
    IntegerField18.AfterLoadDFMValues;
    IntegerField19.AfterLoadDFMValues;
    IntegerField20.AfterLoadDFMValues;
    dsSubsFleet.AfterLoadDFMValues;
    WebTimer1.AfterLoadDFMValues;
  end;
end;

end.